import { Directive, HostBinding, EventEmitter, ElementRef, NgZone, Output, NgModule, Component, Optional, Inject, Input, ɵɵdefineInjectable, Injectable, ComponentFactoryResolver, Injector, TemplateRef, ɵɵinject, INJECTOR, SkipSelf, Self, ViewChild, ContentChildren, InjectionToken, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule, DOCUMENT, Location } from '@angular/common';
import { resizeObserver, executeOnChange, getStyleString, formatBytes, debounce } from 'swire-frontline-ui/common/utils';
import { MAT_SNACK_BAR_DATA, SimpleSnackBar, MatSnackBarContainer, MatSnackBarConfig, MatSnackBarRef, MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { OverlayContainer, Overlay, ScrollStrategyOptions, OverlayPositionBuilder, OverlayKeyboardDispatcher, OverlayOutsideClickDispatcher, OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import { ComponentPortal, TemplatePortal } from '@angular/cdk/portal';
import { takeUntil, map, filter, startWith, switchMap } from 'rxjs/operators';
import { Directionality } from '@angular/cdk/bidi';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DEFAULT_OPTIONS, MAT_DIALOG_SCROLL_STRATEGY, MatDialogModule } from '@angular/material/dialog';
import { BehaviorSubject, of, combineLatest } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FormControl } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/progress-spinner';
import * as ɵngcc3 from '@angular/material/icon';
import * as ɵngcc4 from '@angular/cdk/overlay';
import * as ɵngcc5 from '@angular/cdk/bidi';
import * as ɵngcc6 from '@angular/cdk/a11y';
import * as ɵngcc7 from '@angular/cdk/layout';
import * as ɵngcc8 from '@angular/material/snack-bar';
import * as ɵngcc9 from '@angular/material/dialog';
import * as ɵngcc10 from '@angular/material/button';
import * as ɵngcc11 from 'ng2-pdf-viewer';
import * as ɵngcc12 from '@angular/material/tooltip';

function Snackbar_mat_spinner_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-spinner", 4);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("diameter", 24);
} }
function Snackbar_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵlistener("click", function Snackbar_div_4_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onDismissClick(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 6);
    ɵngcc0.ɵɵtext(2, "close");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = ["dialogTemplate"];
function Dialog_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵprojection(2, 1);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleMap(ctx_r1._getDialogStyles());
    ɵngcc0.ɵɵclassMap(ctx_r1.dialogClass);
} }
const _c1 = [[["sfui-dialog-header"]], [["sfui-dialog-content"]], [["sfui-dialog-footer"]]];
const _c2 = ["sfui-dialog-header", "sfui-dialog-content", "sfui-dialog-footer"];
const _c3 = ["*"];
function Button_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵelementEnd();
} }
const _c4 = ["*", [["", "sfuiButtonIcon", ""]]];
const _c5 = ["*", "[sfuiButtonIcon]"];
function CardHeader_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("background-image", ctx_r0.iconBackgroundUrl);
} }
const _c6 = ["*", [["", "sfuiSuffix", ""]]];
const _c7 = ["*", "[sfuiSuffix]"];
function Card_sfui_card_header_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "sfui-card-header", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("iconUrl", ctx_r0.iconUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.title, "\n");
} }
const _c8 = ["sfui-svg-icon--close", ""];
const _c9 = ["sfui-svg-icon--download", ""];
const _c10 = ["sfui-svg-icon--arrow", ""];
const _c11 = ["sfui-svg-icon--refresh", ""];
const _c12 = ["sfui-svg-icon--tick", ""];
const _c13 = ["sfui-svg-icon--attachment-default", ""];
const _c14 = ["sfui-svg-icon--attachment-doc", ""];
const _c15 = ["sfui-svg-icon--attachment-image", ""];
const _c16 = ["sfui-svg-icon--attachment-pdf", ""];
const _c17 = ["sfui-svg-icon--zoom-in", ""];
const _c18 = ["sfui-svg-icon--zoom-out", ""];
const _c19 = ["sfui-svg-icon--undo", ""];
const _c20 = ["sfui-svg-icon--add-text", ""];
const _c21 = ["sfui-svg-icon--rotate", ""];
const _c22 = ["sfui-svg-icon--brush", ""];
const _c23 = ["sfui-svg-icon--check", ""];
const _c24 = ["sfui-svg-icon--remove", ""];
const _c25 = ["sfui-svg-icon--edit", ""];
const _c26 = [[["sfui-user-item-avatar"]], [["sfui-user-item-name"]], [["sfui-user-item-description"]], [["sfui-user-item-content"]], [["", "sfuiSuffix", ""]]];
const _c27 = ["sfui-user-item-avatar", "sfui-user-item-name", "sfui-user-item-description", "sfui-user-item-content", "[sfuiSuffix]"];
const _c28 = "*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-user-item{display:block;--sfui-user-item-avatar-background:var(--sfui-theme-color-800,#a77332)}  .sfui-user-item,   .sfui-user-item *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-user-item.material-icons,   .sfui-user-item .material-icons{font-family:Material Icons}  .sfui-user-item.material-icons-outlined,   .sfui-user-item .material-icons-outlined{font-family:Material Icons Outlined}  .sfui-user-item__container{display:flex;flex-direction:row;justify-content:space-between}  .sfui-user-item__content-container{display:flex}  .sfui-user-item__content{display:block;flex:1 1 0px}  .sfui-user-item__suffix{display:flex}  .sfui-user-item-avatar{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:16px;line-height:24px;letter-spacing:.15px;width:40px;height:40px;display:inline-flex;justify-content:center;align-items:center;background-color:var(--sfui-user-item-avatar-background,#a77332);border-radius:50%;color:#fff}  .sfui-user-item-avatar+.sfui-user-item__content{padding-left:16px}  .sfui-user-item-name{font-weight:550;font-size:14px;line-height:24px;letter-spacing:.1px;color:rgba(0,0,0,.87)}  .sfui-user-item-description,   .sfui-user-item-name{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal}  .sfui-user-item-description{display:block;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;text-align:left;color:rgba(0,0,0,.6)}";
const _c29 = ["pdfScale"];
function AttachmentPreviewModalCustomPreviewComponent_ng_template_0_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c30 = function (a0) { return { $implicit: a0 }; };
function AttachmentPreviewModalCustomPreviewComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AttachmentPreviewModalCustomPreviewComponent_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.preview.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c30, ctx_r0.item));
} }
function LineGraph__svg_svg_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const xlabel_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const layout_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("left", ctx_r2.xAxisSpacing * i_r9 + layout_r1.paddingLeft, "px")("width", ctx_r2.xAxisSpacing, "px")("margin-left", -ctx_r2.xAxisSpacing / 2, "px");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", xlabel_r8, " ");
} }
function LineGraph__svg_svg_0_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ylabel_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    const layout_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("top", ctx_r3.yAxisSpacing * i_r12 + layout_r1.paddingTop - 8, "px")("width", layout_r1.paddingLeft, "px");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ylabel_r11, " ");
} }
function LineGraph__svg_svg_0__svg_ng_container_9__svg_polyline_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "polyline", 14);
} if (rf & 2) {
    const item_r17 = ctx.$implicit;
    ɵngcc0.ɵɵstyleProp("--sfui-line-graph-color", item_r17.color);
    ɵngcc0.ɵɵattribute("points", item_r17.polylinePoints);
} }
function LineGraph__svg_svg_0__svg_ng_container_9__svg_path_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "path", 15);
} if (rf & 2) {
    const item_r18 = ctx.$implicit;
    ɵngcc0.ɵɵstyleProp("--sfui-line-graph-color", item_r18.color);
    ɵngcc0.ɵɵattribute("d", item_r18.pathD);
} }
function LineGraph__svg_svg_0__svg_ng_container_9_div_4_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17, 18);
    ɵngcc0.ɵɵlistener("click", function LineGraph__svg_svg_0__svg_ng_container_9_div_4_ng_container_1_div_1_Template_div_click_0_listener($event) { const hintPoint_r22 = ctx.$implicit; const i_r23 = ctx.index; return hintPoint_r22.onClick && hintPoint_r22.onClick($event, i_r23); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hintPoint_r22 = ctx.$implicit;
    const item_r19 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵstyleProp("top", hintPoint_r22.y - 6, "px")("left", hintPoint_r22.x - 6, "px")("--sfui-line-graph-color", item_r19.color);
    ɵngcc0.ɵɵproperty("matTooltip", hintPoint_r22.hint)("matTooltipPosition", ctx_r21.tooltipPosition.value);
} }
function LineGraph__svg_svg_0__svg_ng_container_9_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, LineGraph__svg_svg_0__svg_ng_container_9_div_4_ng_container_1_div_1_Template, 2, 8, "div", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r19 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r19.hintPoints);
} }
function LineGraph__svg_svg_0__svg_ng_container_9_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, LineGraph__svg_svg_0__svg_ng_container_9_div_4_ng_container_1_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r19 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r19.hintPoints.length > 0);
} }
function LineGraph__svg_svg_0__svg_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, LineGraph__svg_svg_0__svg_ng_container_9__svg_polyline_1_Template, 1, 3, "polyline", 11);
    ɵngcc0.ɵɵtemplate(2, LineGraph__svg_svg_0__svg_ng_container_9__svg_path_2_Template, 1, 3, "path", 12);
    ɵngcc0.ɵɵelementStart(3, "foreignObject");
    ɵngcc0.ɵɵtemplate(4, LineGraph__svg_svg_0__svg_ng_container_9_div_4_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const layout_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.lineGraphDataList);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.lineGraphDataList);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("x", 0)("y", 0)("width", layout_r1.width)("height", layout_r1.height);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.lineGraphDataList);
} }
function LineGraph__svg_svg_0__svg_ng_container_10__svg_foreignObject_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(0, "div", 17, 18);
    ɵngcc0.ɵɵlistener("click", function LineGraph__svg_svg_0__svg_ng_container_10__svg_foreignObject_3_div_1_Template_div_click_0_listener($event) { const hintPoint_r31 = ctx.$implicit; const i_r32 = ctx.index; return hintPoint_r31.onClick && hintPoint_r31.onClick($event, i_r32); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hintPoint_r31 = ctx.$implicit;
    const ctx_r30 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵstyleProp("top", hintPoint_r31.y - 6, "px")("left", hintPoint_r31.x - 6, "px");
    ɵngcc0.ɵɵproperty("matTooltip", hintPoint_r31.hint)("matTooltipPosition", ctx_r30.tooltipPosition.value);
} }
function LineGraph__svg_svg_0__svg_ng_container_10__svg_foreignObject_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "foreignObject");
    ɵngcc0.ɵɵtemplate(1, LineGraph__svg_svg_0__svg_ng_container_10__svg_foreignObject_3_div_1_Template, 2, 6, "div", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layout_r1 = ɵngcc0.ɵɵnextContext(2).ngIf;
    const ctx_r29 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("x", 0)("y", 0)("width", layout_r1.width)("height", layout_r1.height);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r29.hintPoints);
} }
function LineGraph__svg_svg_0__svg_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "polyline", 14);
    ɵngcc0.ɵɵelement(2, "path", 15);
    ɵngcc0.ɵɵtemplate(3, LineGraph__svg_svg_0__svg_ng_container_10__svg_foreignObject_3_Template, 2, 5, "foreignObject", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("points", ctx_r5.polylinePoints);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("d", ctx_r5.pathD);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.hintPoints.length > 0);
} }
function LineGraph__svg_svg_0__svg_path_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "path", 20);
} if (rf & 2) {
    const baselinePath_r36 = ctx.ngIf;
    ɵngcc0.ɵɵattribute("d", baselinePath_r36);
} }
function LineGraph__svg_svg_0__svg_g_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "g");
    ɵngcc0.ɵɵelementStart(1, "foreignObject");
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(2, "div", 21);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layout_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("x", layout_r1.paddingLeft)("y", 0)("width", layout_r1.width - layout_r1.paddingLeft - layout_r1.paddingRight)("height", layout_r1.height - layout_r1.paddingBottom);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.emptyText, " ");
} }
function LineGraph__svg_svg_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 1);
    ɵngcc0.ɵɵelementStart(1, "g");
    ɵngcc0.ɵɵelementStart(2, "foreignObject");
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(3, "div", 2);
    ɵngcc0.ɵɵtemplate(4, LineGraph__svg_svg_0_div_4_Template, 2, 7, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(5, "g");
    ɵngcc0.ɵɵelementStart(6, "foreignObject", 4);
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(7, "div", 5);
    ɵngcc0.ɵɵtemplate(8, LineGraph__svg_svg_0_div_8_Template, 2, 5, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, LineGraph__svg_svg_0__svg_ng_container_9_Template, 5, 7, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(10, LineGraph__svg_svg_0__svg_ng_container_10_Template, 4, 3, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(11, LineGraph__svg_svg_0__svg_path_11_Template, 1, 1, "path", 8);
    ɵngcc0.ɵɵpipe(12, "async");
    ɵngcc0.ɵɵtemplate(13, LineGraph__svg_svg_0__svg_g_13_Template, 4, 5, "g", 7);
    ɵngcc0.ɵɵpipe(14, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layout_r1 = ctx.ngIf;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("height", layout_r1.height)("width", layout_r1.width);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("x", 0)("y", layout_r1.height - layout_r1.paddingBottom)("width", layout_r1.width)("height", layout_r1.paddingBottom);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.xAxisLabels);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("width", layout_r1.paddingLeft)("height", layout_r1.height);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.yAxisLabels.slice().reverse());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isLineGraphData);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isLineGraphData);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(12, 14, ctx_r0.baselinePath$));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(14, 16, ctx_r0.isEmpty$));
} }
function DoughnutChart_div_3_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const d_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" (", d_r2.percentage, "%) ");
} }
function DoughnutChart_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("click", function DoughnutChart_div_3_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const d_r2 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onSummaryClick(d_r2); })("mouseenter", function DoughnutChart_div_3_div_1_Template_div_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const i_r3 = ctx.index; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.summaryMouseenter(i_r3); })("mouseleave", function DoughnutChart_div_3_div_1_Template_div_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.summaryMouseleave(); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelement(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DoughnutChart_div_3_div_1_div_9_Template, 2, 1, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const d_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("--sfui-dought-chart-summary-item-color", d_r2.color);
    ɵngcc0.ɵɵclassProp("sfui-doughnut-chart__summary-item--empty", d_r2.value <= 0)("sfui-doughnut-chart__summary-item--hover", ɵngcc0.ɵɵpipeBind1(1, 13, ctx_r1.hoverItemIndex$) != null)("sfui-doughnut-chart__summary-item--hover-active", i_r3 === ɵngcc0.ɵɵpipeBind1(2, 15, ctx_r1.hoverItemIndex$));
    ɵngcc0.ɵɵproperty("isTooltipDisplaying", i_r3 === ɵngcc0.ɵɵpipeBind1(3, 17, ctx_r1.hoverItemIndex$) && ctx_r1.hasHint(d_r2))("tooltipHintText", d_r2.hint || "");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(d_r2.label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(d_r2.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", d_r2.percentage != null);
} }
function DoughnutChart_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, DoughnutChart_div_3_div_1_Template, 10, 19, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.data);
} }
function DoughnutChartGraph__svg_circle_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "circle", 4);
    ɵngcc0.ɵɵlistener("mouseenter", function DoughnutChartGraph__svg_circle_2_Template__svg_circle_mouseenter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const i_r2 = ctx.index; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onMouseenter($event, i_r2); })("mouseleave", function DoughnutChartGraph__svg_circle_2_Template__svg_circle_mouseleave_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onMouseleave($event); })("click", function DoughnutChartGraph__svg_circle_2_Template__svg_circle_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const i_r2 = ctx.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onClick(i_r2); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("r", ctx_r0.radius)("opacity", ctx_r0.isEmpty || ctx_r0.hoverItemIndex === null || ctx_r0.hoverItemIndex === i_r2 ? 1 : 0.4)("stroke", data_r1.color)("stroke-width", ctx_r0.strokeWidth)("stroke-dasharray", data_r1.dasharray)("transform", data_r1.transform);
} }
class SfuiSuffix {
    constructor() {
        this.hostClass = ['sfui-suffix'];
    }
}
SfuiSuffix.ɵfac = function SfuiSuffix_Factory(t) { return new (t || SfuiSuffix)(); };
SfuiSuffix.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SfuiSuffix, selectors: [["", "sfuiSuffix", ""]], hostVars: 2, hostBindings: function SfuiSuffix_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } } });
SfuiSuffix.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiSuffix, [{
        type: Directive,
        args: [{
                selector: '[sfuiSuffix]'
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class SfuiResizeObserver {
    constructor(elRef, ngZone) {
        this.elRef = elRef;
        this.ngZone = ngZone;
        this.hostClass = ['sfui-resize-observer'];
        this.sfuiResize = new EventEmitter();
    }
    ngOnInit() {
        this.subscribe = resizeObserver(this.elRef.nativeElement, this.ngZone).subscribe(() => {
            this.handleResize();
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this.subscribe) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    handleResize() {
        this.sfuiResize.emit();
    }
}
SfuiResizeObserver.ɵfac = function SfuiResizeObserver_Factory(t) { return new (t || SfuiResizeObserver)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SfuiResizeObserver.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SfuiResizeObserver, selectors: [["", "sfuiResizeObserver", ""]], hostVars: 2, hostBindings: function SfuiResizeObserver_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, outputs: { sfuiResize: "sfuiResize" } });
SfuiResizeObserver.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
SfuiResizeObserver.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    sfuiResize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiResizeObserver, [{
        type: Directive,
        args: [{
                selector: '[sfuiResizeObserver]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], sfuiResize: [{
            type: Output
        }] }); })();

class SfuiButtonIcon {
    constructor() {
        this.hostClass = ['sfui-button-icon'];
    }
}
SfuiButtonIcon.ɵfac = function SfuiButtonIcon_Factory(t) { return new (t || SfuiButtonIcon)(); };
SfuiButtonIcon.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SfuiButtonIcon, selectors: [["", "sfuiButtonIcon", ""]], hostVars: 2, hostBindings: function SfuiButtonIcon_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } } });
SfuiButtonIcon.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiButtonIcon, [{
        type: Directive,
        args: [{
                selector: '[sfuiButtonIcon]'
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class SfuiCommonDirectivesModule {
}
SfuiCommonDirectivesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiCommonDirectivesModule });
SfuiCommonDirectivesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiCommonDirectivesModule_Factory(t) { return new (t || SfuiCommonDirectivesModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiCommonDirectivesModule, { declarations: function () { return [SfuiSuffix, SfuiResizeObserver, SfuiButtonIcon]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SfuiSuffix, SfuiResizeObserver, SfuiButtonIcon]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiCommonDirectivesModule, [{
        type: NgModule,
        args: [{
                declarations: [SfuiSuffix, SfuiResizeObserver, SfuiButtonIcon],
                imports: [CommonModule],
                exports: [SfuiSuffix, SfuiResizeObserver, SfuiButtonIcon]
            }]
    }], null, null); })();

class Snackbar {
    constructor(data) {
        var _a, _b;
        this.type = 'success';
        this.message = '';
        this.dismissible = false;
        this.dismiss = () => { };
        if (data) {
            this.type = data.type;
            this.message = (_a = data.message) !== null && _a !== void 0 ? _a : '';
            this.dismissible = (_b = data.dismissible) !== null && _b !== void 0 ? _b : false;
            if (data.dismiss) {
                this.dismiss = data.dismiss;
            }
        }
    }
    get hostClass() {
        return {
            'sfui-snackbar': true,
            'sfui-snackbar--dismissible': this.dismissible,
        };
    }
    onDismissClick() {
        this.dismiss();
    }
}
Snackbar.ɵfac = function Snackbar_Factory(t) { return new (t || Snackbar)(ɵngcc0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA, 8)); };
Snackbar.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Snackbar, selectors: [["sfui-snackbar"]], hostVars: 2, hostBindings: function Snackbar_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { type: "type", message: "message", dismissible: "dismissible" }, decls: 5, vars: 13, consts: [[1, "sfui-snackbar-icon"], [3, "diameter", 4, "ngIf"], [1, "sfui-snackbar-message"], [3, "click", 4, "ngIf"], [3, "diameter"], [3, "click"], [1, "sfui-snackbar-dismissible"]], template: function Snackbar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, Snackbar_mat_spinner_1_Template, 1, 1, "mat-spinner", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, Snackbar_div_4_Template, 3, 0, "div", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("type-success", ctx.type === "success")("type-failed", ctx.type === "failed")("type-warning", ctx.type === "warning")("type-loading", ctx.type === "loading");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "loading");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("sfui-snackbar-message--dismissible", ctx.dismissible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.message, "\n");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dismissible);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.MatSpinner, ɵngcc3.MatIcon], styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-snackbar{position:relative;display:block;min-width:344px;min-height:48px;padding:14px 16px 14px 56px;overflow:hidden;background:rgba(0,0,0,.87);border-radius:4px;box-shadow:0 6px 10px rgba(0,0,0,.14),0 1px 18px rgba(0,0,0,.12),0 3px 5px rgba(0,0,0,.2)}  .sfui-snackbar,   .sfui-snackbar *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-snackbar.material-icons,   .sfui-snackbar .material-icons{font-family:Material Icons}  .sfui-snackbar.material-icons-outlined,   .sfui-snackbar .material-icons-outlined{font-family:Material Icons Outlined}  .sfui-snackbar,   .sfui-snackbar *{box-sizing:border-box}  .sfui-snackbar--dismissible{padding-left:46px}.mat-snack-bar-handset[_nghost-%COMP%], .mat-snack-bar-handset   [_nghost-%COMP%]{min-width:auto;width:min(calc(100vw - 20px),344px)}  .mat-snack-bar-container.sfui-snackbar-container.sfui-snackbar-container{pointer-events:auto;background:none;box-shadow:none;padding:0;box-sizing:border-box;display:block;margin:20px;margin-top:calc(20px + var(--sfui-snackbar-y-offset, 0px));margin-bottom:calc(34px + var(--sfui-snackbar-y-offset, 0px));max-width:none;min-width:auto;min-height:auto}@supports (margin-top:calc(calc(max(env(safe-area-inset-top,0px),20px) - 20px) + 20px)){  .mat-snack-bar-container.sfui-snackbar-container.sfui-snackbar-container{margin-top:calc(calc(calc(max(env(safe-area-inset-top, 0px), 20px) - 20px) + 20px) + var(--sfui-snackbar-y-offset, 0px))}}@supports (margin-bottom:calc(calc(max(env(safe-area-inset-bottom,0px),34px) - 34px) + 34px)){  .mat-snack-bar-container.sfui-snackbar-container.sfui-snackbar-container{margin-bottom:calc(calc(calc(max(env(safe-area-inset-bottom, 0px), 34px) - 34px) + 34px) + var(--sfui-snackbar-y-offset, 0px))}}  .cdk-overlay-pane.sfui-snackbar-overlay-panel{pointer-events:none}  .mat-snack-bar-handset .mat-snack-bar-container.sfui-snackbar-container.sfui-snackbar-container{margin-left:auto;margin-right:auto;width:auto}.sfui-snackbar-icon[_ngcontent-%COMP%]{position:absolute;font-size:24px;width:24px;height:24px;top:0;bottom:0;margin-top:auto;margin-bottom:auto;left:16px;background-position:50%;background-repeat:no-repeat;background-size:contain}.sfui-snackbar-icon.type-success[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle cx%3D%2212%22 cy%3D%2212%22 r%3D%2210%22 fill%3D%22white%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z%22 fill%3D%22%23339749%22%2F%3E%3C%2Fsvg%3E\")}.sfui-snackbar-icon.type-warning[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cellipse cx%3D%2212%22 cy%3D%2213.5%22 rx%3D%225%22 ry%3D%226.5%22 fill%3D%22white%22%2F%3E%3Cpath d%3D%22M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z%22 fill%3D%22%23D29C04%22%2F%3E%3C%2Fsvg%3E\")}.sfui-snackbar-icon.type-failed[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle cx%3D%2212%22 cy%3D%2212%22 r%3D%2210%22 fill%3D%22white%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z%22 fill%3D%22%23F03738%22%2F%3E%3C%2Fsvg%3E\")}.sfui-snackbar-icon.type-loading[_ngcontent-%COMP%]     .mat-spinner circle{stroke:#fff}.sfui-snackbar-message[_ngcontent-%COMP%]{font-size:14px;line-height:20px;font-weight:400;text-align:center;margin-right:30px;letter-spacing:.25px;color:#fff;white-space:pre-wrap}.sfui-snackbar-message--dismissible[_ngcontent-%COMP%]{text-align:left}.sfui-snackbar-dismissible[_ngcontent-%COMP%]{color:hsla(0,0%,100%,.74);font-size:24px;width:24px;height:24px;position:absolute;top:0;bottom:0;right:20px;margin-top:auto;margin-bottom:auto;cursor:pointer}"] });
Snackbar.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_SNACK_BAR_DATA,] }] }
];
Snackbar.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    type: [{ type: Input }],
    message: [{ type: Input }],
    dismissible: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Snackbar, [{
        type: Component,
        args: [{
                selector: 'sfui-snackbar',
                template: "<div\n  class=\"sfui-snackbar-icon\"\n  [class.type-success]=\"type === 'success'\"\n  [class.type-failed]=\"type === 'failed'\"\n  [class.type-warning]=\"type === 'warning'\"\n  [class.type-loading]=\"type === 'loading'\"\n>\n  <mat-spinner *ngIf=\"type === 'loading'\" [diameter]=\"24\"></mat-spinner>\n</div>\n<div\n  class=\"sfui-snackbar-message\"\n  [class.sfui-snackbar-message--dismissible]=\"dismissible\"\n>\n  {{ message }}\n</div>\n<div *ngIf=\"dismissible\" (click)=\"onDismissClick()\">\n  <mat-icon class=\"sfui-snackbar-dismissible\">close</mat-icon>\n</div>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-snackbar{position:relative;display:block;min-width:344px;min-height:48px;padding:14px 16px 14px 56px;overflow:hidden;background:rgba(0,0,0,.87);border-radius:4px;box-shadow:0 6px 10px rgba(0,0,0,.14),0 1px 18px rgba(0,0,0,.12),0 3px 5px rgba(0,0,0,.2)}::ng-deep .sfui-snackbar,::ng-deep .sfui-snackbar *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-snackbar.material-icons,::ng-deep .sfui-snackbar .material-icons{font-family:Material Icons}::ng-deep .sfui-snackbar.material-icons-outlined,::ng-deep .sfui-snackbar .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-snackbar,::ng-deep .sfui-snackbar *{box-sizing:border-box}::ng-deep .sfui-snackbar--dismissible{padding-left:46px}:host-context(.mat-snack-bar-handset){min-width:auto;width:min(calc(100vw - 20px),344px)}::ng-deep .mat-snack-bar-container.sfui-snackbar-container.sfui-snackbar-container{pointer-events:auto;background:none;box-shadow:none;padding:0;box-sizing:border-box;display:block;margin:20px;margin-top:calc(20px + var(--sfui-snackbar-y-offset, 0px));margin-bottom:calc(34px + var(--sfui-snackbar-y-offset, 0px));max-width:none;min-width:auto;min-height:auto}@supports (margin-top:calc(calc(max(env(safe-area-inset-top,0px),20px) - 20px) + 20px)){::ng-deep .mat-snack-bar-container.sfui-snackbar-container.sfui-snackbar-container{margin-top:calc(calc(calc(max(env(safe-area-inset-top, 0px), 20px) - 20px) + 20px) + var(--sfui-snackbar-y-offset, 0px))}}@supports (margin-bottom:calc(calc(max(env(safe-area-inset-bottom,0px),34px) - 34px) + 34px)){::ng-deep .mat-snack-bar-container.sfui-snackbar-container.sfui-snackbar-container{margin-bottom:calc(calc(calc(max(env(safe-area-inset-bottom, 0px), 34px) - 34px) + 34px) + var(--sfui-snackbar-y-offset, 0px))}}::ng-deep .cdk-overlay-pane.sfui-snackbar-overlay-panel{pointer-events:none}::ng-deep .mat-snack-bar-handset .mat-snack-bar-container.sfui-snackbar-container.sfui-snackbar-container{margin-left:auto;margin-right:auto;width:auto}.sfui-snackbar-icon{position:absolute;font-size:24px;width:24px;height:24px;top:0;bottom:0;margin-top:auto;margin-bottom:auto;left:16px;background-position:50%;background-repeat:no-repeat;background-size:contain}.sfui-snackbar-icon.type-success{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle cx%3D%2212%22 cy%3D%2212%22 r%3D%2210%22 fill%3D%22white%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z%22 fill%3D%22%23339749%22%2F%3E%3C%2Fsvg%3E\")}.sfui-snackbar-icon.type-warning{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cellipse cx%3D%2212%22 cy%3D%2213.5%22 rx%3D%225%22 ry%3D%226.5%22 fill%3D%22white%22%2F%3E%3Cpath d%3D%22M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z%22 fill%3D%22%23D29C04%22%2F%3E%3C%2Fsvg%3E\")}.sfui-snackbar-icon.type-failed{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle cx%3D%2212%22 cy%3D%2212%22 r%3D%2210%22 fill%3D%22white%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z%22 fill%3D%22%23F03738%22%2F%3E%3C%2Fsvg%3E\")}.sfui-snackbar-icon.type-loading ::ng-deep .mat-spinner circle{stroke:#fff}.sfui-snackbar-message{font-size:14px;line-height:20px;font-weight:400;text-align:center;margin-right:30px;letter-spacing:.25px;color:#fff;white-space:pre-wrap}.sfui-snackbar-message--dismissible{text-align:left}.sfui-snackbar-dismissible{color:hsla(0,0%,100%,.74);font-size:24px;width:24px;height:24px;position:absolute;top:0;bottom:0;right:20px;margin-top:auto;margin-bottom:auto;cursor:pointer}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MAT_SNACK_BAR_DATA]
            }] }]; }, { type: [{
            type: Input
        }], message: [{
            type: Input
        }], dismissible: [{
            type: Input
        }], hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

// Extend from https://github.com/angular/components/blob/master/src/cdk/overlay/overlay-container.ts
class SfuiCdkOverlayContainer extends OverlayContainer {
    constructor() {
        super(...arguments);
        this.hostElement = null;
    }
    saveHostElement(element) {
        this.hostElement = element;
    }
    _createContainer() {
        var _a;
        const element = (_a = this.hostElement) !== null && _a !== void 0 ? _a : document.body;
        const containerClass = 'cdk-overlay-container';
        if (this._platform.isBrowser) {
            const oppositePlatformContainers = this._document.querySelectorAll(`.${containerClass}[platform="server"]`);
            // Remove any old containers from the opposite platform.
            // This can happen when transitioning from the server to the client.
            for (let i = 0; i < oppositePlatformContainers.length; i++) {
                oppositePlatformContainers[i].parentNode.removeChild(oppositePlatformContainers[i]);
            }
        }
        const container = this._document.createElement('div');
        container.classList.add(containerClass);
        container.setAttribute('platform', 'server');
        element.appendChild(container);
        this._containerElement = container;
    }
}
SfuiCdkOverlayContainer.ɵfac = function SfuiCdkOverlayContainer_Factory(t) { return ɵSfuiCdkOverlayContainer_BaseFactory(t || SfuiCdkOverlayContainer); };
SfuiCdkOverlayContainer.ɵprov = ɵɵdefineInjectable({ factory: function SfuiCdkOverlayContainer_Factory() { return new SfuiCdkOverlayContainer(); }, token: SfuiCdkOverlayContainer, providedIn: null });
const ɵSfuiCdkOverlayContainer_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(SfuiCdkOverlayContainer);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiCdkOverlayContainer, [{
        type: Injectable,
        args: [{ providedIn: null }]
    }], null, null); })();

class SfuiCdkOverlay extends Overlay {
    constructor(scrollStrategies, _cdkOverlayContainer, _sfuiOverlayContainer, _componentFactoryResolver, _positionBuilder, _keyboardDispatcher, _injector, _ngZone, _document, _directionality, _location, _outsideClickDispatcher) {
        super(scrollStrategies, _sfuiOverlayContainer !== null && _sfuiOverlayContainer !== void 0 ? _sfuiOverlayContainer : _cdkOverlayContainer, _componentFactoryResolver, _positionBuilder, _keyboardDispatcher, _injector, _ngZone, _document, _directionality, _location, _outsideClickDispatcher);
    }
}
SfuiCdkOverlay.ɵfac = function SfuiCdkOverlay_Factory(t) { return new (t || SfuiCdkOverlay)(ɵngcc0.ɵɵinject(ɵngcc4.ScrollStrategyOptions), ɵngcc0.ɵɵinject(ɵngcc4.OverlayContainer), ɵngcc0.ɵɵinject(SfuiCdkOverlayContainer, 8), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc4.OverlayPositionBuilder), ɵngcc0.ɵɵinject(ɵngcc4.OverlayKeyboardDispatcher), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ɵngcc5.Directionality), ɵngcc0.ɵɵinject(ɵngcc1.Location), ɵngcc0.ɵɵinject(ɵngcc4.OverlayOutsideClickDispatcher)); };
SfuiCdkOverlay.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SfuiCdkOverlay, factory: SfuiCdkOverlay.ɵfac });
SfuiCdkOverlay.ctorParameters = () => [
    { type: ScrollStrategyOptions },
    { type: OverlayContainer },
    { type: SfuiCdkOverlayContainer, decorators: [{ type: Optional }] },
    { type: ComponentFactoryResolver },
    { type: OverlayPositionBuilder },
    { type: OverlayKeyboardDispatcher },
    { type: Injector },
    { type: NgZone },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Directionality },
    { type: Location },
    { type: OverlayOutsideClickDispatcher }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiCdkOverlay, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.ScrollStrategyOptions }, { type: ɵngcc4.OverlayContainer }, { type: SfuiCdkOverlayContainer, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc4.OverlayPositionBuilder }, { type: ɵngcc4.OverlayKeyboardDispatcher }, { type: ɵngcc0.Injector }, { type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc5.Directionality }, { type: ɵngcc1.Location }, { type: ɵngcc4.OverlayOutsideClickDispatcher }]; }, null); })();

// Ref: https://github.com/angular/components/blob/master/src/material/snack-bar/snack-bar.ts
/**
 * Service to dispatch Material Design snack bar messages.
 */
class InternalMatSnackBar {
    constructor(_overlay, _live, _injector, _breakpointObserver, _parentSnackBar, _defaultConfig) {
        this._overlay = _overlay;
        this._live = _live;
        this._injector = _injector;
        this._breakpointObserver = _breakpointObserver;
        this._parentSnackBar = _parentSnackBar;
        this._defaultConfig = _defaultConfig;
        /**
         * Reference to the current snack bar in the view *at this level* (in the Angular injector tree).
         * If there is a parent snack-bar service, all operations should delegate to that parent
         * via `_openedSnackBarRef`.
         */
        this._snackBarRefAtThisLevel = null;
        /** The component that should be rendered as the snack bar's simple component. */
        this.simpleSnackBarComponent = SimpleSnackBar;
        /** The container component that attaches the provided template or component. */
        this.snackBarContainerComponent = MatSnackBarContainer;
        /** The CSS class to apply for handset mode. */
        this.handsetCssClass = 'mat-snack-bar-handset';
        this.overlayPanelClass = 'sfui-snackbar-overlay-panel';
    }
    /** Reference to the currently opened snackbar at *any* level. */
    get _openedSnackBarRef() {
        const parent = this._parentSnackBar;
        return parent ? parent._openedSnackBarRef : this._snackBarRefAtThisLevel;
    }
    set _openedSnackBarRef(value) {
        if (this._parentSnackBar) {
            this._parentSnackBar._openedSnackBarRef = value;
        }
        else {
            this._snackBarRefAtThisLevel = value;
        }
    }
    openFromComponent(component, config) {
        return this._attach(component, config);
    }
    openFromTemplate(template, config) {
        return this._attach(template, config);
    }
    open(message, action = '', config) {
        const _config = Object.assign(Object.assign({}, this._defaultConfig), config);
        // Since the user doesn't have access to the component, we can
        // override the data to pass in our own message and action.
        _config.data = { message, action };
        // Since the snack bar has `role="alert"`, we don't
        // want to announce the same message twice.
        if (_config.announcementMessage === message) {
            _config.announcementMessage = undefined;
        }
        return this.openFromComponent(this.simpleSnackBarComponent, _config);
    }
    /**
     * Dismisses the currently-visible snack bar.
     */
    dismiss() {
        if (this._openedSnackBarRef) {
            this._openedSnackBarRef.dismiss();
        }
    }
    ngOnDestroy() {
        // Only dismiss the snack bar at the current level on destroy.
        if (this._snackBarRefAtThisLevel) {
            this._snackBarRefAtThisLevel.dismiss();
        }
    }
    /**
     * Attaches the snack bar container component to the overlay.
     */
    _attachSnackBarContainer(overlayRef, config) {
        var _a;
        const userInjector = (_a = config.viewContainerRef) === null || _a === void 0 ? void 0 : _a.injector;
        const injector = Injector.create({
            parent: userInjector !== null && userInjector !== void 0 ? userInjector : this._injector,
            providers: [{ provide: MatSnackBarConfig, useValue: config }],
        });
        const containerPortal = new ComponentPortal(this.snackBarContainerComponent, config.viewContainerRef, injector);
        const containerRef = overlayRef.attach(containerPortal);
        containerRef.instance.snackBarConfig = config;
        return containerRef.instance;
    }
    /**
     * Places a new component or a template as the content of the snack bar container.
     */
    _attach(content, userConfig) {
        const config = Object.assign(Object.assign(Object.assign({}, new MatSnackBarConfig()), this._defaultConfig), userConfig);
        const overlayRef = this._createOverlay(config);
        const container = this._attachSnackBarContainer(overlayRef, config);
        const snackBarRef = new MatSnackBarRef(container, overlayRef);
        if (content instanceof TemplateRef) {
            const portal = new TemplatePortal(content, null, {
                $implicit: config.data,
                snackBarRef,
            });
            snackBarRef.instance = container.attachTemplatePortal(portal);
        }
        else {
            const injector = this._createInjector(config, snackBarRef);
            const portal = new ComponentPortal(content, undefined, injector);
            const contentRef = container.attachComponentPortal(portal);
            // We can't pass this via the injector, because the injector is created earlier.
            snackBarRef.instance = contentRef.instance;
        }
        // Subscribe to the breakpoint observer and attach the mat-snack-bar-handset class as
        // appropriate. This class is applied to the overlay element because the overlay must expand to
        // fill the width of the screen for full width snackbars.
        this._breakpointObserver
            .observe(Breakpoints.HandsetPortrait)
            .pipe(takeUntil(overlayRef.detachments()))
            .subscribe((state) => {
            overlayRef.overlayElement.classList.toggle(this.handsetCssClass, state.matches);
        });
        if (config.announcementMessage) {
            // Wait until the snack bar contents have been announced then deliver this message.
            container._onAnnounce.subscribe(() => {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._live.announce(config.announcementMessage, config.politeness);
            });
        }
        this._animateSnackBar(snackBarRef, config);
        this._openedSnackBarRef = snackBarRef;
        return this._openedSnackBarRef;
    }
    /** Animates the old snack bar out and the new one in. */
    _animateSnackBar(snackBarRef, config) {
        // When the snackbar is dismissed, clear the reference to it.
        snackBarRef.afterDismissed().subscribe(() => {
            // Clear the snackbar ref if it hasn't already been replaced by a newer snackbar.
            if (this._openedSnackBarRef === snackBarRef) {
                this._openedSnackBarRef = null;
            }
            if (config.announcementMessage) {
                this._live.clear();
            }
        });
        if (this._openedSnackBarRef) {
            // If a snack bar is already in view, dismiss it and enter the
            // new snack bar after exit animation is complete.
            this._openedSnackBarRef.afterDismissed().subscribe(() => {
                snackBarRef.containerInstance.enter();
            });
            this._openedSnackBarRef.dismiss();
        }
        else {
            // If no snack bar is in view, enter the new snack bar.
            snackBarRef.containerInstance.enter();
        }
        // If a dismiss timeout is provided, set up dismiss based on after the snackbar is opened.
        if (config.duration && config.duration > 0) {
            snackBarRef
                .afterOpened()
                .subscribe(() => snackBarRef._dismissAfter(config.duration));
        }
    }
    _createOverlay(config) {
        const overlayConfig = new OverlayConfig();
        overlayConfig.direction = config.direction;
        const positionStrategy = this._overlay.position().global();
        // Set horizontal position.
        const isRtl = config.direction === 'rtl';
        const isLeft = config.horizontalPosition === 'left' ||
            (config.horizontalPosition === 'start' && !isRtl) ||
            (config.horizontalPosition === 'end' && isRtl);
        const isRight = !isLeft && config.horizontalPosition !== 'center';
        if (isLeft) {
            positionStrategy.left('0');
        }
        else if (isRight) {
            positionStrategy.right('0');
        }
        else {
            positionStrategy.centerHorizontally();
        }
        // Set horizontal position.
        if (config.verticalPosition === 'top') {
            positionStrategy.top('0');
        }
        else {
            positionStrategy.bottom('0');
        }
        overlayConfig.positionStrategy = positionStrategy;
        overlayConfig.panelClass = this.overlayPanelClass;
        return this._overlay.create(overlayConfig);
    }
    _createInjector(config, snackBarRef) {
        var _a;
        const userInjector = (_a = config.viewContainerRef) === null || _a === void 0 ? void 0 : _a.injector;
        return Injector.create({
            parent: userInjector !== null && userInjector !== void 0 ? userInjector : this._injector,
            providers: [
                { provide: MatSnackBarRef, useValue: snackBarRef },
                { provide: MAT_SNACK_BAR_DATA, useValue: config.data },
            ],
        });
    }
}
InternalMatSnackBar.ɵfac = function InternalMatSnackBar_Factory(t) { return new (t || InternalMatSnackBar)(ɵngcc0.ɵɵinject(SfuiCdkOverlay), ɵngcc0.ɵɵinject(ɵngcc6.LiveAnnouncer), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc7.BreakpointObserver), ɵngcc0.ɵɵinject(InternalMatSnackBar, 12), ɵngcc0.ɵɵinject(MAT_SNACK_BAR_DEFAULT_OPTIONS)); };
InternalMatSnackBar.ɵprov = ɵɵdefineInjectable({ factory: function InternalMatSnackBar_Factory() { return new InternalMatSnackBar(ɵɵinject(SfuiCdkOverlay), ɵɵinject(LiveAnnouncer), ɵɵinject(INJECTOR), ɵɵinject(BreakpointObserver), ɵɵinject(InternalMatSnackBar, 12), ɵɵinject(MAT_SNACK_BAR_DEFAULT_OPTIONS)); }, token: InternalMatSnackBar, providedIn: null });
InternalMatSnackBar.ctorParameters = () => [
    { type: SfuiCdkOverlay },
    { type: LiveAnnouncer },
    { type: Injector },
    { type: BreakpointObserver },
    { type: InternalMatSnackBar, decorators: [{ type: Optional }, { type: SkipSelf }] },
    { type: MatSnackBarConfig, decorators: [{ type: Inject, args: [MAT_SNACK_BAR_DEFAULT_OPTIONS,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InternalMatSnackBar, [{
        type: Injectable,
        args: [{ providedIn: null }]
    }], function () { return [{ type: SfuiCdkOverlay }, { type: ɵngcc6.LiveAnnouncer }, { type: ɵngcc0.Injector }, { type: ɵngcc7.BreakpointObserver }, { type: InternalMatSnackBar, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }, { type: ɵngcc8.MatSnackBarConfig, decorators: [{
                type: Inject,
                args: [MAT_SNACK_BAR_DEFAULT_OPTIONS]
            }] }]; }, null); })();

const DEFAULT_DISPLAY_OPTIONS = {
    duration: 3000,
    horizontalPosition: 'center',
    verticalPosition: 'top',
};
function composeDisplayOptions(displayOptions) {
    const panelClass = ['sfui-snackbar-container'];
    let duration;
    let horizontalPosition = DEFAULT_DISPLAY_OPTIONS.horizontalPosition;
    let verticalPosition = DEFAULT_DISPLAY_OPTIONS.verticalPosition;
    if (displayOptions.containerClass) {
        panelClass.push(displayOptions.containerClass);
    }
    if (displayOptions.horizontalPosition !== undefined) {
        horizontalPosition = displayOptions.horizontalPosition;
    }
    if (displayOptions.verticalPosition !== undefined) {
        verticalPosition = displayOptions.verticalPosition;
    }
    if (displayOptions.duration === undefined) {
        duration = DEFAULT_DISPLAY_OPTIONS.duration;
    }
    else {
        duration = displayOptions.duration;
    }
    return {
        panelClass,
        horizontalPosition,
        verticalPosition,
        duration,
    };
}
class SnackbarService {
    constructor(matSnackBar) {
        this.matSnackBar = matSnackBar;
        this.dismissSnackbar = () => {
            this.matSnackBar.dismiss();
        };
    }
    displaySnackbar(config, displayOptions = {}) {
        const finalDisplayOptions = composeDisplayOptions(displayOptions);
        this.matSnackBar.openFromComponent(Snackbar, Object.assign({ data: Object.assign(Object.assign({}, config), { dismiss: this.dismissSnackbar }) }, finalDisplayOptions));
    }
}
SnackbarService.ɵfac = function SnackbarService_Factory(t) { return new (t || SnackbarService)(ɵngcc0.ɵɵinject(InternalMatSnackBar)); };
SnackbarService.ɵprov = ɵɵdefineInjectable({ factory: function SnackbarService_Factory() { return new SnackbarService(ɵɵinject(InternalMatSnackBar)); }, token: SnackbarService, providedIn: null });
SnackbarService.ctorParameters = () => [
    { type: InternalMatSnackBar }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SnackbarService, [{
        type: Injectable,
        args: [{
                providedIn: null
            }]
    }], function () { return [{ type: InternalMatSnackBar }]; }, null); })();

class SfuiCdkDialog extends MatDialog {
    constructor(overlay, _sfuiOverlay, injector, location, defaultOptions, scrollStrategy, parentDialog, overlayContainer, _sfuiOverlayContainer) {
        super(_sfuiOverlay !== null && _sfuiOverlay !== void 0 ? _sfuiOverlay : overlay, injector, location, defaultOptions, scrollStrategy, parentDialog, _sfuiOverlayContainer !== null && _sfuiOverlayContainer !== void 0 ? _sfuiOverlayContainer : overlayContainer);
    }
}
SfuiCdkDialog.ɵfac = function SfuiCdkDialog_Factory(t) { return new (t || SfuiCdkDialog)(ɵngcc0.ɵɵinject(ɵngcc4.Overlay), ɵngcc0.ɵɵinject(SfuiCdkOverlay, 8), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc1.Location, 8), ɵngcc0.ɵɵinject(MAT_DIALOG_DEFAULT_OPTIONS, 8), ɵngcc0.ɵɵinject(MAT_DIALOG_SCROLL_STRATEGY), ɵngcc0.ɵɵinject(ɵngcc9.MatDialog, 12), ɵngcc0.ɵɵinject(ɵngcc4.OverlayContainer), ɵngcc0.ɵɵinject(SfuiCdkOverlayContainer, 8)); };
SfuiCdkDialog.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SfuiCdkDialog, factory: SfuiCdkDialog.ɵfac });
SfuiCdkDialog.ctorParameters = () => [
    { type: Overlay },
    { type: SfuiCdkOverlay, decorators: [{ type: Optional }] },
    { type: Injector },
    { type: Location, decorators: [{ type: Optional }] },
    { type: MatDialogConfig, decorators: [{ type: Optional }, { type: Inject, args: [MAT_DIALOG_DEFAULT_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_SCROLL_STRATEGY,] }] },
    { type: MatDialog, decorators: [{ type: Optional }, { type: SkipSelf }] },
    { type: OverlayContainer },
    { type: SfuiCdkOverlayContainer, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiCdkDialog, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.Overlay }, { type: SfuiCdkOverlay, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.Injector }, { type: ɵngcc1.Location, decorators: [{
                type: Optional
            }] }, { type: ɵngcc9.MatDialogConfig, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MAT_DIALOG_DEFAULT_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_SCROLL_STRATEGY]
            }] }, { type: ɵngcc9.MatDialog, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }, { type: ɵngcc4.OverlayContainer }, { type: SfuiCdkOverlayContainer, decorators: [{
                type: Optional
            }] }]; }, null); })();

class SfuiCdkOverlayContainerDirective {
    constructor(elementReference, cdkOverlayContainer) {
        this.elementReference = elementReference;
        cdkOverlayContainer.saveHostElement(this.elementReference.nativeElement);
    }
}
SfuiCdkOverlayContainerDirective.ɵfac = function SfuiCdkOverlayContainerDirective_Factory(t) { return new (t || SfuiCdkOverlayContainerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(SfuiCdkOverlayContainer, 2)); };
SfuiCdkOverlayContainerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SfuiCdkOverlayContainerDirective, selectors: [["", "sfuiCdkOverlayContainer", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: SfuiCdkOverlayContainer,
                useClass: SfuiCdkOverlayContainer
            },
            SfuiCdkOverlay,
            SfuiCdkDialog,
            InternalMatSnackBar,
            SnackbarService,
        ])] });
SfuiCdkOverlayContainerDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: SfuiCdkOverlayContainer, decorators: [{ type: Inject, args: [SfuiCdkOverlayContainer,] }, { type: Self }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiCdkOverlayContainerDirective, [{
        type: Directive,
        args: [{
                selector: '[sfuiCdkOverlayContainer]',
                providers: [
                    {
                        provide: SfuiCdkOverlayContainer,
                        useClass: SfuiCdkOverlayContainer
                    },
                    SfuiCdkOverlay,
                    SfuiCdkDialog,
                    InternalMatSnackBar,
                    SnackbarService,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: SfuiCdkOverlayContainer, decorators: [{
                type: Inject,
                args: [SfuiCdkOverlayContainer]
            }, {
                type: Self
            }] }]; }, null); })();

class SfuiCdkOverlayModule {
}
SfuiCdkOverlayModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiCdkOverlayModule });
SfuiCdkOverlayModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiCdkOverlayModule_Factory(t) { return new (t || SfuiCdkOverlayModule)(); }, providers: [
        SfuiCdkOverlay,
        SfuiCdkDialog,
        InternalMatSnackBar,
        SnackbarService,
    ], imports: [[CommonModule, OverlayModule, MatDialogModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiCdkOverlayModule, { declarations: function () { return [SfuiCdkOverlayContainerDirective]; }, imports: function () { return [CommonModule, OverlayModule, MatDialogModule]; }, exports: function () { return [SfuiCdkOverlayContainerDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiCdkOverlayModule, [{
        type: NgModule,
        args: [{
                declarations: [SfuiCdkOverlayContainerDirective],
                imports: [CommonModule, OverlayModule, MatDialogModule],
                exports: [SfuiCdkOverlayContainerDirective],
                providers: [
                    SfuiCdkOverlay,
                    SfuiCdkDialog,
                    InternalMatSnackBar,
                    SnackbarService,
                ]
            }]
    }], null, null); })();

class SfuiSnackbarModule {
}
SfuiSnackbarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiSnackbarModule });
SfuiSnackbarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiSnackbarModule_Factory(t) { return new (t || SfuiSnackbarModule)(); }, imports: [[
            CommonModule,
            MatSnackBarModule,
            MatProgressSpinnerModule,
            SfuiCdkOverlayModule,
            MatIconModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiSnackbarModule, { declarations: function () { return [Snackbar]; }, imports: function () { return [CommonModule,
        MatSnackBarModule,
        MatProgressSpinnerModule, SfuiCdkOverlayModule, MatIconModule]; }, exports: function () { return [Snackbar]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiSnackbarModule, [{
        type: NgModule,
        args: [{
                declarations: [Snackbar],
                imports: [
                    CommonModule,
                    MatSnackBarModule,
                    MatProgressSpinnerModule,
                    SfuiCdkOverlayModule,
                    MatIconModule,
                ],
                exports: [Snackbar]
            }]
    }], null, null); })();

const DEFAULT_THEME = {
    theme: {
        50: '#EDF3E8',
        100: '#D3E0C5',
        200: '#B5CB9F',
        300: '#97B678',
        400: '#81A75B',
        500: '#6B973E',
        600: '#638F38',
        700: '#588430',
        800: '#4E7A28',
        900: '#3C691B',
    },
};
class SfuiThemeService {
    constructor() {
        this.theme = new BehaviorSubject(DEFAULT_THEME);
    }
    setTheme(theme) {
        this.theme.next(theme);
    }
}
SfuiThemeService.ɵfac = function SfuiThemeService_Factory(t) { return new (t || SfuiThemeService)(); };
SfuiThemeService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SfuiThemeService, factory: SfuiThemeService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiThemeService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class SfuiThemeProvider {
    constructor(themeService) {
        this.themeService = themeService;
        this.theme = themeService.theme;
    }
    set sfuiThemeProvider(v) {
        if (!v)
            return; // Possible to be empty string if bind without value
        this.themeService.setTheme(v);
    }
}
SfuiThemeProvider.ɵfac = function SfuiThemeProvider_Factory(t) { return new (t || SfuiThemeProvider)(ɵngcc0.ɵɵdirectiveInject(SfuiThemeService, 2)); };
SfuiThemeProvider.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SfuiThemeProvider, selectors: [["", "sfuiThemeProvider", ""]], inputs: { sfuiThemeProvider: "sfuiThemeProvider" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: SfuiThemeService,
                useClass: SfuiThemeService
            },
        ])] });
SfuiThemeProvider.ctorParameters = () => [
    { type: SfuiThemeService, decorators: [{ type: Self }] }
];
SfuiThemeProvider.propDecorators = {
    sfuiThemeProvider: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiThemeProvider, [{
        type: Directive,
        args: [{
                selector: `[sfuiThemeProvider]`,
                providers: [
                    {
                        provide: SfuiThemeService,
                        useClass: SfuiThemeService
                    },
                ]
            }]
    }], function () { return [{ type: SfuiThemeService, decorators: [{
                type: Self
            }] }]; }, { sfuiThemeProvider: [{
            type: Input
        }] }); })();

const THEME_COLORS = [
    50, 100, 200, 300, 400, 500, 600, 700, 800, 900,
];
function getThemeStyles(theme) {
    const result = {};
    THEME_COLORS.forEach((color) => {
        result[`--sfui-theme-color-${color}`] = theme.theme[color];
    });
    return result;
}

class SfuiThemeConsumer {
    constructor(themeService, elRef) {
        this.elRef = elRef;
        this.theme = themeService.theme;
    }
    ngOnInit() {
        this.sub = this.theme.subscribe((theme) => {
            const styles = getThemeStyles(theme);
            Object.entries(styles).forEach(([key, value]) => {
                this.elRef.nativeElement.style.setProperty(key, value);
            });
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
}
SfuiThemeConsumer.ɵfac = function SfuiThemeConsumer_Factory(t) { return new (t || SfuiThemeConsumer)(ɵngcc0.ɵɵdirectiveInject(SfuiThemeService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SfuiThemeConsumer.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SfuiThemeConsumer, selectors: [["", "sfuiThemeConsumer", ""]], exportAs: ["sfuiThemeConsumer"], features: [ɵngcc0.ɵɵProvidersFeature([])] });
SfuiThemeConsumer.ctorParameters = () => [
    { type: SfuiThemeService },
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiThemeConsumer, [{
        type: Directive,
        args: [{
                selector: `[sfuiThemeConsumer]`,
                providers: [],
                exportAs: 'sfuiThemeConsumer'
            }]
    }], function () { return [{ type: SfuiThemeService }, { type: ɵngcc0.ElementRef }]; }, null); })();

class SfuiThemeModule {
}
SfuiThemeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiThemeModule });
SfuiThemeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiThemeModule_Factory(t) { return new (t || SfuiThemeModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiThemeModule, { declarations: function () { return [SfuiThemeProvider, SfuiThemeConsumer]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SfuiThemeProvider, SfuiThemeConsumer]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiThemeModule, [{
        type: NgModule,
        args: [{
                declarations: [SfuiThemeProvider, SfuiThemeConsumer],
                imports: [CommonModule],
                exports: [SfuiThemeProvider, SfuiThemeConsumer],
                providers: []
            }]
    }], null, null); })();

class Dialog {
    constructor(dialog, themeConsumer) {
        this.dialog = dialog;
        this.isOpen = true;
        this.isBlocking = false;
        this.dialogClass = '';
        this.dismiss = new EventEmitter();
        this.isInitialized = false;
        this._contentStyles = {};
        if (themeConsumer) {
            this.themeConsumer = themeConsumer;
        }
    }
    set themeConsumer(v) {
        this.setupThemeSubsciption(v);
    }
    ngOnChanges(changes) {
        if (this.isInitialized) {
            executeOnChange(() => this.toggleDialog(), Dialog.toggleDialogDependencies, changes);
        }
    }
    ngOnInit() {
        this.isInitialized = true;
        this.toggleDialog();
    }
    ngOnDestroy() {
        var _a;
        this.closeDialog();
        (_a = this.themeSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    setupThemeSubsciption(consumer) {
        var _a;
        (_a = this.themeSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.themeSubscription = consumer.theme.subscribe((newTheme) => {
            this._contentStyles = getThemeStyles(newTheme);
        });
    }
    toggleDialog() {
        if (this.isOpen) {
            this.openDialog();
        }
        else {
            this.closeDialog();
        }
    }
    closeDialog() {
        if (this.matDialogRef) {
            const { matDialog, subscriptions } = this.matDialogRef;
            matDialog.close();
            subscriptions.forEach((s) => s.unsubscribe());
        }
        this.matDialogRef = undefined;
    }
    openDialog() {
        this.closeDialog();
        const matDialog = this.dialog.open(this.dialogTemplate, {
            closeOnNavigation: false,
            disableClose: true,
            autoFocus: false,
            backdropClass: 'sfui-dialog-backdrop',
            panelClass: 'sfui-dialog-panel',
            width: 'auto',
            height: 'auto',
            maxWidth: 'auto',
            maxHeight: 'auto',
        });
        const escapeSub = matDialog
            .keydownEvents()
            .subscribe((e) => this.onDialogKeydown(e));
        const backdropClickSub = matDialog
            .backdropClick()
            .subscribe((e) => this.onBackdropClick(e));
        this.matDialogRef = {
            matDialog,
            subscriptions: [escapeSub, backdropClickSub],
        };
    }
    onDialogKeydown(e) {
        if (this.isBlocking) {
            return;
        }
        if (e.key.toLowerCase() === 'escape') {
            this.dismissDialog();
        }
    }
    onBackdropClick(_) {
        if (this.isBlocking) {
            return;
        }
        this.dismissDialog();
    }
    dismissDialog() {
        this.dismiss.emit();
    }
    _getDialogStyles() {
        const styles = {};
        if (this.width) {
            styles.width = getStyleString(this.width);
        }
        if (this.minWidth) {
            styles.minWidth = getStyleString(this.minWidth);
        }
        if (this.maxWidth) {
            styles.maxWidth = getStyleString(this.maxWidth);
        }
        if (this.height) {
            styles.height = getStyleString(this.height);
        }
        if (this.minHeight) {
            styles.minHeight = getStyleString(this.minHeight);
        }
        if (this.maxHeight) {
            styles.maxHeight = getStyleString(this.maxHeight);
        }
        return Object.assign(Object.assign({}, styles), this._contentStyles);
    }
}
Dialog.ɵfac = function Dialog_Factory(t) { return new (t || Dialog)(ɵngcc0.ɵɵdirectiveInject(SfuiCdkDialog), ɵngcc0.ɵɵdirectiveInject(SfuiThemeConsumer, 8)); };
Dialog.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Dialog, selectors: [["sfui-dialog"]], viewQuery: function Dialog_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 3, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dialogTemplate = _t.first);
    } }, inputs: { isOpen: "isOpen", isBlocking: "isBlocking", dialogClass: "dialogClass", themeConsumer: "themeConsumer", width: "width", minWidth: "minWidth", maxWidth: "maxWidth", height: "height", minHeight: "minHeight", maxHeight: "maxHeight" }, outputs: { dismiss: "dismiss" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2, decls: 2, vars: 0, consts: [["dialogTemplate", ""], [1, "sfui-dialog-container"]], template: function Dialog_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵtemplate(0, Dialog_ng_template_0_Template, 4, 4, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-dialog-backdrop{background-color:rgba(0,0,0,.52)}  .sfui-dialog-panel .mat-dialog-container{padding:0;width:auto;height:auto;border-radius:4px;box-shadow:0 24px 38px rgba(0,0,0,.14),0 9px 46px rgba(0,0,0,.12),0 11px 15px rgba(0,0,0,.2);overflow:hidden}  .sfui-dialog-container{overflow:auto;width:466px;max-width:calc(100vw - 40px);display:flex;flex-direction:column}  .sfui-dialog-container,   .sfui-dialog-container *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-dialog-container.material-icons,   .sfui-dialog-container .material-icons{font-family:Material Icons}  .sfui-dialog-container.material-icons-outlined,   .sfui-dialog-container .material-icons-outlined{font-family:Material Icons Outlined}"] });
Dialog.toggleDialogDependencies = ['isOpen'];
Dialog.ctorParameters = () => [
    { type: SfuiCdkDialog },
    { type: SfuiThemeConsumer, decorators: [{ type: Optional }] }
];
Dialog.propDecorators = {
    isOpen: [{ type: Input }],
    isBlocking: [{ type: Input }],
    dialogClass: [{ type: Input }],
    width: [{ type: Input }],
    minWidth: [{ type: Input }],
    maxWidth: [{ type: Input }],
    height: [{ type: Input }],
    minHeight: [{ type: Input }],
    maxHeight: [{ type: Input }],
    themeConsumer: [{ type: Input }],
    dismiss: [{ type: Output }],
    dialogTemplate: [{ type: ViewChild, args: ['dialogTemplate', { static: true, read: TemplateRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Dialog, [{
        type: Component,
        args: [{
                selector: 'sfui-dialog',
                template: "<ng-template #dialogTemplate>\n  <div\n    class=\"sfui-dialog-container\"\n    [class]=\"dialogClass\"\n    [style]=\"_getDialogStyles()\"\n  >\n    <ng-content select=\"sfui-dialog-header\"> </ng-content>\n    <ng-content select=\"sfui-dialog-content\"> </ng-content>\n    <ng-content select=\"sfui-dialog-footer\"> </ng-content>\n  </div>\n</ng-template>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-dialog-backdrop{background-color:rgba(0,0,0,.52)}::ng-deep .sfui-dialog-panel .mat-dialog-container{padding:0;width:auto;height:auto;border-radius:4px;box-shadow:0 24px 38px rgba(0,0,0,.14),0 9px 46px rgba(0,0,0,.12),0 11px 15px rgba(0,0,0,.2);overflow:hidden}::ng-deep .sfui-dialog-container{overflow:auto;width:466px;max-width:calc(100vw - 40px);display:flex;flex-direction:column}::ng-deep .sfui-dialog-container,::ng-deep .sfui-dialog-container *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-dialog-container.material-icons,::ng-deep .sfui-dialog-container .material-icons{font-family:Material Icons}::ng-deep .sfui-dialog-container.material-icons-outlined,::ng-deep .sfui-dialog-container .material-icons-outlined{font-family:Material Icons Outlined}"]
            }]
    }], function () { return [{ type: SfuiCdkDialog }, { type: SfuiThemeConsumer, decorators: [{
                type: Optional
            }] }]; }, { isOpen: [{
            type: Input
        }], isBlocking: [{
            type: Input
        }], dialogClass: [{
            type: Input
        }], dismiss: [{
            type: Output
        }], themeConsumer: [{
            type: Input
        }], width: [{
            type: Input
        }], minWidth: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], height: [{
            type: Input
        }], minHeight: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }], dialogTemplate: [{
            type: ViewChild,
            args: ['dialogTemplate', { static: true, read: TemplateRef }]
        }] }); })();

class DialogHeader {
    constructor() {
        this.hostClass = {
            'sfui-dialog-header': true,
        };
    }
}
DialogHeader.ɵfac = function DialogHeader_Factory(t) { return new (t || DialogHeader)(); };
DialogHeader.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DialogHeader, selectors: [["sfui-dialog-header"]], hostVars: 2, hostBindings: function DialogHeader_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, ngContentSelectors: _c3, decls: 1, vars: 0, template: function DialogHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:block;padding:20px 24px 15px;font-size:16px;line-height:24px;color:rgba(0,0,0,.87);letter-spacing:.15px;font-weight:550}"] });
DialogHeader.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogHeader, [{
        type: Component,
        args: [{
                selector: 'sfui-dialog-header',
                template: `<ng-content></ng-content>`,
                styles: [":host{display:block;padding:20px 24px 15px;font-size:16px;line-height:24px;color:rgba(0,0,0,.87);letter-spacing:.15px;font-weight:550}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class DialogFooter {
    constructor() {
        this.hostClass = {
            'sfui-dialog-footer': true,
        };
    }
}
DialogFooter.ɵfac = function DialogFooter_Factory(t) { return new (t || DialogFooter)(); };
DialogFooter.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DialogFooter, selectors: [["sfui-dialog-footer"]], hostVars: 2, hostBindings: function DialogFooter_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, ngContentSelectors: _c3, decls: 1, vars: 0, template: function DialogFooter_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end;padding:15px 14px 8px}[_nghost-%COMP%] >   .sfui-button+.sfui-button, [_nghost-%COMP%] >   .sfui-dialog-button+.sfui-dialog-button{margin-left:8px}"] });
DialogFooter.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogFooter, [{
        type: Component,
        args: [{
                selector: 'sfui-dialog-footer',
                template: `<ng-content></ng-content>`,
                styles: [":host{display:flex;flex-direction:row;justify-content:flex-end;padding:15px 14px 8px}:host>::ng-deep .sfui-button+.sfui-button,:host>::ng-deep .sfui-dialog-button+.sfui-dialog-button{margin-left:8px}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class DialogContent {
    constructor() {
        this.hostClass = {
            'sfui-dialog-content': true,
        };
    }
}
DialogContent.ɵfac = function DialogContent_Factory(t) { return new (t || DialogContent)(); };
DialogContent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DialogContent, selectors: [["sfui-dialog-content"]], hostVars: 2, hostBindings: function DialogContent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, ngContentSelectors: _c3, decls: 1, vars: 0, template: function DialogContent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:block;padding:0 24px;font-size:16px;line-height:24px;color:rgba(0,0,0,.87);letter-spacing:.5px;white-space:pre-line;flex:1 0 auto}"] });
DialogContent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogContent, [{
        type: Component,
        args: [{
                selector: 'sfui-dialog-content',
                template: `<ng-content></ng-content>`,
                styles: [":host{display:block;padding:0 24px;font-size:16px;line-height:24px;color:rgba(0,0,0,.87);letter-spacing:.5px;white-space:pre-line;flex:1 0 auto}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

/** @deprecated use Button instead */
class DialogButton {
    constructor() {
        this.hostClass = {
            'sfui-dialog-button': true,
        };
        this.type = 'default';
        this.disabled = false;
        this.buttonClick = new EventEmitter();
    }
    _getButtonTypeByColor() {
        if (this.type === 'default') {
            return 'stroked';
        }
        return 'flat';
    }
    _onClick(e) {
        if (this.disabled) {
            return;
        }
        this.buttonClick.emit(e);
    }
}
DialogButton.ɵfac = function DialogButton_Factory(t) { return new (t || DialogButton)(); };
DialogButton.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DialogButton, selectors: [["sfui-dialog-button"]], hostVars: 2, hostBindings: function DialogButton_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { type: "type", disabled: "disabled" }, outputs: { buttonClick: "buttonClick" }, ngContentSelectors: _c3, decls: 2, vars: 3, consts: [[1, "sfui-dialog-button__button", 3, "type", "color", "disabled", "buttonClick"]], template: function DialogButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "sfui-button", 0);
        ɵngcc0.ɵɵlistener("buttonClick", function DialogButton_Template_sfui_button_buttonClick_0_listener($event) { return ctx._onClick($event); });
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("type", ctx._getButtonTypeByColor())("color", ctx.type)("disabled", ctx.disabled);
    } }, directives: function () { return [Button]; }, styles: ["*[_ngcontent-%COMP%],   .sfui-dialog-button{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-dialog-button{display:inline-block;font-style:normal;font-weight:550;font-size:16px;line-height:16px}.sfui-dialog-button__button[_ngcontent-%COMP%]{display:block;font-family:inherit;font-style:inherit;font-weight:inherit;font-size:inherit;line-height:inherit}"] });
DialogButton.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    type: [{ type: Input }],
    disabled: [{ type: Input }],
    buttonClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogButton, [{
        type: Component,
        args: [{
                selector: 'sfui-dialog-button',
                template: "<sfui-button\n  class=\"sfui-dialog-button__button\"\n  (buttonClick)=\"_onClick($event)\"\n  [type]=\"_getButtonTypeByColor()\"\n  [color]=\"type\"\n  [disabled]=\"disabled\"\n>\n  <ng-content></ng-content>\n</sfui-button>\n",
                styles: ["*,::ng-deep .sfui-dialog-button{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-dialog-button{display:inline-block;font-style:normal;font-weight:550;font-size:16px;line-height:16px}.sfui-dialog-button__button{display:block;font-family:inherit;font-style:inherit;font-weight:inherit;font-size:inherit;line-height:inherit}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], type: [{
            type: Input
        }], disabled: [{
            type: Input
        }], buttonClick: [{
            type: Output
        }] }); })();

const TAG_NAME_TO_TYPE_MAP = new Map([
    ['sfui-stroked-button', 'stroked'],
    ['sfui-flat-button', 'flat'],
    ['sfui-button', 'flat'],
]);
class Button {
    constructor(elRef) {
        this.elRef = elRef;
        this.color = 'default';
        this.disabled = false;
        this.buttonClick = new EventEmitter();
        this._onHostClick = (e) => {
            if (this.disabled) {
                e.stopPropagation();
                e.stopImmediatePropagation();
                e.preventDefault();
            }
        };
        // Call in constructor to ensure this is the first listener attached to click event
        elRef.nativeElement.addEventListener('click', this._onHostClick);
    }
    get hostClass() {
        return ['sfui-button', ...this.typeClass, ...this.colorClass];
    }
    get typeClass() {
        return [`sfui-${this.type}-button`];
    }
    get colorClass() {
        return [`sfui-button--${this.color}`];
    }
    get type() {
        if (this.explicitType) {
            return this.explicitType;
        }
        const tagName = this.elRef.nativeElement.tagName.toLowerCase();
        const type = TAG_NAME_TO_TYPE_MAP.get(tagName);
        if (type) {
            return type;
        }
        return 'flat';
    }
    set type(v) {
        this.explicitType = v;
    }
    ngOnDestroy() {
        this.elRef.nativeElement.removeEventListener('click', this._onHostClick);
    }
    _onClick(e) {
        if (this.disabled) {
            return;
        }
        this.buttonClick.emit(e);
    }
}
Button.ɵfac = function Button_Factory(t) { return new (t || Button)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
Button.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Button, selectors: [["sfui-button"], ["sfui-stroked-button"], ["sfui-flat-button"]], contentQueries: function Button_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SfuiButtonIcon, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._buttonIconChildren = _t);
    } }, hostVars: 2, hostBindings: function Button_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { color: "color", disabled: "disabled", type: "type" }, outputs: { buttonClick: "buttonClick" }, ngContentSelectors: _c5, decls: 4, vars: 2, consts: [["mat-button", "", 1, "sfui-button__button", 3, "disabled", "click"], [1, "sfui-button__button-wrapper"], ["class", "sfui-button__button-content", 4, "ngIf"], [1, "sfui-button__button-content"]], template: function Button_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c4);
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function Button_Template_button_click_0_listener($event) { return ctx._onClick($event); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, Button_div_2_Template, 2, 0, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx._buttonIconChildren.length);
    } }, directives: [ɵngcc10.MatButton, ɵngcc1.NgIf], styles: ["*[_ngcontent-%COMP%],   .sfui-button{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-button{display:inline-block;font-style:normal;font-weight:550;font-size:16px;line-height:16px;--sfui-button-color:var(--sfui-theme-color-500,#968c75);--sfui-button-border-color:rgba(0,0,0,0.12)}  .sfui-button--default{--sfui-button-color:rgba(0,0,0,0.6)}  .sfui-button--primary{--sfui-button-color:var(--sfui-theme-color-500,#968c75)}  .sfui-button--warn{--sfui-button-color:#f03738}.sfui-flat-button[_nghost-%COMP%]   .sfui-button__button[_ngcontent-%COMP%]{background-color:var(--sfui-button-color);color:#fff;border-color:var(--sfui-button-color)}.sfui-flat-button[_nghost-%COMP%]   .sfui-button__button[_ngcontent-%COMP%]:disabled{color:rgba(0,0,0,.24);background-color:rgba(33,33,33,.08);border-color:rgba(33,33,33,.08)}.sfui-stroked-button[_nghost-%COMP%]   .sfui-button__button[_ngcontent-%COMP%]{background-color:transparent;color:var(--sfui-button-color);border-color:var(--sfui-button-border-color)}.sfui-stroked-button[_nghost-%COMP%]   .sfui-button__button[_ngcontent-%COMP%]:disabled{color:rgba(0,0,0,.24)}.sfui-button__button[_ngcontent-%COMP%]{display:block;width:100%;border:1px solid transparent;font-family:inherit;font-style:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;border-radius:4px;padding:9px 15px;background-clip:padding-box}.sfui-button__button[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.sfui-button__button-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;justify-content:center}.sfui-button__button-content[_ngcontent-%COMP%]{display:block}.sfui-button__button-content[_ngcontent-%COMP%]:not(:last-child){margin-right:6px}"] });
Button.ctorParameters = () => [
    { type: ElementRef }
];
Button.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    type: [{ type: Input }],
    color: [{ type: Input }],
    disabled: [{ type: Input }],
    buttonClick: [{ type: Output }],
    _buttonIconChildren: [{ type: ContentChildren, args: [SfuiButtonIcon,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Button, [{
        type: Component,
        args: [{
                selector: `sfui-button,
             sfui-stroked-button,
             sfui-flat-button`,
                template: "<button\n  mat-button\n  class=\"sfui-button__button\"\n  (click)=\"_onClick($event)\"\n  [disabled]=\"disabled\"\n>\n  <div class=\"sfui-button__button-wrapper\">\n    <div *ngIf=\"_buttonIconChildren.length\" class=\"sfui-button__button-content\">\n      <ng-content select=\"[sfuiButtonIcon]\"></ng-content>\n    </div>\n    <ng-content></ng-content>\n  </div>\n</button>\n",
                styles: ["*,::ng-deep .sfui-button{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-button{display:inline-block;font-style:normal;font-weight:550;font-size:16px;line-height:16px;--sfui-button-color:var(--sfui-theme-color-500,#968c75);--sfui-button-border-color:rgba(0,0,0,0.12)}::ng-deep .sfui-button--default{--sfui-button-color:rgba(0,0,0,0.6)}::ng-deep .sfui-button--primary{--sfui-button-color:var(--sfui-theme-color-500,#968c75)}::ng-deep .sfui-button--warn{--sfui-button-color:#f03738}:host(.sfui-flat-button) .sfui-button__button{background-color:var(--sfui-button-color);color:#fff;border-color:var(--sfui-button-color)}:host(.sfui-flat-button) .sfui-button__button:disabled{color:rgba(0,0,0,.24);background-color:rgba(33,33,33,.08);border-color:rgba(33,33,33,.08)}:host(.sfui-stroked-button) .sfui-button__button{background-color:transparent;color:var(--sfui-button-color);border-color:var(--sfui-button-border-color)}:host(.sfui-stroked-button) .sfui-button__button:disabled{color:rgba(0,0,0,.24)}.sfui-button__button{display:block;width:100%;border:1px solid transparent;font-family:inherit;font-style:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;border-radius:4px;padding:9px 15px;background-clip:padding-box}.sfui-button__button:disabled{cursor:not-allowed}.sfui-button__button-wrapper{display:flex;flex-direction:row;align-items:center;justify-content:center}.sfui-button__button-content{display:block}.sfui-button__button-content:not(:last-child){margin-right:6px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { color: [{
            type: Input
        }], disabled: [{
            type: Input
        }], buttonClick: [{
            type: Output
        }], hostClass: [{
            type: HostBinding,
            args: ['class']
        }], type: [{
            type: Input
        }], _buttonIconChildren: [{
            type: ContentChildren,
            args: [SfuiButtonIcon]
        }] }); })();

class SfuiButtonModule {
}
SfuiButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiButtonModule });
SfuiButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiButtonModule_Factory(t) { return new (t || SfuiButtonModule)(); }, imports: [[CommonModule, MatButtonModule, SfuiCommonDirectivesModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiButtonModule, { declarations: function () { return [Button]; }, imports: function () { return [CommonModule, MatButtonModule, SfuiCommonDirectivesModule]; }, exports: function () { return [Button, SfuiButtonIcon]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [Button],
                imports: [CommonModule, MatButtonModule, SfuiCommonDirectivesModule],
                exports: [Button, SfuiButtonIcon]
            }]
    }], null, null); })();

class SfuiDialogModule {
}
SfuiDialogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiDialogModule });
SfuiDialogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiDialogModule_Factory(t) { return new (t || SfuiDialogModule)(); }, imports: [[CommonModule, SfuiButtonModule, SfuiCdkOverlayModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiDialogModule, { declarations: function () { return [Dialog, DialogHeader, DialogFooter, DialogContent, DialogButton]; }, imports: function () { return [CommonModule, SfuiButtonModule, SfuiCdkOverlayModule]; }, exports: function () { return [Dialog, DialogHeader, DialogFooter, DialogContent, Button, DialogButton]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiDialogModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    Dialog,
                    DialogHeader,
                    DialogFooter,
                    DialogContent,
                    DialogButton,
                ],
                imports: [CommonModule, SfuiButtonModule, SfuiCdkOverlayModule],
                exports: [
                    Dialog,
                    DialogHeader,
                    DialogFooter,
                    DialogContent,
                    Button,
                    DialogButton,
                ]
            }]
    }], null, null); })();

const SFUI_PLATFORM = new InjectionToken('sfui.platform');

class CardHeader {
    constructor(platform) {
        this.platform = platform;
        this.iconUrl = '';
        this.hostClass = [
            'sfui-card-header',
            platform === 'web' ? 'sfui-card-header--web' : 'sfui-card-header--app',
        ];
    }
    get iconBackgroundUrl() {
        if (!this.iconUrl)
            return null;
        return `url('${this.iconUrl}')`;
    }
}
CardHeader.ɵfac = function CardHeader_Factory(t) { return new (t || CardHeader)(ɵngcc0.ɵɵdirectiveInject(SFUI_PLATFORM)); };
CardHeader.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardHeader, selectors: [["sfui-card-header"]], hostVars: 2, hostBindings: function CardHeader_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { iconUrl: "iconUrl" }, ngContentSelectors: _c7, decls: 5, vars: 1, consts: [[1, "sfui-card-header__rect"], ["class", "sfui-card-header__icon", 3, "backgroundImage", 4, "ngIf"], [1, "sfui-card-header__title"], [1, "sfui-card-header__icon"]], template: function CardHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c6);
        ɵngcc0.ɵɵelement(0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, CardHeader_span_1_Template, 1, 2, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(4, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.iconUrl);
    } }, directives: [ɵngcc1.NgIf], styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-card-header{text-align:left;display:flex;flex-direction:row;align-items:center;position:relative;color:var(--sfui-card-color,rgba(0,0,0,.87));overflow:hidden;white-space:nowrap;text-overflow:ellipsis}  .sfui-card-header,   .sfui-card-header *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-card-header.material-icons,   .sfui-card-header .material-icons{font-family:Material Icons}  .sfui-card-header.material-icons-outlined,   .sfui-card-header .material-icons-outlined{font-family:Material Icons Outlined}  .sfui-card-header--app{padding-top:12px;padding-bottom:8px;font-size:12px;line-height:16px;letter-spacing:.2px}  .sfui-card-header--app,   .sfui-card-header--web{padding-right:16px;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550}  .sfui-card-header--web{padding-top:20px;padding-bottom:16px;font-size:18px;line-height:24px;letter-spacing:.15px}.sfui-card-header__rect[_ngcontent-%COMP%]{flex:0 0 auto;width:4px;height:24px;background-color:var(--sfui-card-color,transparent);margin-right:10px;margin-top:-2px}.sfui-card-header__icon[_ngcontent-%COMP%]{flex:0 0 auto;width:20px;height:20px;background-repeat:no-repeat;background-position:50%;background-size:contain;margin-right:4px}.sfui-card-header__title[_ngcontent-%COMP%]{flex:1 1 0px;padding-right:5px;color:inherit;font-family:inherit;font-style:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;letter-spacing:inherit;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.sfui-card-header--web[_nghost-%COMP%]   .sfui-card-header__rect[_ngcontent-%COMP%]{width:7px;margin-right:8px;margin-top:0}.sfui-card-header--web[_nghost-%COMP%]   .sfui-card-header__icon[_ngcontent-%COMP%]{width:24px;height:24px}.sfui-card-header--web[_nghost-%COMP%]   .sfui-card-header__title[_ngcontent-%COMP%]{flex:1 1 0px;padding-right:5px}"] });
CardHeader.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [SFUI_PLATFORM,] }] }
];
CardHeader.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    iconUrl: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardHeader, [{
        type: Component,
        args: [{
                selector: 'sfui-card-header',
                template: "<span class=\"sfui-card-header__rect\"></span>\n<span\n  *ngIf=\"!!iconUrl\"\n  class=\"sfui-card-header__icon\"\n  [style.backgroundImage]=\"iconBackgroundUrl\"\n></span>\n<span class=\"sfui-card-header__title\">\n  <ng-content></ng-content>\n</span>\n<ng-content select=\"[sfuiSuffix]\"></ng-content>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-card-header{text-align:left;display:flex;flex-direction:row;align-items:center;position:relative;color:var(--sfui-card-color,rgba(0,0,0,.87));overflow:hidden;white-space:nowrap;text-overflow:ellipsis}::ng-deep .sfui-card-header,::ng-deep .sfui-card-header *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-card-header.material-icons,::ng-deep .sfui-card-header .material-icons{font-family:Material Icons}::ng-deep .sfui-card-header.material-icons-outlined,::ng-deep .sfui-card-header .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-card-header--app{padding-top:12px;padding-bottom:8px;font-size:12px;line-height:16px;letter-spacing:.2px}::ng-deep .sfui-card-header--app,::ng-deep .sfui-card-header--web{padding-right:16px;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550}::ng-deep .sfui-card-header--web{padding-top:20px;padding-bottom:16px;font-size:18px;line-height:24px;letter-spacing:.15px}.sfui-card-header__rect{flex:0 0 auto;width:4px;height:24px;background-color:var(--sfui-card-color,transparent);margin-right:10px;margin-top:-2px}.sfui-card-header__icon{flex:0 0 auto;width:20px;height:20px;background-repeat:no-repeat;background-position:50%;background-size:contain;margin-right:4px}.sfui-card-header__title{flex:1 1 0px;padding-right:5px;color:inherit;font-family:inherit;font-style:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;letter-spacing:inherit;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}:host(.sfui-card-header--web) .sfui-card-header__rect{width:7px;margin-right:8px;margin-top:0}:host(.sfui-card-header--web) .sfui-card-header__icon{width:24px;height:24px}:host(.sfui-card-header--web) .sfui-card-header__title{flex:1 1 0px;padding-right:5px}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [SFUI_PLATFORM]
            }] }]; }, { iconUrl: [{
            type: Input
        }], hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

const COLOR_VARIABLE_NAME = '--sfui-card-color';
class Card {
    constructor(platform) {
        this.platform = platform;
        this.title = '';
        this.iconUrl = '';
        this.color = '';
        this.hostClass = [
            'sfui-card',
            platform === 'web' ? 'sfui-card--web' : 'sfui-card--app',
        ];
    }
    get cardColor() {
        if (!this.color)
            return null;
        return this.color;
    }
    _shouldRenderHeader() {
        if (this.headers && this.headers.length !== 0)
            return false;
        return !!(this.title || this.iconUrl);
    }
}
Card.ɵfac = function Card_Factory(t) { return new (t || Card)(ɵngcc0.ɵɵdirectiveInject(SFUI_PLATFORM)); };
Card.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Card, selectors: [["sfui-card"]], contentQueries: function Card_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CardHeader, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headers = _t);
    } }, hostVars: 4, hostBindings: function Card_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
        ɵngcc0.ɵɵstyleProp("--sfui-card-color", ctx.cardColor);
    } }, inputs: { title: "title", iconUrl: "iconUrl", color: "color", cardColor: "cardColor" }, ngContentSelectors: _c3, decls: 2, vars: 1, consts: [[3, "iconUrl", 4, "ngIf"], [3, "iconUrl"]], template: function Card_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, Card_sfui_card_header_0_Template, 2, 2, "sfui-card-header", 0);
        ɵngcc0.ɵɵprojection(1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._shouldRenderHeader());
    } }, directives: [ɵngcc1.NgIf, CardHeader], styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-card{display:block;background-color:#fff;box-shadow:0 4px 8px rgba(0,0,0,.24);border-radius:4px;color:var(--sfui-card-color);--sfui-card-color:var(--sfui-theme-color-500,rgba(0,0,0,0.87))}  .sfui-card,   .sfui-card *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-card.material-icons,   .sfui-card .material-icons{font-family:Material Icons}  .sfui-card.material-icons-outlined,   .sfui-card .material-icons-outlined{font-family:Material Icons Outlined}"] });
Card.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [SFUI_PLATFORM,] }] }
];
Card.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    title: [{ type: Input }],
    iconUrl: [{ type: Input }],
    color: [{ type: Input }],
    cardColor: [{ type: Input }, { type: HostBinding, args: [`style.${COLOR_VARIABLE_NAME}`,] }],
    headers: [{ type: ContentChildren, args: [CardHeader,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Card, [{
        type: Component,
        args: [{
                selector: 'sfui-card',
                template: "<sfui-card-header *ngIf=\"_shouldRenderHeader()\" [iconUrl]=\"iconUrl\">\n  {{ title }}\n</sfui-card-header>\n<ng-content></ng-content>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-card{display:block;background-color:#fff;box-shadow:0 4px 8px rgba(0,0,0,.24);border-radius:4px;color:var(--sfui-card-color);--sfui-card-color:var(--sfui-theme-color-500,rgba(0,0,0,0.87))}::ng-deep .sfui-card,::ng-deep .sfui-card *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-card.material-icons,::ng-deep .sfui-card .material-icons{font-family:Material Icons}::ng-deep .sfui-card.material-icons-outlined,::ng-deep .sfui-card .material-icons-outlined{font-family:Material Icons Outlined}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [SFUI_PLATFORM]
            }] }]; }, { title: [{
            type: Input
        }], iconUrl: [{
            type: Input
        }], color: [{
            type: Input
        }], hostClass: [{
            type: HostBinding,
            args: ['class']
        }], cardColor: [{
            type: Input
        }, {
            type: HostBinding,
            args: [`style.${COLOR_VARIABLE_NAME}`]
        }], headers: [{
            type: ContentChildren,
            args: [CardHeader]
        }] }); })();

class SfuiCardModule {
}
SfuiCardModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiCardModule });
SfuiCardModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiCardModule_Factory(t) { return new (t || SfuiCardModule)(); }, imports: [[CommonModule, SfuiCommonDirectivesModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiCardModule, { declarations: function () { return [Card, CardHeader]; }, imports: function () { return [CommonModule, SfuiCommonDirectivesModule]; }, exports: function () { return [Card, CardHeader, SfuiSuffix]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiCardModule, [{
        type: NgModule,
        args: [{
                declarations: [Card, CardHeader],
                imports: [CommonModule, SfuiCommonDirectivesModule],
                exports: [Card, CardHeader, SfuiSuffix]
            }]
    }], null, null); })();

class TimelineGroup {
    constructor() {
        this.hostClass = ['sfui-timeline-group'];
    }
}
TimelineGroup.ɵfac = function TimelineGroup_Factory(t) { return new (t || TimelineGroup)(); };
TimelineGroup.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimelineGroup, selectors: [["sfui-timeline-group"]], hostVars: 2, hostBindings: function TimelineGroup_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, ngContentSelectors: _c3, decls: 2, vars: 0, consts: [[1, "sfui-timeline-group__container"]], template: function TimelineGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-timeline-group{display:block}  .sfui-timeline-group,   .sfui-timeline-group *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-timeline-group.material-icons,   .sfui-timeline-group .material-icons{font-family:Material Icons}  .sfui-timeline-group.material-icons-outlined,   .sfui-timeline-group .material-icons-outlined{font-family:Material Icons Outlined}  .sfui-timeline-group__container .sfui-timeline:not(:last-child) .sfui-timeline__timeline-line{border-left:1px solid rgba(0,0,0,.12)}"] });
TimelineGroup.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimelineGroup, [{
        type: Component,
        args: [{
                selector: 'sfui-timeline-group',
                template: "<div class=\"sfui-timeline-group__container\">\n  <ng-content></ng-content>\n</div>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-timeline-group{display:block}::ng-deep .sfui-timeline-group,::ng-deep .sfui-timeline-group *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-timeline-group.material-icons,::ng-deep .sfui-timeline-group .material-icons{font-family:Material Icons}::ng-deep .sfui-timeline-group.material-icons-outlined,::ng-deep .sfui-timeline-group .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-timeline-group__container .sfui-timeline:not(:last-child) .sfui-timeline__timeline-line{border-left:1px solid rgba(0,0,0,.12)}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class Timeline {
    constructor() {
        this.hostClass = ['sfui-timeline'];
        this.timestamp = '';
        this.iconUrl = '';
    }
}
Timeline.ɵfac = function Timeline_Factory(t) { return new (t || Timeline)(); };
Timeline.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Timeline, selectors: [["sfui-timeline"]], hostVars: 2, hostBindings: function Timeline_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { timestamp: "timestamp", iconUrl: "iconUrl" }, ngContentSelectors: _c3, decls: 10, vars: 2, consts: [[1, "sfui-timeline__timeline"], [1, "sfui-timeline__timeline-timeline"], [1, "sfui-timeline__timeline-badge"], [1, "sfui-timeline__timeline-badge-icon", 3, "src"], [1, "sfui-timeline__timeline-line"], [1, "sfui-timeline__timeline-content"], [1, "sfui-timeline__timeline-timestamp"], [1, "sfui-timeline__timeline-content-wrapper"]], template: function Timeline_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵprojection(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("src", ctx.iconUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.timestamp);
    } }, styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-timeline{display:block;--sfui-timeline-badge-background:#968c75}  .sfui-timeline,   .sfui-timeline *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-timeline.material-icons,   .sfui-timeline .material-icons{font-family:Material Icons}  .sfui-timeline.material-icons-outlined,   .sfui-timeline .material-icons-outlined{font-family:Material Icons Outlined}.sfui-timeline__timeline[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:stretch}.sfui-timeline__timeline-badge[_ngcontent-%COMP%]{border-radius:50%;width:28px;height:28px;background-color:var(--sfui-timeline-badge-background);display:flex;justify-content:center;align-items:center}.sfui-timeline__timeline-badge-icon[_ngcontent-%COMP%]{width:18px;height:18px}.sfui-timeline__timeline-line[_ngcontent-%COMP%]{display:block;margin:8px 0 8px 13px;min-height:24px;height:calc(100% - 44px)}.sfui-timeline__timeline-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:flex-start;text-align:left;padding-left:13px}.sfui-timeline__timeline-timestamp[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:rgba(0,0,0,.6);text-align:left}"] });
Timeline.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    timestamp: [{ type: Input }],
    iconUrl: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Timeline, [{
        type: Component,
        args: [{
                selector: 'sfui-timeline',
                template: "<div class=\"sfui-timeline__timeline\">\n  <div class=\"sfui-timeline__timeline-timeline\">\n    <div class=\"sfui-timeline__timeline-badge\">\n      <img class=\"sfui-timeline__timeline-badge-icon\" [src]=\"iconUrl\" />\n    </div>\n    <div class=\"sfui-timeline__timeline-line\"></div>\n  </div>\n  <div class=\"sfui-timeline__timeline-content\">\n    <div class=\"sfui-timeline__timeline-timestamp\">{{ timestamp }}</div>\n    <div class=\"sfui-timeline__timeline-content-wrapper\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-timeline{display:block;--sfui-timeline-badge-background:#968c75}::ng-deep .sfui-timeline,::ng-deep .sfui-timeline *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-timeline.material-icons,::ng-deep .sfui-timeline .material-icons{font-family:Material Icons}::ng-deep .sfui-timeline.material-icons-outlined,::ng-deep .sfui-timeline .material-icons-outlined{font-family:Material Icons Outlined}.sfui-timeline__timeline{display:flex;flex-direction:row;align-items:stretch}.sfui-timeline__timeline-badge{border-radius:50%;width:28px;height:28px;background-color:var(--sfui-timeline-badge-background);display:flex;justify-content:center;align-items:center}.sfui-timeline__timeline-badge-icon{width:18px;height:18px}.sfui-timeline__timeline-line{display:block;margin:8px 0 8px 13px;min-height:24px;height:calc(100% - 44px)}.sfui-timeline__timeline-content{display:flex;flex-direction:column;justify-content:flex-start;text-align:left;padding-left:13px}.sfui-timeline__timeline-timestamp{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:rgba(0,0,0,.6);text-align:left}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], timestamp: [{
            type: Input
        }], iconUrl: [{
            type: Input
        }] }); })();

class SfuiTimelineModule {
}
SfuiTimelineModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiTimelineModule });
SfuiTimelineModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiTimelineModule_Factory(t) { return new (t || SfuiTimelineModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiTimelineModule, { declarations: function () { return [TimelineGroup, Timeline]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TimelineGroup, Timeline]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiTimelineModule, [{
        type: NgModule,
        args: [{
                declarations: [TimelineGroup, Timeline],
                imports: [CommonModule],
                exports: [TimelineGroup, Timeline]
            }]
    }], null, null); })();

class CloseIcon {
}
CloseIcon.ɵfac = function CloseIcon_Factory(t) { return new (t || CloseIcon)(); };
CloseIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CloseIcon, selectors: [["", "sfui-svg-icon--close", ""]], attrs: _c8, decls: 2, vars: 0, consts: [["viewBox", "0 0 24 24", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--close"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z", "fill", "currentColor"]], template: function CloseIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CloseIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--close]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--close"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill="currentColor"
      />
    </svg>
  `
            }]
    }], null, null); })();

class DownloadIcon {
}
DownloadIcon.ɵfac = function DownloadIcon_Factory(t) { return new (t || DownloadIcon)(); };
DownloadIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DownloadIcon, selectors: [["", "sfui-svg-icon--download", ""]], attrs: _c9, decls: 2, vars: 0, consts: [["viewBox", "0 0 24 24", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--download"], ["d", "M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z", "fill", "white", "fill-opacity", "0.74"]], template: function DownloadIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DownloadIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--download]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--download"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z"
        fill="white"
        fill-opacity="0.74"
      />
    </svg>
  `
            }]
    }], null, null); })();

class ArrowIcon {
}
ArrowIcon.ɵfac = function ArrowIcon_Factory(t) { return new (t || ArrowIcon)(); };
ArrowIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ArrowIcon, selectors: [["", "sfui-svg-icon--arrow", ""]], attrs: _c10, decls: 2, vars: 0, consts: [["viewBox", "0 0 24 24", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--arrow"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z", "fill", "white"]], template: function ArrowIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ArrowIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--arrow]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--arrow"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z"
        fill="white"
      />
    </svg>
  `
            }]
    }], null, null); })();

class RefreshIcon {
}
RefreshIcon.ɵfac = function RefreshIcon_Factory(t) { return new (t || RefreshIcon)(); };
RefreshIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RefreshIcon, selectors: [["", "sfui-svg-icon--refresh", ""]], attrs: _c11, decls: 2, vars: 0, consts: [["viewBox", "0 0 32 32", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--refresh"], ["d", "M23.5333 8.46683C21.6 6.5335 18.9467 5.3335 16 5.3335C10.1067 5.3335 5.34668 10.1068 5.34668 16.0002C5.34668 21.8935 10.1067 26.6668 16 26.6668C20.9733 26.6668 25.12 23.2668 26.3067 18.6668H23.5333C22.44 21.7735 19.48 24.0002 16 24.0002C11.5867 24.0002 8.00001 20.4135 8.00001 16.0002C8.00001 11.5868 11.5867 8.00016 16 8.00016C18.2133 8.00016 20.1867 8.92016 21.6267 10.3735L17.3333 14.6668H26.6667V5.3335L23.5333 8.46683Z", "fill", "white"]], template: function RefreshIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RefreshIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--refresh]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--refresh"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5333 8.46683C21.6 6.5335 18.9467 5.3335 16 5.3335C10.1067 5.3335 5.34668 10.1068 5.34668 16.0002C5.34668 21.8935 10.1067 26.6668 16 26.6668C20.9733 26.6668 25.12 23.2668 26.3067 18.6668H23.5333C22.44 21.7735 19.48 24.0002 16 24.0002C11.5867 24.0002 8.00001 20.4135 8.00001 16.0002C8.00001 11.5868 11.5867 8.00016 16 8.00016C18.2133 8.00016 20.1867 8.92016 21.6267 10.3735L17.3333 14.6668H26.6667V5.3335L23.5333 8.46683Z"
        fill="white"
      />
    </svg>
  `
            }]
    }], null, null); })();

class TickIcon {
}
TickIcon.ɵfac = function TickIcon_Factory(t) { return new (t || TickIcon)(); };
TickIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TickIcon, selectors: [["", "sfui-svg-icon--tick", ""]], attrs: _c12, decls: 2, vars: 0, consts: [["viewBox", "0 0 24 24", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--tick"], ["d", "M9.00016 16.1698L4.83016 11.9998L3.41016 13.4098L9.00016 18.9998L21.0002 6.99984L19.5902 5.58984L9.00016 16.1698Z", "fill", "white"]], template: function TickIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TickIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--tick]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--tick"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00016 16.1698L4.83016 11.9998L3.41016 13.4098L9.00016 18.9998L21.0002 6.99984L19.5902 5.58984L9.00016 16.1698Z"
        fill="white"
      />
    </svg>
  `
            }]
    }], null, null); })();

class AttachmentDefaultIcon {
    constructor() {
        this.iconColor = '';
    }
}
AttachmentDefaultIcon.ɵfac = function AttachmentDefaultIcon_Factory(t) { return new (t || AttachmentDefaultIcon)(); };
AttachmentDefaultIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttachmentDefaultIcon, selectors: [["", "sfui-svg-icon--attachment-default", ""]], inputs: { iconColor: "iconColor" }, attrs: _c13, decls: 3, vars: 2, consts: [["viewBox", "0 0 49 48", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--attachment-default"], ["d", "M35.75 46.5H8.75C7.09315 46.5 5.75 45.1569 5.75 43.5V11.25", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M43.25 36.318C43.2959 38.2996 41.7314 39.9455 39.75 40H15.25C13.2687 39.9455 11.7041 38.2996 11.75 36.318V5.182C11.7041 3.20043 13.2687 1.55453 15.25 1.5H33.05C33.9882 1.50471 34.8834 1.89443 35.526 2.578L42.224 9.626C42.886 10.3295 43.2532 11.26 43.25 12.226V36.318Z", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"]], template: function AttachmentDefaultIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelement(2, "path", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke", ctx.iconColor);
    } }, encapsulation: 2 });
AttachmentDefaultIcon.propDecorators = {
    iconColor: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentDefaultIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--attachment-default]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--attachment-default"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.75 46.5H8.75C7.09315 46.5 5.75 45.1569 5.75 43.5V11.25"
        [attr.stroke]="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.25 36.318C43.2959 38.2996 41.7314 39.9455 39.75 40H15.25C13.2687 39.9455 11.7041 38.2996 11.75 36.318V5.182C11.7041 3.20043 13.2687 1.55453 15.25 1.5H33.05C33.9882 1.50471 34.8834 1.89443 35.526 2.578L42.224 9.626C42.886 10.3295 43.2532 11.26 43.25 12.226V36.318Z"
        [attr.stroke]="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `
            }]
    }], function () { return []; }, { iconColor: [{
            type: Input
        }] }); })();

class AttachmentDOCIcon {
    constructor() {
        this.iconColor = '';
    }
}
AttachmentDOCIcon.ɵfac = function AttachmentDOCIcon_Factory(t) { return new (t || AttachmentDOCIcon)(); };
AttachmentDOCIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttachmentDOCIcon, selectors: [["", "sfui-svg-icon--attachment-doc", ""]], inputs: { iconColor: "iconColor" }, attrs: _c14, decls: 6, vars: 5, consts: [["viewBox", "0 0 48 48", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--attachment-doc"], ["d", "M35.25 46.5H8.25C6.59315 46.5 5.25 45.1569 5.25 43.5V11.25", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M42.75 36.318C42.7959 38.2996 41.2314 39.9455 39.25 40H14.75C12.7687 39.9455 11.2041 38.2996 11.25 36.318V5.182C11.2041 3.20043 12.7687 1.55453 14.75 1.5H32.55C33.4882 1.50471 34.3834 1.89443 35.026 2.578L41.724 9.626C42.386 10.3295 42.7532 11.26 42.75 12.226V36.318Z", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"], ["d", "M18.7036 28.0527V32.75H20.0903C20.8 32.75 21.2948 32.4001 21.5747 31.7002C21.7277 31.3161 21.8042 30.8587 21.8042 30.3281C21.8042 29.5957 21.6886 29.0342 21.4575 28.6436C21.2297 28.2497 20.7739 28.0527 20.0903 28.0527H18.7036ZM20.3442 26.8027C20.7902 26.8092 21.1613 26.8613 21.4575 26.959C21.9621 27.125 22.3706 27.4294 22.6831 27.8721C22.9338 28.2301 23.1047 28.6175 23.1958 29.0342C23.2869 29.4508 23.3325 29.848 23.3325 30.2256C23.3325 31.1826 23.1405 31.9932 22.7563 32.6572C22.2355 33.5524 21.4315 34 20.3442 34H17.2437V26.8027H20.3442Z"], ["d", "M28.0538 32.9258C28.6495 32.9258 29.1215 32.7061 29.4698 32.2666C29.8214 31.8271 29.9972 31.2021 29.9972 30.3916C29.9972 29.5843 29.8214 28.9609 29.4698 28.5215C29.1215 28.0788 28.6495 27.8574 28.0538 27.8574C27.4581 27.8574 26.9828 28.0771 26.628 28.5166C26.2732 28.9561 26.0958 29.5811 26.0958 30.3916C26.0958 31.2021 26.2732 31.8271 26.628 32.2666C26.9828 32.7061 27.4581 32.9258 28.0538 32.9258ZM31.5011 30.3916C31.5011 31.6839 31.1381 32.6735 30.4122 33.3604C29.8686 33.9202 29.0825 34.2002 28.0538 34.2002C27.0252 34.2002 26.239 33.9202 25.6954 33.3604C24.9662 32.6735 24.6017 31.6839 24.6017 30.3916C24.6017 29.0732 24.9662 28.0837 25.6954 27.4229C26.239 26.863 27.0252 26.583 28.0538 26.583C29.0825 26.583 29.8686 26.863 30.4122 27.4229C31.1381 28.0837 31.5011 29.0732 31.5011 30.3916Z"], ["d", "M32.7409 30.46C32.7409 29.2035 33.0778 28.235 33.7517 27.5547C34.3376 26.9622 35.083 26.666 35.988 26.666C37.1989 26.666 38.0843 27.0632 38.6442 27.8574C38.9535 28.3034 39.1195 28.751 39.1423 29.2002H37.6384C37.5407 28.8551 37.4154 28.5947 37.2624 28.4189C36.989 28.1064 36.5837 27.9502 36.0466 27.9502C35.4997 27.9502 35.0684 28.1715 34.7526 28.6143C34.4369 29.0537 34.279 29.6771 34.279 30.4844C34.279 31.2917 34.445 31.8971 34.7771 32.3008C35.1123 32.7012 35.5371 32.9014 36.0515 32.9014C36.5788 32.9014 36.9808 32.7288 37.2575 32.3838C37.4105 32.1982 37.5375 31.9199 37.6384 31.5488H39.1276C38.9974 32.3333 38.6638 32.9714 38.1267 33.4629C37.5928 33.9544 36.9076 34.2002 36.071 34.2002C35.0358 34.2002 34.222 33.8682 33.6296 33.2041C33.0371 32.5368 32.7409 31.6221 32.7409 30.46Z"]], template: function AttachmentDOCIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelement(2, "path", 2);
        ɵngcc0.ɵɵelement(3, "path", 3);
        ɵngcc0.ɵɵelement(4, "path", 4);
        ɵngcc0.ɵɵelement(5, "path", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("fill", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("fill", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("fill", ctx.iconColor);
    } }, encapsulation: 2 });
AttachmentDOCIcon.propDecorators = {
    iconColor: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentDOCIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--attachment-doc]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--attachment-doc"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.25 46.5H8.25C6.59315 46.5 5.25 45.1569 5.25 43.5V11.25"
        [attr.stroke]="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.75 36.318C42.7959 38.2996 41.2314 39.9455 39.25 40H14.75C12.7687 39.9455 11.2041 38.2996 11.25 36.318V5.182C11.2041 3.20043 12.7687 1.55453 14.75 1.5H32.55C33.4882 1.50471 34.3834 1.89443 35.026 2.578L41.724 9.626C42.386 10.3295 42.7532 11.26 42.75 12.226V36.318Z"
        [attr.stroke]="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.7036 28.0527V32.75H20.0903C20.8 32.75 21.2948 32.4001 21.5747 31.7002C21.7277 31.3161 21.8042 30.8587 21.8042 30.3281C21.8042 29.5957 21.6886 29.0342 21.4575 28.6436C21.2297 28.2497 20.7739 28.0527 20.0903 28.0527H18.7036ZM20.3442 26.8027C20.7902 26.8092 21.1613 26.8613 21.4575 26.959C21.9621 27.125 22.3706 27.4294 22.6831 27.8721C22.9338 28.2301 23.1047 28.6175 23.1958 29.0342C23.2869 29.4508 23.3325 29.848 23.3325 30.2256C23.3325 31.1826 23.1405 31.9932 22.7563 32.6572C22.2355 33.5524 21.4315 34 20.3442 34H17.2437V26.8027H20.3442Z"
        [attr.fill]="iconColor"
      />
      <path
        d="M28.0538 32.9258C28.6495 32.9258 29.1215 32.7061 29.4698 32.2666C29.8214 31.8271 29.9972 31.2021 29.9972 30.3916C29.9972 29.5843 29.8214 28.9609 29.4698 28.5215C29.1215 28.0788 28.6495 27.8574 28.0538 27.8574C27.4581 27.8574 26.9828 28.0771 26.628 28.5166C26.2732 28.9561 26.0958 29.5811 26.0958 30.3916C26.0958 31.2021 26.2732 31.8271 26.628 32.2666C26.9828 32.7061 27.4581 32.9258 28.0538 32.9258ZM31.5011 30.3916C31.5011 31.6839 31.1381 32.6735 30.4122 33.3604C29.8686 33.9202 29.0825 34.2002 28.0538 34.2002C27.0252 34.2002 26.239 33.9202 25.6954 33.3604C24.9662 32.6735 24.6017 31.6839 24.6017 30.3916C24.6017 29.0732 24.9662 28.0837 25.6954 27.4229C26.239 26.863 27.0252 26.583 28.0538 26.583C29.0825 26.583 29.8686 26.863 30.4122 27.4229C31.1381 28.0837 31.5011 29.0732 31.5011 30.3916Z"
        [attr.fill]="iconColor"
      />
      <path
        d="M32.7409 30.46C32.7409 29.2035 33.0778 28.235 33.7517 27.5547C34.3376 26.9622 35.083 26.666 35.988 26.666C37.1989 26.666 38.0843 27.0632 38.6442 27.8574C38.9535 28.3034 39.1195 28.751 39.1423 29.2002H37.6384C37.5407 28.8551 37.4154 28.5947 37.2624 28.4189C36.989 28.1064 36.5837 27.9502 36.0466 27.9502C35.4997 27.9502 35.0684 28.1715 34.7526 28.6143C34.4369 29.0537 34.279 29.6771 34.279 30.4844C34.279 31.2917 34.445 31.8971 34.7771 32.3008C35.1123 32.7012 35.5371 32.9014 36.0515 32.9014C36.5788 32.9014 36.9808 32.7288 37.2575 32.3838C37.4105 32.1982 37.5375 31.9199 37.6384 31.5488H39.1276C38.9974 32.3333 38.6638 32.9714 38.1267 33.4629C37.5928 33.9544 36.9076 34.2002 36.071 34.2002C35.0358 34.2002 34.222 33.8682 33.6296 33.2041C33.0371 32.5368 32.7409 31.6221 32.7409 30.46Z"
        [attr.fill]="iconColor"
      />
    </svg>
  `
            }]
    }], function () { return []; }, { iconColor: [{
            type: Input
        }] }); })();

class AttachmentImageIcon {
    constructor() {
        this.iconColor = '';
    }
}
AttachmentImageIcon.ɵfac = function AttachmentImageIcon_Factory(t) { return new (t || AttachmentImageIcon)(); };
AttachmentImageIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttachmentImageIcon, selectors: [["", "sfui-svg-icon--attachment-image", ""]], inputs: { iconColor: "iconColor" }, attrs: _c15, decls: 4, vars: 3, consts: [["viewBox", "0 0 48 48", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--attachment-image"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M14.1602 20.75C16.2312 20.75 17.9102 19.0711 17.9102 17C17.9102 14.9289 16.2312 13.25 14.1602 13.25C12.0891 13.25 10.4102 14.9289 10.4102 17C10.4102 19.0711 12.0891 20.75 14.1602 20.75Z", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"], ["d", "M40.4001 33.9101L31.6561 20.8001C31.3464 20.3369 30.8282 20.0564 30.271 20.0504C29.7139 20.0444 29.1897 20.3137 28.8701 20.7701L24.3801 27.2001L21.6001 24.9661C21.2309 24.6703 20.7545 24.5432 20.287 24.6159C19.8195 24.6885 19.4041 24.9542 19.1421 25.3481L13.4121 33.9481", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.5 6.0459C2.84315 6.0459 1.5 7.38904 1.5 9.0459V38.9539C1.5 40.6108 2.84315 41.9539 4.5 41.9539H43.5C45.1569 41.9539 46.5 40.6108 46.5 38.9539V14.9539C46.4999 14.1715 46.1942 13.4201 45.648 12.8599L39.882 6.9499C39.3171 6.37141 38.5426 6.04545 37.734 6.0459H4.5Z", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"]], template: function AttachmentImageIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelement(2, "path", 2);
        ɵngcc0.ɵɵelement(3, "path", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke", ctx.iconColor);
    } }, encapsulation: 2 });
AttachmentImageIcon.propDecorators = {
    iconColor: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentImageIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--attachment-image]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--attachment-image"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1602 20.75C16.2312 20.75 17.9102 19.0711 17.9102 17C17.9102 14.9289 16.2312 13.25 14.1602 13.25C12.0891 13.25 10.4102 14.9289 10.4102 17C10.4102 19.0711 12.0891 20.75 14.1602 20.75Z"
        [attr.stroke]="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M40.4001 33.9101L31.6561 20.8001C31.3464 20.3369 30.8282 20.0564 30.271 20.0504C29.7139 20.0444 29.1897 20.3137 28.8701 20.7701L24.3801 27.2001L21.6001 24.9661C21.2309 24.6703 20.7545 24.5432 20.287 24.6159C19.8195 24.6885 19.4041 24.9542 19.1421 25.3481L13.4121 33.9481"
        [attr.stroke]="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.5 6.0459C2.84315 6.0459 1.5 7.38904 1.5 9.0459V38.9539C1.5 40.6108 2.84315 41.9539 4.5 41.9539H43.5C45.1569 41.9539 46.5 40.6108 46.5 38.9539V14.9539C46.4999 14.1715 46.1942 13.4201 45.648 12.8599L39.882 6.9499C39.3171 6.37141 38.5426 6.04545 37.734 6.0459H4.5Z"
        [attr.stroke]="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `
            }]
    }], function () { return []; }, { iconColor: [{
            type: Input
        }] }); })();

class AttachmentPDFIcon {
    constructor() {
        this.iconColor = '';
    }
}
AttachmentPDFIcon.ɵfac = function AttachmentPDFIcon_Factory(t) { return new (t || AttachmentPDFIcon)(); };
AttachmentPDFIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttachmentPDFIcon, selectors: [["", "sfui-svg-icon--attachment-pdf", ""]], inputs: { iconColor: "iconColor" }, attrs: _c16, decls: 6, vars: 5, consts: [["viewBox", "0 0 49 48", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--attachment-pdf"], ["d", "M35.75 46.5H8.75C7.09315 46.5 5.75 45.1569 5.75 43.5V11.25", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M43.25 36.318C43.2959 38.2996 41.7314 39.9455 39.75 40H15.25C13.2687 39.9455 11.7041 38.2996 11.75 36.318V5.182C11.7041 3.20043 13.2687 1.55453 15.25 1.5H33.05C33.9882 1.50471 34.8834 1.89443 35.526 2.578L42.224 9.626C42.886 10.3295 43.2532 11.26 43.25 12.226V36.318Z", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"], ["d", "M23.9097 29.0928C23.9097 28.7184 23.8104 28.4515 23.6118 28.292C23.4165 28.1325 23.1414 28.0527 22.7866 28.0527H21.3853V30.1719H22.7866C23.1414 30.1719 23.4165 30.0856 23.6118 29.9131C23.8104 29.7406 23.9097 29.4671 23.9097 29.0928ZM25.3989 29.083C25.3989 29.9326 25.1841 30.5332 24.7544 30.8848C24.3247 31.2363 23.7111 31.4121 22.9136 31.4121H21.3853V34H19.8911V26.8027H23.0259C23.7485 26.8027 24.3247 26.9883 24.7544 27.3594C25.1841 27.7305 25.3989 28.305 25.3989 29.083Z"], ["d", "M28.3868 28.0527V32.75H29.7735C30.4832 32.75 30.978 32.4001 31.2579 31.7002C31.4109 31.3161 31.4874 30.8587 31.4874 30.3281C31.4874 29.5957 31.3718 29.0342 31.1407 28.6436C30.9129 28.2497 30.4571 28.0527 29.7735 28.0527H28.3868ZM30.0274 26.8027C30.4734 26.8092 30.8445 26.8613 31.1407 26.959C31.6453 27.125 32.0538 27.4294 32.3663 27.8721C32.617 28.2301 32.7879 28.6175 32.879 29.0342C32.9701 29.4508 33.0157 29.848 33.0157 30.2256C33.0157 31.1826 32.8237 31.9932 32.4395 32.6572C31.9187 33.5524 31.1147 34 30.0274 34H26.9269V26.8027H30.0274Z"], ["d", "M34.5534 26.8125H39.656V28.0771H36.0476V29.7324H39.2067V30.9824H36.0476V34H34.5534V26.8125Z"]], template: function AttachmentPDFIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelement(2, "path", 2);
        ɵngcc0.ɵɵelement(3, "path", 3);
        ɵngcc0.ɵɵelement(4, "path", 4);
        ɵngcc0.ɵɵelement(5, "path", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("fill", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("fill", ctx.iconColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("fill", ctx.iconColor);
    } }, encapsulation: 2 });
AttachmentPDFIcon.propDecorators = {
    iconColor: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentPDFIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--attachment-pdf]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--attachment-pdf"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.75 46.5H8.75C7.09315 46.5 5.75 45.1569 5.75 43.5V11.25"
        [attr.stroke]="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.25 36.318C43.2959 38.2996 41.7314 39.9455 39.75 40H15.25C13.2687 39.9455 11.7041 38.2996 11.75 36.318V5.182C11.7041 3.20043 13.2687 1.55453 15.25 1.5H33.05C33.9882 1.50471 34.8834 1.89443 35.526 2.578L42.224 9.626C42.886 10.3295 43.2532 11.26 43.25 12.226V36.318Z"
        [attr.stroke]="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.9097 29.0928C23.9097 28.7184 23.8104 28.4515 23.6118 28.292C23.4165 28.1325 23.1414 28.0527 22.7866 28.0527H21.3853V30.1719H22.7866C23.1414 30.1719 23.4165 30.0856 23.6118 29.9131C23.8104 29.7406 23.9097 29.4671 23.9097 29.0928ZM25.3989 29.083C25.3989 29.9326 25.1841 30.5332 24.7544 30.8848C24.3247 31.2363 23.7111 31.4121 22.9136 31.4121H21.3853V34H19.8911V26.8027H23.0259C23.7485 26.8027 24.3247 26.9883 24.7544 27.3594C25.1841 27.7305 25.3989 28.305 25.3989 29.083Z"
        [attr.fill]="iconColor"
      />
      <path
        d="M28.3868 28.0527V32.75H29.7735C30.4832 32.75 30.978 32.4001 31.2579 31.7002C31.4109 31.3161 31.4874 30.8587 31.4874 30.3281C31.4874 29.5957 31.3718 29.0342 31.1407 28.6436C30.9129 28.2497 30.4571 28.0527 29.7735 28.0527H28.3868ZM30.0274 26.8027C30.4734 26.8092 30.8445 26.8613 31.1407 26.959C31.6453 27.125 32.0538 27.4294 32.3663 27.8721C32.617 28.2301 32.7879 28.6175 32.879 29.0342C32.9701 29.4508 33.0157 29.848 33.0157 30.2256C33.0157 31.1826 32.8237 31.9932 32.4395 32.6572C31.9187 33.5524 31.1147 34 30.0274 34H26.9269V26.8027H30.0274Z"
        [attr.fill]="iconColor"
      />
      <path
        d="M34.5534 26.8125H39.656V28.0771H36.0476V29.7324H39.2067V30.9824H36.0476V34H34.5534V26.8125Z"
        [attr.fill]="iconColor"
      />
    </svg>
  `
            }]
    }], function () { return []; }, { iconColor: [{
            type: Input
        }] }); })();

class ZoomInIcon {
}
ZoomInIcon.ɵfac = function ZoomInIcon_Factory(t) { return new (t || ZoomInIcon)(); };
ZoomInIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ZoomInIcon, selectors: [["", "sfui-svg-icon--zoom-in", ""]], attrs: _c17, decls: 2, vars: 0, consts: [["viewBox", "0 0 32 32", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--zoom-in"], ["d", "M20.6667 18.6667H19.6133L19.24 18.3067C20.5467 16.7867 21.3333 14.8133 21.3333 12.6667C21.3333 7.88 17.4533 4 12.6667 4C7.88 4 4 7.88 4 12.6667C4 17.4533 7.88 21.3333 12.6667 21.3333C14.8133 21.3333 16.7867 20.5467 18.3067 19.24L18.6667 19.6133V20.6667L25.3333 27.32L27.32 25.3333L20.6667 18.6667ZM12.6667 18.6667C9.34667 18.6667 6.66667 15.9867 6.66667 12.6667C6.66667 9.34667 9.34667 6.66667 12.6667 6.66667C15.9867 6.66667 18.6667 9.34667 18.6667 12.6667C18.6667 15.9867 15.9867 18.6667 12.6667 18.6667ZM13.3333 9.33333H12V12H9.33333V13.3333H12V16H13.3333V13.3333H16V12H13.3333V9.33333Z", "fill", "white"]], template: function ZoomInIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ZoomInIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--zoom-in]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--zoom-in"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6667 18.6667H19.6133L19.24 18.3067C20.5467 16.7867 21.3333 14.8133 21.3333 12.6667C21.3333 7.88 17.4533 4 12.6667 4C7.88 4 4 7.88 4 12.6667C4 17.4533 7.88 21.3333 12.6667 21.3333C14.8133 21.3333 16.7867 20.5467 18.3067 19.24L18.6667 19.6133V20.6667L25.3333 27.32L27.32 25.3333L20.6667 18.6667ZM12.6667 18.6667C9.34667 18.6667 6.66667 15.9867 6.66667 12.6667C6.66667 9.34667 9.34667 6.66667 12.6667 6.66667C15.9867 6.66667 18.6667 9.34667 18.6667 12.6667C18.6667 15.9867 15.9867 18.6667 12.6667 18.6667ZM13.3333 9.33333H12V12H9.33333V13.3333H12V16H13.3333V13.3333H16V12H13.3333V9.33333Z"
        fill="white"
      />
    </svg>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();

class ZoomOutIcon {
}
ZoomOutIcon.ɵfac = function ZoomOutIcon_Factory(t) { return new (t || ZoomOutIcon)(); };
ZoomOutIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ZoomOutIcon, selectors: [["", "sfui-svg-icon--zoom-out", ""]], attrs: _c18, decls: 2, vars: 0, consts: [["viewBox", "0 0 32 32", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--zoom-out"], ["d", "M20.6667 18.6667H19.6133L19.24 18.3067C20.5467 16.7867 21.3333 14.8133 21.3333 12.6667C21.3333 7.88 17.4533 4 12.6667 4C7.88 4 4 7.88 4 12.6667C4 17.4533 7.88 21.3333 12.6667 21.3333C14.8133 21.3333 16.7867 20.5467 18.3067 19.24L18.6667 19.6133V20.6667L25.3333 27.32L27.32 25.3333L20.6667 18.6667ZM12.6667 18.6667C9.34667 18.6667 6.66667 15.9867 6.66667 12.6667C6.66667 9.34667 9.34667 6.66667 12.6667 6.66667C15.9867 6.66667 18.6667 9.34667 18.6667 12.6667C18.6667 15.9867 15.9867 18.6667 12.6667 18.6667ZM9.33333 12H16V13.3333H9.33333V12Z", "fill", "white"]], template: function ZoomOutIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ZoomOutIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--zoom-out]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--zoom-out"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6667 18.6667H19.6133L19.24 18.3067C20.5467 16.7867 21.3333 14.8133 21.3333 12.6667C21.3333 7.88 17.4533 4 12.6667 4C7.88 4 4 7.88 4 12.6667C4 17.4533 7.88 21.3333 12.6667 21.3333C14.8133 21.3333 16.7867 20.5467 18.3067 19.24L18.6667 19.6133V20.6667L25.3333 27.32L27.32 25.3333L20.6667 18.6667ZM12.6667 18.6667C9.34667 18.6667 6.66667 15.9867 6.66667 12.6667C6.66667 9.34667 9.34667 6.66667 12.6667 6.66667C15.9867 6.66667 18.6667 9.34667 18.6667 12.6667C18.6667 15.9867 15.9867 18.6667 12.6667 18.6667ZM9.33333 12H16V13.3333H9.33333V12Z"
        fill="white"
      />
    </svg>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();

class UndoIcon {
}
UndoIcon.ɵfac = function UndoIcon_Factory(t) { return new (t || UndoIcon)(); };
UndoIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UndoIcon, selectors: [["", "sfui-svg-icon--undo", ""]], attrs: _c19, decls: 2, vars: 0, consts: [["viewBox", "0 0 24 24", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--undo"], ["d", "M12.5 8C9.85 8 7.45 8.99 5.6 10.6L2 7V16H11L7.38 12.38C8.77 11.22 10.54 10.5 12.5 10.5C16.04 10.5 19.05 12.81 20.1 16L22.47 15.22C21.08 11.03 17.15 8 12.5 8Z", "fill", "white"]], template: function UndoIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UndoIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--undo]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--undo"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 8C9.85 8 7.45 8.99 5.6 10.6L2 7V16H11L7.38 12.38C8.77 11.22 10.54 10.5 12.5 10.5C16.04 10.5 19.05 12.81 20.1 16L22.47 15.22C21.08 11.03 17.15 8 12.5 8Z"
        fill="white"
      />
    </svg>
  `
            }]
    }], null, null); })();

class AddTextIcon {
}
AddTextIcon.ɵfac = function AddTextIcon_Factory(t) { return new (t || AddTextIcon)(); };
AddTextIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AddTextIcon, selectors: [["", "sfui-svg-icon--add-text", ""]], attrs: _c20, decls: 2, vars: 0, consts: [["viewBox", "0 0 28 28", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--add-text"], ["d", "M26.8332 8.16602V1.16602H19.8332V3.49935H8.1665V1.16602H1.1665V8.16602H3.49984V19.8327H1.1665V26.8327H8.1665V24.4993H19.8332V26.8327H26.8332V19.8327H24.4998V8.16602H26.8332ZM3.49984 3.49935H5.83317V5.83268H3.49984V3.49935ZM5.83317 24.4993H3.49984V22.166H5.83317V24.4993ZM19.8332 22.166H8.1665V19.8327H5.83317V8.16602H8.1665V5.83268H19.8332V8.16602H22.1665V19.8327H19.8332V22.166ZM24.4998 24.4993H22.1665V22.166H24.4998V24.4993ZM22.1665 5.83268V3.49935H24.4998V5.83268H22.1665ZM16.0182 16.3327H11.9465L11.0948 18.666H9.20484L13.1715 8.16602H14.8048L18.7832 18.666H16.8815L16.0182 16.3327ZM12.4715 14.8627H15.5165L13.9998 10.3943L12.4715 14.8627Z", "fill", "white"]], template: function AddTextIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddTextIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--add-text]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--add-text"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.8332 8.16602V1.16602H19.8332V3.49935H8.1665V1.16602H1.1665V8.16602H3.49984V19.8327H1.1665V26.8327H8.1665V24.4993H19.8332V26.8327H26.8332V19.8327H24.4998V8.16602H26.8332ZM3.49984 3.49935H5.83317V5.83268H3.49984V3.49935ZM5.83317 24.4993H3.49984V22.166H5.83317V24.4993ZM19.8332 22.166H8.1665V19.8327H5.83317V8.16602H8.1665V5.83268H19.8332V8.16602H22.1665V19.8327H19.8332V22.166ZM24.4998 24.4993H22.1665V22.166H24.4998V24.4993ZM22.1665 5.83268V3.49935H24.4998V5.83268H22.1665ZM16.0182 16.3327H11.9465L11.0948 18.666H9.20484L13.1715 8.16602H14.8048L18.7832 18.666H16.8815L16.0182 16.3327ZM12.4715 14.8627H15.5165L13.9998 10.3943L12.4715 14.8627Z"
        fill="white"
      />
    </svg>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();

class RotateIcon {
}
RotateIcon.ɵfac = function RotateIcon_Factory(t) { return new (t || RotateIcon)(); };
RotateIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RotateIcon, selectors: [["", "sfui-svg-icon--rotate", ""]], attrs: _c21, decls: 2, vars: 0, consts: [["viewBox", "0 0 28 28", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--rotate"], ["d", "M8.56342 7.47838L1.00342 15.0501L8.57508 22.6101L16.1468 15.0501L8.56342 7.47838ZM4.30508 15.0501L8.57508 10.7801L12.8334 15.0501L8.56342 19.3201L4.30508 15.0501ZM22.5868 7.74672C20.5451 5.69339 17.8501 4.66672 15.1668 4.66672V0.886719L10.2201 5.83338L15.1668 10.7801V7.00005C17.2551 7.00005 19.3434 7.79339 20.9418 9.39172C24.1268 12.5767 24.1268 17.7567 20.9418 20.9417C19.3434 22.5401 17.2551 23.3334 15.1668 23.3334C14.0351 23.3334 12.9034 23.0884 11.8534 22.6217L10.1151 24.3601C11.6901 25.2234 13.4284 25.6667 15.1668 25.6667C17.8501 25.6667 20.5451 24.6401 22.5868 22.5867C26.6934 18.4917 26.6934 11.8417 22.5868 7.74672Z", "fill", "white"]], template: function RotateIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RotateIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--rotate]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--rotate"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.56342 7.47838L1.00342 15.0501L8.57508 22.6101L16.1468 15.0501L8.56342 7.47838ZM4.30508 15.0501L8.57508 10.7801L12.8334 15.0501L8.56342 19.3201L4.30508 15.0501ZM22.5868 7.74672C20.5451 5.69339 17.8501 4.66672 15.1668 4.66672V0.886719L10.2201 5.83338L15.1668 10.7801V7.00005C17.2551 7.00005 19.3434 7.79339 20.9418 9.39172C24.1268 12.5767 24.1268 17.7567 20.9418 20.9417C19.3434 22.5401 17.2551 23.3334 15.1668 23.3334C14.0351 23.3334 12.9034 23.0884 11.8534 22.6217L10.1151 24.3601C11.6901 25.2234 13.4284 25.6667 15.1668 25.6667C17.8501 25.6667 20.5451 24.6401 22.5868 22.5867C26.6934 18.4917 26.6934 11.8417 22.5868 7.74672Z"
        fill="white"
      />
    </svg>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();

class BrushIcon {
}
BrushIcon.ɵfac = function BrushIcon_Factory(t) { return new (t || BrushIcon)(); };
BrushIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BrushIcon, selectors: [["", "sfui-svg-icon--brush", ""]], attrs: _c22, decls: 2, vars: 0, consts: [["viewBox", "0 0 28 28", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--brush"], ["d", "M8.16683 18.6667C8.8085 18.6667 9.3335 19.1917 9.3335 19.8333C9.3335 21.1167 8.2835 22.1667 7.00016 22.1667C6.80183 22.1667 6.61516 22.1433 6.41683 22.1083C6.7785 21.4667 7.00016 20.6967 7.00016 19.8333C7.00016 19.1917 7.52516 18.6667 8.16683 18.6667ZM21.7818 3.5C21.4785 3.5 21.1868 3.61667 20.9535 3.83833L10.5002 14.2917L13.7085 17.5L24.1618 7.04667C24.6168 6.59167 24.6168 5.85667 24.1618 5.40167L22.5985 3.83833C22.3652 3.605 22.0735 3.5 21.7818 3.5ZM8.16683 16.3333C6.23016 16.3333 4.66683 17.8967 4.66683 19.8333C4.66683 21.3617 3.3135 22.1667 2.3335 22.1667C3.40683 23.59 5.2385 24.5 7.00016 24.5C9.5785 24.5 11.6668 22.4117 11.6668 19.8333C11.6668 17.8967 10.1035 16.3333 8.16683 16.3333Z", "fill", "white", "fill-opacity", "0.74"]], template: function BrushIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrushIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--brush]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--brush"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.16683 18.6667C8.8085 18.6667 9.3335 19.1917 9.3335 19.8333C9.3335 21.1167 8.2835 22.1667 7.00016 22.1667C6.80183 22.1667 6.61516 22.1433 6.41683 22.1083C6.7785 21.4667 7.00016 20.6967 7.00016 19.8333C7.00016 19.1917 7.52516 18.6667 8.16683 18.6667ZM21.7818 3.5C21.4785 3.5 21.1868 3.61667 20.9535 3.83833L10.5002 14.2917L13.7085 17.5L24.1618 7.04667C24.6168 6.59167 24.6168 5.85667 24.1618 5.40167L22.5985 3.83833C22.3652 3.605 22.0735 3.5 21.7818 3.5ZM8.16683 16.3333C6.23016 16.3333 4.66683 17.8967 4.66683 19.8333C4.66683 21.3617 3.3135 22.1667 2.3335 22.1667C3.40683 23.59 5.2385 24.5 7.00016 24.5C9.5785 24.5 11.6668 22.4117 11.6668 19.8333C11.6668 17.8967 10.1035 16.3333 8.16683 16.3333Z"
        fill="white"
        fill-opacity="0.74"
      />
    </svg>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();

class CheckIcon {
    constructor() {
        this.iconColor = '';
    }
}
CheckIcon.ɵfac = function CheckIcon_Factory(t) { return new (t || CheckIcon)(); };
CheckIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CheckIcon, selectors: [["", "sfui-svg-icon--check", ""]], inputs: { iconColor: "iconColor" }, attrs: _c23, decls: 2, vars: 1, consts: [["viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--check"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"]], template: function CheckIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("fill", ctx.iconColor);
    } }, encapsulation: 2 });
CheckIcon.propDecorators = {
    iconColor: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--check]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--check"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
        [attr.fill]="iconColor"
      />
    </svg>
  `
            }]
    }], function () { return []; }, { iconColor: [{
            type: Input
        }] }); })();

class RemoveIcon {
}
RemoveIcon.ɵfac = function RemoveIcon_Factory(t) { return new (t || RemoveIcon)(); };
RemoveIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RemoveIcon, selectors: [["", "sfui-svg-icon--remove", ""]], attrs: _c24, decls: 2, vars: 0, consts: [["viewBox", "0 0 28 28", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sfui-svg-icon", "sfui-svg-icon--remove"], ["d", "M16.4735 12.215L14.0002 14.6883L11.5152 12.215L9.87016 13.86L12.3552 16.3333L9.88183 18.8067L11.5268 20.4517L14.0002 17.9783L16.4735 20.4517L18.1185 18.8067L15.6452 16.3333L18.1185 13.86L16.4735 12.215ZM18.0835 4.66667L16.9168 3.5H11.0835L9.91683 4.66667H5.8335V7H22.1668V4.66667H18.0835ZM7.00016 22.1667C7.00016 23.45 8.05016 24.5 9.3335 24.5H18.6668C19.9502 24.5 21.0002 23.45 21.0002 22.1667V8.16667H7.00016V22.1667ZM9.3335 10.5H18.6668V22.1667H9.3335V10.5Z", "fill", "white"]], template: function RemoveIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RemoveIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--remove]',
                template: `
    <svg
      class="sfui-svg-icon sfui-svg-icon--remove"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4735 12.215L14.0002 14.6883L11.5152 12.215L9.87016 13.86L12.3552 16.3333L9.88183 18.8067L11.5268 20.4517L14.0002 17.9783L16.4735 20.4517L18.1185 18.8067L15.6452 16.3333L18.1185 13.86L16.4735 12.215ZM18.0835 4.66667L16.9168 3.5H11.0835L9.91683 4.66667H5.8335V7H22.1668V4.66667H18.0835ZM7.00016 22.1667C7.00016 23.45 8.05016 24.5 9.3335 24.5H18.6668C19.9502 24.5 21.0002 23.45 21.0002 22.1667V8.16667H7.00016V22.1667ZM9.3335 10.5H18.6668V22.1667H9.3335V10.5Z"
        fill="white"
      />
    </svg>
  `
            }]
    }], null, null); })();

class EditIcon {
}
EditIcon.ɵfac = function EditIcon_Factory(t) { return new (t || EditIcon)(); };
EditIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EditIcon, selectors: [["", "sfui-svg-icon--edit", ""]], attrs: _c25, decls: 2, vars: 0, consts: [["width", "19", "height", "18", "viewBox", "0 0 19 18", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z", "fill", "white"]], template: function EditIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "path", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditIcon, [{
        type: Component,
        args: [{
                selector: '[sfui-svg-icon--edit]',
                template: `
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
        fill="white"
      />
    </svg>
  `
            }]
    }], null, null); })();

class SfuiSvgIconModule {
}
SfuiSvgIconModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiSvgIconModule });
SfuiSvgIconModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiSvgIconModule_Factory(t) { return new (t || SfuiSvgIconModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiSvgIconModule, { declarations: function () { return [CloseIcon, DownloadIcon, ArrowIcon, RefreshIcon, TickIcon, AttachmentDefaultIcon, AttachmentDOCIcon, AttachmentImageIcon, AttachmentPDFIcon, ZoomInIcon, ZoomOutIcon, UndoIcon, AddTextIcon, RotateIcon, BrushIcon, CheckIcon, RemoveIcon, EditIcon]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CloseIcon, DownloadIcon, ArrowIcon, RefreshIcon, TickIcon, AttachmentDefaultIcon, AttachmentDOCIcon, AttachmentImageIcon, AttachmentPDFIcon, ZoomInIcon, ZoomOutIcon, UndoIcon, AddTextIcon, RotateIcon, BrushIcon, CheckIcon, RemoveIcon, EditIcon]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiSvgIconModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CloseIcon,
                    DownloadIcon,
                    ArrowIcon,
                    RefreshIcon,
                    TickIcon,
                    AttachmentDefaultIcon,
                    AttachmentDOCIcon,
                    AttachmentImageIcon,
                    AttachmentPDFIcon,
                    ZoomInIcon,
                    ZoomOutIcon,
                    UndoIcon,
                    AddTextIcon,
                    RotateIcon,
                    BrushIcon,
                    CheckIcon,
                    RemoveIcon,
                    EditIcon,
                ],
                imports: [CommonModule],
                exports: [
                    CloseIcon,
                    DownloadIcon,
                    ArrowIcon,
                    RefreshIcon,
                    TickIcon,
                    AttachmentDefaultIcon,
                    AttachmentDOCIcon,
                    AttachmentImageIcon,
                    AttachmentPDFIcon,
                    ZoomInIcon,
                    ZoomOutIcon,
                    UndoIcon,
                    AddTextIcon,
                    RotateIcon,
                    BrushIcon,
                    CheckIcon,
                    RemoveIcon,
                    EditIcon,
                ],
                providers: []
            }]
    }], null, null); })();

class UserItem {
    constructor() {
        this.hostClass = ['sfui-user-item'];
        this.itemClick = new EventEmitter();
    }
    onClick(event) {
        this.itemClick.emit(event);
    }
}
UserItem.ɵfac = function UserItem_Factory(t) { return new (t || UserItem)(); };
UserItem.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UserItem, selectors: [["sfui-user-item"]], hostVars: 2, hostBindings: function UserItem_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, outputs: { itemClick: "itemClick" }, ngContentSelectors: _c27, decls: 9, vars: 0, consts: [[1, "sfui-user-item__container", 3, "click"], [1, "sfui-user-item__content-container"], [1, "sfui-user-item__content"], [1, "sfui-user-item__suffix"]], template: function UserItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c26);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function UserItem_Template_div_click_0_listener($event) { return ctx.onClick($event); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵprojection(5, 2);
        ɵngcc0.ɵɵprojection(6, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵprojection(8, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [_c28] });
UserItem.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    itemClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserItem, [{
        type: Component,
        args: [{
                selector: 'sfui-user-item',
                template: "<div class=\"sfui-user-item__container\" (click)=\"onClick($event)\">\n  <div class=\"sfui-user-item__content-container\">\n    <ng-content select=\"sfui-user-item-avatar\"></ng-content>\n    <div class=\"sfui-user-item__content\">\n      <ng-content select=\"sfui-user-item-name\"></ng-content>\n      <ng-content select=\"sfui-user-item-description\"></ng-content>\n      <ng-content select=\"sfui-user-item-content\"></ng-content>\n    </div>\n  </div>\n  <div class=\"sfui-user-item__suffix\">\n    <ng-content select=\"[sfuiSuffix]\"></ng-content>\n  </div>\n</div>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item{display:block;--sfui-user-item-avatar-background:var(--sfui-theme-color-800,#a77332)}::ng-deep .sfui-user-item,::ng-deep .sfui-user-item *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item.material-icons,::ng-deep .sfui-user-item .material-icons{font-family:Material Icons}::ng-deep .sfui-user-item.material-icons-outlined,::ng-deep .sfui-user-item .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-user-item__container{display:flex;flex-direction:row;justify-content:space-between}::ng-deep .sfui-user-item__content-container{display:flex}::ng-deep .sfui-user-item__content{display:block;flex:1 1 0px}::ng-deep .sfui-user-item__suffix{display:flex}::ng-deep .sfui-user-item-avatar{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:16px;line-height:24px;letter-spacing:.15px;width:40px;height:40px;display:inline-flex;justify-content:center;align-items:center;background-color:var(--sfui-user-item-avatar-background,#a77332);border-radius:50%;color:#fff}::ng-deep .sfui-user-item-avatar+.sfui-user-item__content{padding-left:16px}::ng-deep .sfui-user-item-name{font-weight:550;font-size:14px;line-height:24px;letter-spacing:.1px;color:rgba(0,0,0,.87)}::ng-deep .sfui-user-item-description,::ng-deep .sfui-user-item-name{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal}::ng-deep .sfui-user-item-description{display:block;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;text-align:left;color:rgba(0,0,0,.6)}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], itemClick: [{
            type: Output
        }] }); })();

class UserItemAvatar {
    constructor() {
        this.hostClass = ['sfui-user-item-avatar'];
    }
}
UserItemAvatar.ɵfac = function UserItemAvatar_Factory(t) { return new (t || UserItemAvatar)(); };
UserItemAvatar.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UserItemAvatar, selectors: [["sfui-user-item-avatar"]], hostVars: 2, hostBindings: function UserItemAvatar_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, ngContentSelectors: _c3, decls: 1, vars: 0, template: function UserItemAvatar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [_c28] });
UserItemAvatar.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserItemAvatar, [{
        type: Component,
        args: [{
                selector: 'sfui-user-item-avatar',
                template: `<ng-content></ng-content>`,
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item{display:block;--sfui-user-item-avatar-background:var(--sfui-theme-color-800,#a77332)}::ng-deep .sfui-user-item,::ng-deep .sfui-user-item *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item.material-icons,::ng-deep .sfui-user-item .material-icons{font-family:Material Icons}::ng-deep .sfui-user-item.material-icons-outlined,::ng-deep .sfui-user-item .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-user-item__container{display:flex;flex-direction:row;justify-content:space-between}::ng-deep .sfui-user-item__content-container{display:flex}::ng-deep .sfui-user-item__content{display:block;flex:1 1 0px}::ng-deep .sfui-user-item__suffix{display:flex}::ng-deep .sfui-user-item-avatar{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:16px;line-height:24px;letter-spacing:.15px;width:40px;height:40px;display:inline-flex;justify-content:center;align-items:center;background-color:var(--sfui-user-item-avatar-background,#a77332);border-radius:50%;color:#fff}::ng-deep .sfui-user-item-avatar+.sfui-user-item__content{padding-left:16px}::ng-deep .sfui-user-item-name{font-weight:550;font-size:14px;line-height:24px;letter-spacing:.1px;color:rgba(0,0,0,.87)}::ng-deep .sfui-user-item-description,::ng-deep .sfui-user-item-name{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal}::ng-deep .sfui-user-item-description{display:block;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;text-align:left;color:rgba(0,0,0,.6)}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class UserItemName {
    constructor() {
        this.hostClass = ['sfui-user-item-name'];
    }
}
UserItemName.ɵfac = function UserItemName_Factory(t) { return new (t || UserItemName)(); };
UserItemName.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UserItemName, selectors: [["sfui-user-item-name"]], hostVars: 2, hostBindings: function UserItemName_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, ngContentSelectors: _c3, decls: 1, vars: 0, template: function UserItemName_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [_c28] });
UserItemName.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserItemName, [{
        type: Component,
        args: [{
                selector: 'sfui-user-item-name',
                template: `<ng-content></ng-content>`,
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item{display:block;--sfui-user-item-avatar-background:var(--sfui-theme-color-800,#a77332)}::ng-deep .sfui-user-item,::ng-deep .sfui-user-item *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item.material-icons,::ng-deep .sfui-user-item .material-icons{font-family:Material Icons}::ng-deep .sfui-user-item.material-icons-outlined,::ng-deep .sfui-user-item .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-user-item__container{display:flex;flex-direction:row;justify-content:space-between}::ng-deep .sfui-user-item__content-container{display:flex}::ng-deep .sfui-user-item__content{display:block;flex:1 1 0px}::ng-deep .sfui-user-item__suffix{display:flex}::ng-deep .sfui-user-item-avatar{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:16px;line-height:24px;letter-spacing:.15px;width:40px;height:40px;display:inline-flex;justify-content:center;align-items:center;background-color:var(--sfui-user-item-avatar-background,#a77332);border-radius:50%;color:#fff}::ng-deep .sfui-user-item-avatar+.sfui-user-item__content{padding-left:16px}::ng-deep .sfui-user-item-name{font-weight:550;font-size:14px;line-height:24px;letter-spacing:.1px;color:rgba(0,0,0,.87)}::ng-deep .sfui-user-item-description,::ng-deep .sfui-user-item-name{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal}::ng-deep .sfui-user-item-description{display:block;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;text-align:left;color:rgba(0,0,0,.6)}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class UserItemDescription {
    constructor() {
        this.hostClass = ['sfui-user-item-description'];
    }
}
UserItemDescription.ɵfac = function UserItemDescription_Factory(t) { return new (t || UserItemDescription)(); };
UserItemDescription.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UserItemDescription, selectors: [["sfui-user-item-description"]], hostVars: 2, hostBindings: function UserItemDescription_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, ngContentSelectors: _c3, decls: 1, vars: 0, template: function UserItemDescription_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [_c28] });
UserItemDescription.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserItemDescription, [{
        type: Component,
        args: [{
                selector: 'sfui-user-item-description',
                template: `<ng-content></ng-content>`,
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item{display:block;--sfui-user-item-avatar-background:var(--sfui-theme-color-800,#a77332)}::ng-deep .sfui-user-item,::ng-deep .sfui-user-item *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item.material-icons,::ng-deep .sfui-user-item .material-icons{font-family:Material Icons}::ng-deep .sfui-user-item.material-icons-outlined,::ng-deep .sfui-user-item .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-user-item__container{display:flex;flex-direction:row;justify-content:space-between}::ng-deep .sfui-user-item__content-container{display:flex}::ng-deep .sfui-user-item__content{display:block;flex:1 1 0px}::ng-deep .sfui-user-item__suffix{display:flex}::ng-deep .sfui-user-item-avatar{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:16px;line-height:24px;letter-spacing:.15px;width:40px;height:40px;display:inline-flex;justify-content:center;align-items:center;background-color:var(--sfui-user-item-avatar-background,#a77332);border-radius:50%;color:#fff}::ng-deep .sfui-user-item-avatar+.sfui-user-item__content{padding-left:16px}::ng-deep .sfui-user-item-name{font-weight:550;font-size:14px;line-height:24px;letter-spacing:.1px;color:rgba(0,0,0,.87)}::ng-deep .sfui-user-item-description,::ng-deep .sfui-user-item-name{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal}::ng-deep .sfui-user-item-description{display:block;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;text-align:left;color:rgba(0,0,0,.6)}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class UserItemContent {
    constructor() {
        this.hostClass = ['sfui-user-item-content'];
    }
}
UserItemContent.ɵfac = function UserItemContent_Factory(t) { return new (t || UserItemContent)(); };
UserItemContent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UserItemContent, selectors: [["sfui-user-item-content"]], hostVars: 2, hostBindings: function UserItemContent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, ngContentSelectors: _c3, decls: 1, vars: 0, template: function UserItemContent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [_c28] });
UserItemContent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserItemContent, [{
        type: Component,
        args: [{
                selector: 'sfui-user-item-content',
                template: `<ng-content></ng-content>`,
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item{display:block;--sfui-user-item-avatar-background:var(--sfui-theme-color-800,#a77332)}::ng-deep .sfui-user-item,::ng-deep .sfui-user-item *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-user-item.material-icons,::ng-deep .sfui-user-item .material-icons{font-family:Material Icons}::ng-deep .sfui-user-item.material-icons-outlined,::ng-deep .sfui-user-item .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-user-item__container{display:flex;flex-direction:row;justify-content:space-between}::ng-deep .sfui-user-item__content-container{display:flex}::ng-deep .sfui-user-item__content{display:block;flex:1 1 0px}::ng-deep .sfui-user-item__suffix{display:flex}::ng-deep .sfui-user-item-avatar{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:16px;line-height:24px;letter-spacing:.15px;width:40px;height:40px;display:inline-flex;justify-content:center;align-items:center;background-color:var(--sfui-user-item-avatar-background,#a77332);border-radius:50%;color:#fff}::ng-deep .sfui-user-item-avatar+.sfui-user-item__content{padding-left:16px}::ng-deep .sfui-user-item-name{font-weight:550;font-size:14px;line-height:24px;letter-spacing:.1px;color:rgba(0,0,0,.87)}::ng-deep .sfui-user-item-description,::ng-deep .sfui-user-item-name{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal}::ng-deep .sfui-user-item-description{display:block;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;text-align:left;color:rgba(0,0,0,.6)}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class SfuiUserItemModule {
}
SfuiUserItemModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiUserItemModule });
SfuiUserItemModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiUserItemModule_Factory(t) { return new (t || SfuiUserItemModule)(); }, imports: [[CommonModule, SfuiCommonDirectivesModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiUserItemModule, { declarations: function () { return [UserItem, UserItemAvatar, UserItemName, UserItemDescription, UserItemContent]; }, imports: function () { return [CommonModule, SfuiCommonDirectivesModule]; }, exports: function () { return [UserItem, UserItemAvatar, UserItemName, UserItemDescription, UserItemContent, SfuiSuffix]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiUserItemModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UserItem,
                    UserItemAvatar,
                    UserItemName,
                    UserItemDescription,
                    UserItemContent,
                ],
                imports: [CommonModule, SfuiCommonDirectivesModule],
                exports: [
                    UserItem,
                    UserItemAvatar,
                    UserItemName,
                    UserItemDescription,
                    UserItemContent,
                    SfuiSuffix,
                ]
            }]
    }], null, null); })();

class AttachmentPreviewModalDefaultPreviewComponent {
    constructor() {
        this.hostClass = 'sfui-attachment-preview-modal-default-preview';
        this.downloadFileText = '';
        this.download = new EventEmitter();
    }
    get itemSize() {
        return formatBytes(this.item.size);
    }
    _onDownload() {
        this.download.emit(this.item);
    }
}
AttachmentPreviewModalDefaultPreviewComponent.ɵfac = function AttachmentPreviewModalDefaultPreviewComponent_Factory(t) { return new (t || AttachmentPreviewModalDefaultPreviewComponent)(); };
AttachmentPreviewModalDefaultPreviewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttachmentPreviewModalDefaultPreviewComponent, selectors: [["sfui-attachment-preview-modal-default-preview"]], hostVars: 2, hostBindings: function AttachmentPreviewModalDefaultPreviewComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { downloadFileText: "downloadFileText", item: "item" }, outputs: { download: "download" }, decls: 8, vars: 11, consts: [[1, "sfui-attachment-preview-modal-default-preview__content"], [1, "sfui-attachment-preview-modal-default-preview__icon"], [1, "sfui-attachment-preview-modal-default-preview__file-name"], [1, "sfui-attachment-preview-modal-default-preview__file-size"], [1, "sfui-attachment-preview-modal-default-preview__download-button", 3, "click"]], template: function AttachmentPreviewModalDefaultPreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 4);
        ɵngcc0.ɵɵlistener("click", function AttachmentPreviewModalDefaultPreviewComponent_Template_button_click_6_listener() { return ctx._onDownload(); });
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("sfui-attachment-preview-modal-default-preview__icon--default", ctx.item.fileType == null)("sfui-attachment-preview-modal-default-preview__icon--doc", ctx.item.fileType === "doc")("sfui-attachment-preview-modal-default-preview__icon--pdf", ctx.item.fileType === "pdf")("sfui-attachment-preview-modal-default-preview__icon--image", ctx.item.fileType === "image");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.item.filename, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.itemSize, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.downloadFileText, " ");
    } }, styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-attachment-preview-modal-default-preview{display:flex;align-items:center;justify-content:center}.sfui-attachment-preview-modal-default-preview__download-button[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background:none;background-color:transparent;outline:none;padding:0;margin:0;text-decoration:none;color:inherit}.sfui-attachment-preview-modal-default-preview__download-button[_ngcontent-%COMP%]:focus, .sfui-attachment-preview-modal-default-preview__download-button[_ngcontent-%COMP%]:hover{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none}.sfui-attachment-preview-modal-default-preview__content[_ngcontent-%COMP%]{margin:16px;flex:0 1 auto;max-width:260px;display:flex;flex-direction:column;align-items:center;overflow:hidden}.sfui-attachment-preview-modal-default-preview__icon[_ngcontent-%COMP%]{width:100px;height:100px;background-position:50%;background-repeat:no-repeat;background-size:contain}.sfui-attachment-preview-modal-default-preview__icon--default[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%22100%22 height%3D%22100%22 viewBox%3D%220 0 100 100%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22M73.4375 96.875H17.1875C13.7357 96.875 10.9375 94.0768 10.9375 90.625V23.4375%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M89.0626 75.6625C89.1582 79.7908 85.8988 83.2197 81.7709 83.3333H30.7293C26.6014 83.2197 23.342 79.7908 23.4376 75.6625V10.7958C23.342 6.66755 26.6014 3.2386 30.7293 3.125H67.8126C69.7672 3.13481 71.6321 3.94673 72.9709 5.37083L86.9251 20.0542C88.3042 21.5198 89.0692 23.4583 89.0626 25.4708V75.6625Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\")}.sfui-attachment-preview-modal-default-preview__icon--doc[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%22100%22 height%3D%22100%22 viewBox%3D%220 0 100 100%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22M73.4375 96.875H17.1875C13.7357 96.875 10.9375 94.0768 10.9375 90.625V23.4375%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M89.0626 75.6625C89.1582 79.7908 85.8988 83.2197 81.7709 83.3333H30.7293C26.6014 83.2197 23.342 79.7908 23.4376 75.6625V10.7958C23.342 6.66755 26.6014 3.2386 30.7293 3.125H67.8126C69.7672 3.13481 71.6321 3.94673 72.9709 5.37083L86.9251 20.0542C88.3042 21.5198 89.0692 23.4583 89.0626 25.4708V75.6625Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath d%3D%22M40 73.624V59.376H44.8681C45.2639 59.376 45.653 59.3892 46.0356 59.4156C46.4182 59.4288 46.7942 59.4749 47.1636 59.5541C47.533 59.6201 47.8892 59.7256 48.2322 59.8707C48.5884 60.0158 48.9314 60.2071 49.2612 60.4446C49.7361 60.7876 50.1253 61.2098 50.4288 61.7111C50.7322 62.1992 50.9697 62.7203 51.1412 63.2744C51.3259 63.8153 51.4512 64.3694 51.5172 64.9367C51.5963 65.4908 51.6359 66.0053 51.6359 66.4802C51.6359 66.9551 51.6029 67.4367 51.5369 67.9248C51.4842 68.4129 51.3918 68.8945 51.2599 69.3694C51.128 69.8311 50.9499 70.2797 50.7256 70.715C50.5145 71.1372 50.2441 71.5264 49.9142 71.8826C49.5844 72.252 49.2216 72.5488 48.8259 72.7731C48.4433 72.9974 48.0343 73.1755 47.5989 73.3074C47.1768 73.4261 46.7348 73.5119 46.2731 73.5646C45.8113 73.6042 45.343 73.624 44.8681 73.624H40ZM41.3456 72.4763H44.5712C45.1781 72.4763 45.7454 72.4433 46.2731 72.3773C46.814 72.2982 47.3615 72.1135 47.9156 71.8232C48.3905 71.5858 48.7797 71.2625 49.0831 70.8536C49.3865 70.4446 49.624 70.0026 49.7955 69.5277C49.9802 69.0396 50.1055 68.5317 50.1715 68.004C50.2507 67.4763 50.2902 66.9683 50.2902 66.4802C50.2902 65.9657 50.2573 65.4446 50.1913 64.9169C50.1253 64.376 50 63.8681 49.8153 63.3931C49.6306 62.905 49.3799 62.4631 49.0633 62.0673C48.7467 61.6583 48.3377 61.3219 47.8364 61.058C47.4142 60.8338 46.9129 60.6887 46.3325 60.6227C45.752 60.5567 45.1649 60.5237 44.5712 60.5237H41.3456V72.4763Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3Cpath d%3D%22M53.8921 66.5198C53.8921 65.4776 54.0306 64.5013 54.3076 63.591C54.5979 62.6807 55.02 61.8892 55.5741 61.2164C56.1282 60.5303 56.8142 59.9894 57.6322 59.5937C58.4501 59.1979 59.3934 59 60.462 59C61.5702 59 62.5398 59.1979 63.371 59.5937C64.2153 59.9763 64.9145 60.5106 65.4686 61.1966C66.0359 61.8694 66.458 62.6675 66.7351 63.591C67.0253 64.5013 67.1704 65.4776 67.1704 66.5198C67.1704 67.5488 67.0253 68.5185 66.7351 69.4288C66.458 70.3259 66.0425 71.1174 65.4884 71.8034C64.9343 72.4763 64.2417 73.0106 63.4106 73.4063C62.5794 73.8021 61.6164 74 60.5214 74C59.4264 74 58.4633 73.8021 57.6322 73.4063C56.8011 73.0106 56.1084 72.4763 55.5543 71.8034C55.0003 71.1174 54.5847 70.3259 54.3076 69.4288C54.0306 68.5185 53.8921 67.5488 53.8921 66.5198ZM60.5412 72.8522C61.4646 72.8522 62.2562 72.6807 62.9158 72.3377C63.5886 71.9815 64.1361 71.5132 64.5583 70.9327C64.9937 70.3522 65.3103 69.6794 65.5082 68.9142C65.7193 68.1491 65.8248 67.3509 65.8248 66.5198C65.8248 65.5303 65.6995 64.6464 65.4488 63.8681C65.2113 63.0765 64.8617 62.4037 64.4 61.8496C63.9383 61.2955 63.3776 60.8734 62.7179 60.5831C62.0583 60.2929 61.3195 60.1478 60.5016 60.1478C59.5913 60.1478 58.7997 60.3259 58.1269 60.6821C57.4673 61.0383 56.9198 61.5132 56.4844 62.1069C56.0623 62.6873 55.7456 63.3602 55.5346 64.1253C55.3367 64.8905 55.2377 65.6887 55.2377 66.5198C55.2377 67.3641 55.3367 68.1689 55.5346 68.934C55.7456 69.6992 56.0623 70.372 56.4844 70.9525C56.9198 71.533 57.4673 71.9947 58.1269 72.3377C58.7997 72.6807 59.6045 72.8522 60.5412 72.8522Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3Cpath d%3D%22M80.1253 63.5119C79.8483 62.2982 79.3338 61.434 78.5818 60.9195C77.8298 60.405 76.847 60.1478 75.6332 60.1478C74.7757 60.1478 74.0369 60.3193 73.4169 60.6623C72.7968 61.0053 72.2823 61.467 71.8734 62.0475C71.4776 62.628 71.1807 63.3008 70.9829 64.066C70.7982 64.8179 70.7058 65.6161 70.7058 66.4604C70.7058 67.252 70.785 68.0303 70.9433 68.7955C71.1148 69.5607 71.3918 70.2467 71.7744 70.8536C72.157 71.4472 72.6715 71.9288 73.3179 72.2982C73.9644 72.6675 74.7757 72.8522 75.752 72.8522C76.3588 72.8522 76.9129 72.7533 77.4143 72.5554C77.9156 72.3575 78.3509 72.0871 78.7203 71.7441C79.1029 71.3879 79.4195 70.9723 79.6702 70.4974C79.934 70.0224 80.1319 69.5013 80.2639 68.934H81.6689C81.5106 69.6201 81.2797 70.2731 80.9763 70.8931C80.6728 71.5 80.2705 72.0343 79.7691 72.496C79.281 72.9578 78.6807 73.3272 77.9683 73.6042C77.2691 73.8681 76.4446 74 75.4947 74C74.3997 74 73.4631 73.8021 72.6847 73.4063C71.9063 72.9974 71.2665 72.4499 70.7652 71.7639C70.277 71.0778 69.9208 70.2863 69.6966 69.3892C69.4723 68.4789 69.3602 67.5158 69.3602 66.5C69.3602 65.1412 69.5251 63.9868 69.8549 63.0369C70.1979 62.0871 70.6662 61.3153 71.2599 60.7216C71.8536 60.1148 72.5528 59.6794 73.3575 59.4156C74.1623 59.1385 75.0396 59 75.9894 59C76.715 59 77.3879 59.0989 78.0079 59.2968C78.6412 59.4815 79.1953 59.7652 79.6702 60.1478C80.1583 60.5303 80.5541 61.0053 80.8575 61.5726C81.1741 62.1266 81.3918 62.7731 81.5106 63.5119H80.1253Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3C%2Fsvg%3E\")}.sfui-attachment-preview-modal-default-preview__icon--pdf[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%22100%22 height%3D%22100%22 viewBox%3D%220 0 100 100%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22M73.4375 96.875H17.1875C13.7357 96.875 10.9375 94.0768 10.9375 90.625V23.4375%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M89.0626 75.6625C89.1582 79.7908 85.8988 83.2197 81.7709 83.3333H30.7293C26.6014 83.2197 23.342 79.7908 23.4376 75.6625V10.7958C23.342 6.66755 26.6014 3.2386 30.7293 3.125H67.8126C69.7672 3.13481 71.6321 3.94673 72.9709 5.37083L86.9251 20.0542C88.3042 21.5198 89.0692 23.4583 89.0626 25.4708V75.6625Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath d%3D%22M42 74V59H47.5573C48.5434 59 49.3534 59.1111 49.9873 59.3333C50.6353 59.5556 51.1424 59.8611 51.5087 60.25C51.889 60.6389 52.1496 61.0903 52.2905 61.6042C52.4455 62.1042 52.5229 62.6319 52.5229 63.1875C52.5229 64.0208 52.3468 64.7083 51.9947 65.25C51.6566 65.7917 51.2129 66.2222 50.6635 66.5417C50.1141 66.8472 49.4872 67.0625 48.7829 67.1875C48.0926 67.3125 47.3953 67.375 46.6909 67.375H43.4369V74H42ZM46.7332 66.1667C47.4094 66.1667 48.0151 66.125 48.5504 66.0417C49.0857 65.9583 49.5365 65.8056 49.9028 65.5833C50.2831 65.3472 50.5719 65.0347 50.7691 64.6458C50.9804 64.2431 51.0861 63.7222 51.0861 63.0833C51.0861 62.1389 50.7691 61.4236 50.1352 60.9375C49.5154 60.4514 48.5222 60.2083 47.1558 60.2083H43.4369V66.1667H46.7332Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3Cpath d%3D%22M56.0375 74V59H61.2356C61.6582 59 62.0738 59.0139 62.4823 59.0417C62.8908 59.0556 63.2923 59.1042 63.6867 59.1875C64.0812 59.2569 64.4615 59.3681 64.8278 59.5208C65.2081 59.6736 65.5744 59.875 65.9265 60.125C66.4337 60.4861 66.8492 60.9306 67.1732 61.4583C67.4972 61.9722 67.7508 62.5208 67.9339 63.1042C68.1311 63.6736 68.265 64.2569 68.3354 64.8542C68.4199 65.4375 68.4622 65.9792 68.4622 66.4792C68.4622 66.9792 68.427 67.4861 68.3565 68C68.3002 68.5139 68.2016 69.0208 68.0607 69.5208C67.9198 70.0069 67.7297 70.4792 67.4902 70.9375C67.2648 71.3819 66.976 71.7917 66.6238 72.1667C66.2717 72.5556 65.8843 72.8681 65.4617 73.1042C65.0532 73.3403 64.6165 73.5278 64.1516 73.6667C63.7008 73.7917 63.2289 73.8819 62.7358 73.9375C62.2428 73.9792 61.7427 74 61.2356 74H56.0375ZM57.4744 72.7917H60.9186C61.5666 72.7917 62.1724 72.7569 62.7358 72.6875C63.3134 72.6042 63.898 72.4097 64.4897 72.1042C64.9968 71.8542 65.4124 71.5139 65.7364 71.0833C66.0604 70.6528 66.3139 70.1875 66.4971 69.6875C66.6943 69.1736 66.8281 68.6389 66.8985 68.0833C66.9831 67.5278 67.0253 66.9931 67.0253 66.4792C67.0253 65.9375 66.9901 65.3889 66.9197 64.8333C66.8492 64.2639 66.7154 63.7292 66.5182 63.2292C66.321 62.7153 66.0533 62.25 65.7152 61.8333C65.3771 61.4028 64.9405 61.0486 64.4051 60.7708C63.9544 60.5347 63.4191 60.3819 62.7992 60.3125C62.1794 60.2431 61.5525 60.2083 60.9186 60.2083H57.4744V72.7917Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3Cpath d%3D%22M72.1955 74V59H82V60.2083H73.6324V65.625H81.2393V66.8333H73.6324V74H72.1955Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3C%2Fsvg%3E\")}.sfui-attachment-preview-modal-default-preview__icon--image[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%22100%22 height%3D%22100%22 viewBox%3D%220 0 100 100%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M29.5005 43.229C33.8152 43.229 37.313 39.7312 37.313 35.4165C37.313 31.1018 33.8152 27.604 29.5005 27.604C25.1858 27.604 21.688 31.1018 21.688 35.4165C21.688 39.7312 25.1858 43.229 29.5005 43.229Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath d%3D%22M84.1669 70.6456L65.9502 43.3331C65.3051 42.3681 64.2253 41.7837 63.0646 41.7712C61.9039 41.7587 60.8118 42.3198 60.1461 43.2706L50.7919 56.6664L45.0002 52.0123C44.2311 51.396 43.2384 51.1313 42.2646 51.2826C41.2907 51.434 40.4252 51.9875 39.8794 52.8081L27.9419 70.7248%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M9.375 12.5957C5.92322 12.5957 3.125 15.3939 3.125 18.8457V81.154C3.125 84.6058 5.92322 87.404 9.375 87.404H90.625C94.0768 87.404 96.875 84.6058 96.875 81.154V31.154C96.8748 29.524 96.2379 27.9586 95.1 26.7915L83.0875 14.479C81.9106 13.2739 80.297 12.5948 78.6125 12.5957H9.375Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\")}.sfui-attachment-preview-modal-default-preview__file-name[_ngcontent-%COMP%]{box-sizing:content-box;margin-top:16px;margin-bottom:4px;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:18px;line-height:24px;letter-spacing:.15px;color:#fff;overflow:hidden;word-wrap:break-word;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;text-overflow:ellipsis;word-break:break-all;text-align:center}.sfui-attachment-preview-modal-default-preview__file-size[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:hsla(0,0%,100%,.74)}.sfui-attachment-preview-modal-default-preview__download-button[_ngcontent-%COMP%]{margin-top:16px;padding:10px 15px;background:#6b973e;border-radius:4px;text-align:center;color:#fff;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:16px;line-height:16px}.sfui-attachment-preview-modal-default-preview__download-button[_ngcontent-%COMP%]:active{opacity:.5}"] });
AttachmentPreviewModalDefaultPreviewComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    item: [{ type: Input }],
    downloadFileText: [{ type: Input }],
    download: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentPreviewModalDefaultPreviewComponent, [{
        type: Component,
        args: [{
                selector: 'sfui-attachment-preview-modal-default-preview',
                template: "<div class=\"sfui-attachment-preview-modal-default-preview__content\">\n  <div\n    class=\"sfui-attachment-preview-modal-default-preview__icon\"\n    [class.sfui-attachment-preview-modal-default-preview__icon--default]=\"\n      item.fileType == null\n    \"\n    [class.sfui-attachment-preview-modal-default-preview__icon--doc]=\"\n      item.fileType === 'doc'\n    \"\n    [class.sfui-attachment-preview-modal-default-preview__icon--pdf]=\"\n      item.fileType === 'pdf'\n    \"\n    [class.sfui-attachment-preview-modal-default-preview__icon--image]=\"\n      item.fileType === 'image'\n    \"\n  ></div>\n  <span class=\"sfui-attachment-preview-modal-default-preview__file-name\">\n    {{ item.filename }}\n  </span>\n  <span class=\"sfui-attachment-preview-modal-default-preview__file-size\">\n    {{ itemSize }}\n  </span>\n  <button\n    class=\"sfui-attachment-preview-modal-default-preview__download-button\"\n    (click)=\"_onDownload()\"\n  >\n    {{ downloadFileText }}\n  </button>\n</div>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-attachment-preview-modal-default-preview{display:flex;align-items:center;justify-content:center}.sfui-attachment-preview-modal-default-preview__download-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background:none;background-color:transparent;outline:none;padding:0;margin:0;text-decoration:none;color:inherit}.sfui-attachment-preview-modal-default-preview__download-button:focus,.sfui-attachment-preview-modal-default-preview__download-button:hover{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none}.sfui-attachment-preview-modal-default-preview__content{margin:16px;flex:0 1 auto;max-width:260px;display:flex;flex-direction:column;align-items:center;overflow:hidden}.sfui-attachment-preview-modal-default-preview__icon{width:100px;height:100px;background-position:50%;background-repeat:no-repeat;background-size:contain}.sfui-attachment-preview-modal-default-preview__icon--default{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%22100%22 height%3D%22100%22 viewBox%3D%220 0 100 100%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22M73.4375 96.875H17.1875C13.7357 96.875 10.9375 94.0768 10.9375 90.625V23.4375%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M89.0626 75.6625C89.1582 79.7908 85.8988 83.2197 81.7709 83.3333H30.7293C26.6014 83.2197 23.342 79.7908 23.4376 75.6625V10.7958C23.342 6.66755 26.6014 3.2386 30.7293 3.125H67.8126C69.7672 3.13481 71.6321 3.94673 72.9709 5.37083L86.9251 20.0542C88.3042 21.5198 89.0692 23.4583 89.0626 25.4708V75.6625Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\")}.sfui-attachment-preview-modal-default-preview__icon--doc{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%22100%22 height%3D%22100%22 viewBox%3D%220 0 100 100%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22M73.4375 96.875H17.1875C13.7357 96.875 10.9375 94.0768 10.9375 90.625V23.4375%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M89.0626 75.6625C89.1582 79.7908 85.8988 83.2197 81.7709 83.3333H30.7293C26.6014 83.2197 23.342 79.7908 23.4376 75.6625V10.7958C23.342 6.66755 26.6014 3.2386 30.7293 3.125H67.8126C69.7672 3.13481 71.6321 3.94673 72.9709 5.37083L86.9251 20.0542C88.3042 21.5198 89.0692 23.4583 89.0626 25.4708V75.6625Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath d%3D%22M40 73.624V59.376H44.8681C45.2639 59.376 45.653 59.3892 46.0356 59.4156C46.4182 59.4288 46.7942 59.4749 47.1636 59.5541C47.533 59.6201 47.8892 59.7256 48.2322 59.8707C48.5884 60.0158 48.9314 60.2071 49.2612 60.4446C49.7361 60.7876 50.1253 61.2098 50.4288 61.7111C50.7322 62.1992 50.9697 62.7203 51.1412 63.2744C51.3259 63.8153 51.4512 64.3694 51.5172 64.9367C51.5963 65.4908 51.6359 66.0053 51.6359 66.4802C51.6359 66.9551 51.6029 67.4367 51.5369 67.9248C51.4842 68.4129 51.3918 68.8945 51.2599 69.3694C51.128 69.8311 50.9499 70.2797 50.7256 70.715C50.5145 71.1372 50.2441 71.5264 49.9142 71.8826C49.5844 72.252 49.2216 72.5488 48.8259 72.7731C48.4433 72.9974 48.0343 73.1755 47.5989 73.3074C47.1768 73.4261 46.7348 73.5119 46.2731 73.5646C45.8113 73.6042 45.343 73.624 44.8681 73.624H40ZM41.3456 72.4763H44.5712C45.1781 72.4763 45.7454 72.4433 46.2731 72.3773C46.814 72.2982 47.3615 72.1135 47.9156 71.8232C48.3905 71.5858 48.7797 71.2625 49.0831 70.8536C49.3865 70.4446 49.624 70.0026 49.7955 69.5277C49.9802 69.0396 50.1055 68.5317 50.1715 68.004C50.2507 67.4763 50.2902 66.9683 50.2902 66.4802C50.2902 65.9657 50.2573 65.4446 50.1913 64.9169C50.1253 64.376 50 63.8681 49.8153 63.3931C49.6306 62.905 49.3799 62.4631 49.0633 62.0673C48.7467 61.6583 48.3377 61.3219 47.8364 61.058C47.4142 60.8338 46.9129 60.6887 46.3325 60.6227C45.752 60.5567 45.1649 60.5237 44.5712 60.5237H41.3456V72.4763Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3Cpath d%3D%22M53.8921 66.5198C53.8921 65.4776 54.0306 64.5013 54.3076 63.591C54.5979 62.6807 55.02 61.8892 55.5741 61.2164C56.1282 60.5303 56.8142 59.9894 57.6322 59.5937C58.4501 59.1979 59.3934 59 60.462 59C61.5702 59 62.5398 59.1979 63.371 59.5937C64.2153 59.9763 64.9145 60.5106 65.4686 61.1966C66.0359 61.8694 66.458 62.6675 66.7351 63.591C67.0253 64.5013 67.1704 65.4776 67.1704 66.5198C67.1704 67.5488 67.0253 68.5185 66.7351 69.4288C66.458 70.3259 66.0425 71.1174 65.4884 71.8034C64.9343 72.4763 64.2417 73.0106 63.4106 73.4063C62.5794 73.8021 61.6164 74 60.5214 74C59.4264 74 58.4633 73.8021 57.6322 73.4063C56.8011 73.0106 56.1084 72.4763 55.5543 71.8034C55.0003 71.1174 54.5847 70.3259 54.3076 69.4288C54.0306 68.5185 53.8921 67.5488 53.8921 66.5198ZM60.5412 72.8522C61.4646 72.8522 62.2562 72.6807 62.9158 72.3377C63.5886 71.9815 64.1361 71.5132 64.5583 70.9327C64.9937 70.3522 65.3103 69.6794 65.5082 68.9142C65.7193 68.1491 65.8248 67.3509 65.8248 66.5198C65.8248 65.5303 65.6995 64.6464 65.4488 63.8681C65.2113 63.0765 64.8617 62.4037 64.4 61.8496C63.9383 61.2955 63.3776 60.8734 62.7179 60.5831C62.0583 60.2929 61.3195 60.1478 60.5016 60.1478C59.5913 60.1478 58.7997 60.3259 58.1269 60.6821C57.4673 61.0383 56.9198 61.5132 56.4844 62.1069C56.0623 62.6873 55.7456 63.3602 55.5346 64.1253C55.3367 64.8905 55.2377 65.6887 55.2377 66.5198C55.2377 67.3641 55.3367 68.1689 55.5346 68.934C55.7456 69.6992 56.0623 70.372 56.4844 70.9525C56.9198 71.533 57.4673 71.9947 58.1269 72.3377C58.7997 72.6807 59.6045 72.8522 60.5412 72.8522Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3Cpath d%3D%22M80.1253 63.5119C79.8483 62.2982 79.3338 61.434 78.5818 60.9195C77.8298 60.405 76.847 60.1478 75.6332 60.1478C74.7757 60.1478 74.0369 60.3193 73.4169 60.6623C72.7968 61.0053 72.2823 61.467 71.8734 62.0475C71.4776 62.628 71.1807 63.3008 70.9829 64.066C70.7982 64.8179 70.7058 65.6161 70.7058 66.4604C70.7058 67.252 70.785 68.0303 70.9433 68.7955C71.1148 69.5607 71.3918 70.2467 71.7744 70.8536C72.157 71.4472 72.6715 71.9288 73.3179 72.2982C73.9644 72.6675 74.7757 72.8522 75.752 72.8522C76.3588 72.8522 76.9129 72.7533 77.4143 72.5554C77.9156 72.3575 78.3509 72.0871 78.7203 71.7441C79.1029 71.3879 79.4195 70.9723 79.6702 70.4974C79.934 70.0224 80.1319 69.5013 80.2639 68.934H81.6689C81.5106 69.6201 81.2797 70.2731 80.9763 70.8931C80.6728 71.5 80.2705 72.0343 79.7691 72.496C79.281 72.9578 78.6807 73.3272 77.9683 73.6042C77.2691 73.8681 76.4446 74 75.4947 74C74.3997 74 73.4631 73.8021 72.6847 73.4063C71.9063 72.9974 71.2665 72.4499 70.7652 71.7639C70.277 71.0778 69.9208 70.2863 69.6966 69.3892C69.4723 68.4789 69.3602 67.5158 69.3602 66.5C69.3602 65.1412 69.5251 63.9868 69.8549 63.0369C70.1979 62.0871 70.6662 61.3153 71.2599 60.7216C71.8536 60.1148 72.5528 59.6794 73.3575 59.4156C74.1623 59.1385 75.0396 59 75.9894 59C76.715 59 77.3879 59.0989 78.0079 59.2968C78.6412 59.4815 79.1953 59.7652 79.6702 60.1478C80.1583 60.5303 80.5541 61.0053 80.8575 61.5726C81.1741 62.1266 81.3918 62.7731 81.5106 63.5119H80.1253Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3C%2Fsvg%3E\")}.sfui-attachment-preview-modal-default-preview__icon--pdf{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%22100%22 height%3D%22100%22 viewBox%3D%220 0 100 100%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22M73.4375 96.875H17.1875C13.7357 96.875 10.9375 94.0768 10.9375 90.625V23.4375%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M89.0626 75.6625C89.1582 79.7908 85.8988 83.2197 81.7709 83.3333H30.7293C26.6014 83.2197 23.342 79.7908 23.4376 75.6625V10.7958C23.342 6.66755 26.6014 3.2386 30.7293 3.125H67.8126C69.7672 3.13481 71.6321 3.94673 72.9709 5.37083L86.9251 20.0542C88.3042 21.5198 89.0692 23.4583 89.0626 25.4708V75.6625Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath d%3D%22M42 74V59H47.5573C48.5434 59 49.3534 59.1111 49.9873 59.3333C50.6353 59.5556 51.1424 59.8611 51.5087 60.25C51.889 60.6389 52.1496 61.0903 52.2905 61.6042C52.4455 62.1042 52.5229 62.6319 52.5229 63.1875C52.5229 64.0208 52.3468 64.7083 51.9947 65.25C51.6566 65.7917 51.2129 66.2222 50.6635 66.5417C50.1141 66.8472 49.4872 67.0625 48.7829 67.1875C48.0926 67.3125 47.3953 67.375 46.6909 67.375H43.4369V74H42ZM46.7332 66.1667C47.4094 66.1667 48.0151 66.125 48.5504 66.0417C49.0857 65.9583 49.5365 65.8056 49.9028 65.5833C50.2831 65.3472 50.5719 65.0347 50.7691 64.6458C50.9804 64.2431 51.0861 63.7222 51.0861 63.0833C51.0861 62.1389 50.7691 61.4236 50.1352 60.9375C49.5154 60.4514 48.5222 60.2083 47.1558 60.2083H43.4369V66.1667H46.7332Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3Cpath d%3D%22M56.0375 74V59H61.2356C61.6582 59 62.0738 59.0139 62.4823 59.0417C62.8908 59.0556 63.2923 59.1042 63.6867 59.1875C64.0812 59.2569 64.4615 59.3681 64.8278 59.5208C65.2081 59.6736 65.5744 59.875 65.9265 60.125C66.4337 60.4861 66.8492 60.9306 67.1732 61.4583C67.4972 61.9722 67.7508 62.5208 67.9339 63.1042C68.1311 63.6736 68.265 64.2569 68.3354 64.8542C68.4199 65.4375 68.4622 65.9792 68.4622 66.4792C68.4622 66.9792 68.427 67.4861 68.3565 68C68.3002 68.5139 68.2016 69.0208 68.0607 69.5208C67.9198 70.0069 67.7297 70.4792 67.4902 70.9375C67.2648 71.3819 66.976 71.7917 66.6238 72.1667C66.2717 72.5556 65.8843 72.8681 65.4617 73.1042C65.0532 73.3403 64.6165 73.5278 64.1516 73.6667C63.7008 73.7917 63.2289 73.8819 62.7358 73.9375C62.2428 73.9792 61.7427 74 61.2356 74H56.0375ZM57.4744 72.7917H60.9186C61.5666 72.7917 62.1724 72.7569 62.7358 72.6875C63.3134 72.6042 63.898 72.4097 64.4897 72.1042C64.9968 71.8542 65.4124 71.5139 65.7364 71.0833C66.0604 70.6528 66.3139 70.1875 66.4971 69.6875C66.6943 69.1736 66.8281 68.6389 66.8985 68.0833C66.9831 67.5278 67.0253 66.9931 67.0253 66.4792C67.0253 65.9375 66.9901 65.3889 66.9197 64.8333C66.8492 64.2639 66.7154 63.7292 66.5182 63.2292C66.321 62.7153 66.0533 62.25 65.7152 61.8333C65.3771 61.4028 64.9405 61.0486 64.4051 60.7708C63.9544 60.5347 63.4191 60.3819 62.7992 60.3125C62.1794 60.2431 61.5525 60.2083 60.9186 60.2083H57.4744V72.7917Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3Cpath d%3D%22M72.1955 74V59H82V60.2083H73.6324V65.625H81.2393V66.8333H73.6324V74H72.1955Z%22 fill%3D%22white%22 fill-opacity%3D%220.74%22%2F%3E%3C%2Fsvg%3E\")}.sfui-attachment-preview-modal-default-preview__icon--image{background-image:url(\"data:image/svg+xml,%3Csvg width%3D%22100%22 height%3D%22100%22 viewBox%3D%220 0 100 100%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M29.5005 43.229C33.8152 43.229 37.313 39.7312 37.313 35.4165C37.313 31.1018 33.8152 27.604 29.5005 27.604C25.1858 27.604 21.688 31.1018 21.688 35.4165C21.688 39.7312 25.1858 43.229 29.5005 43.229Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath d%3D%22M84.1669 70.6456L65.9502 43.3331C65.3051 42.3681 64.2253 41.7837 63.0646 41.7712C61.9039 41.7587 60.8118 42.3198 60.1461 43.2706L50.7919 56.6664L45.0002 52.0123C44.2311 51.396 43.2384 51.1313 42.2646 51.2826C41.2907 51.434 40.4252 51.9875 39.8794 52.8081L27.9419 70.7248%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M9.375 12.5957C5.92322 12.5957 3.125 15.3939 3.125 18.8457V81.154C3.125 84.6058 5.92322 87.404 9.375 87.404H90.625C94.0768 87.404 96.875 84.6058 96.875 81.154V31.154C96.8748 29.524 96.2379 27.9586 95.1 26.7915L83.0875 14.479C81.9106 13.2739 80.297 12.5948 78.6125 12.5957H9.375Z%22 stroke%3D%22white%22 stroke-opacity%3D%220.74%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\")}.sfui-attachment-preview-modal-default-preview__file-name{box-sizing:content-box;margin-top:16px;margin-bottom:4px;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:18px;line-height:24px;letter-spacing:.15px;color:#fff;overflow:hidden;word-wrap:break-word;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;text-overflow:ellipsis;word-break:break-all;text-align:center}.sfui-attachment-preview-modal-default-preview__file-size{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:hsla(0,0%,100%,.74)}.sfui-attachment-preview-modal-default-preview__download-button{margin-top:16px;padding:10px 15px;background:#6b973e;border-radius:4px;text-align:center;color:#fff;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:550;font-size:16px;line-height:16px}.sfui-attachment-preview-modal-default-preview__download-button:active{opacity:.5}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], downloadFileText: [{
            type: Input
        }], download: [{
            type: Output
        }], item: [{
            type: Input
        }] }); })();

class AttachmentPreviewModalPdfPreviewComponent {
    constructor() {
        this.hostClass = 'sfui-attachment-preview-modal-pdf-preview';
        this.viewerError = new EventEmitter();
        this.shouldDisableSwipeChange = new EventEmitter();
        this.isLoaded = false;
        this.currentPage = 1;
        this.maxScale = 2.5;
        this._scale = 1;
        this.lastViewerClick = new Date(0);
    }
    set scale(v) {
        const prevShouldDisableSwipe = this.shouldDisableSwipe;
        this._scale = v;
        if (this.shouldDisableSwipe !== prevShouldDisableSwipe) {
            this.shouldDisableSwipeChange.emit(this.shouldDisableSwipe);
        }
    }
    get scale() {
        return this._scale;
    }
    get source() {
        return this.preview.src;
    }
    get shouldDisableSwipe() {
        return this.scale > 1;
    }
    zoomIn() {
        const fromScale = this.scale;
        this.scale = Math.min(this.maxScale, this.scale + 0.25);
        this.pdfScale.scrollForUpdatedScale(null, fromScale, this.scale);
    }
    zoomOut() {
        const fromScale = this.scale;
        this.scale = Math.max(1, this.scale - 0.25);
        this.pdfScale.scrollForUpdatedScale(null, fromScale, this.scale);
    }
    toggleZoom() {
        if (this.scale > 1) {
            this.scale = 1;
        }
        else {
            this.scale = 2;
        }
    }
    _onPdfViewerClick(event) {
        // For some reason dblclick event is not working in ios
        // We handle click event and detect double click here
        const now = new Date();
        const clickInterval = +now - +this.lastViewerClick;
        this.lastViewerClick = now;
        if (clickInterval < 500) {
            const fromScale = this.scale;
            const toPoint = {
                x: event.pageX,
                y: event.pageY,
            };
            this.toggleZoom();
            this.pdfScale.scrollForUpdatedScale(toPoint, fromScale, this.scale);
        }
    }
    _onError() {
        this.viewerError.emit();
    }
    _onPageInitialized() {
        this.isLoaded = true;
    }
}
AttachmentPreviewModalPdfPreviewComponent.ɵfac = function AttachmentPreviewModalPdfPreviewComponent_Factory(t) { return new (t || AttachmentPreviewModalPdfPreviewComponent)(); };
AttachmentPreviewModalPdfPreviewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttachmentPreviewModalPdfPreviewComponent, selectors: [["sfui-attachment-preview-modal-pdf-preview"]], viewQuery: function AttachmentPreviewModalPdfPreviewComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c29, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pdfScale = _t.first);
    } }, hostVars: 2, hostBindings: function AttachmentPreviewModalPdfPreviewComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { item: "item", preview: "preview" }, outputs: { viewerError: "viewerError", shouldDisableSwipeChange: "shouldDisableSwipeChange" }, decls: 6, vars: 14, consts: [["sfuiPdfScale", "", 1, "sfui-attachment-preview-modal-pdf-preview__viewer", 3, "src", "page", "render-text", "original-size", "zoom", "zoom-scale", "pageChange", "pages-initialized", "click", "error"], ["pdfScale", "sfuiPdfScale"], [1, "sfui-attachment-preview-modal-pdf-preview__zoom-container"], ["sfui-svg-icon--zoom-out", "", 1, "sfui-attachment-preview-modal-pdf-preview__zoom-button", 3, "disabled", "click"], ["sfui-svg-icon--zoom-in", "", 1, "sfui-attachment-preview-modal-pdf-preview__zoom-button", "sfui-attachment-preview-modal-pdf-preview__zoom-button--with-border", 3, "disabled", "click"], [1, "sfui-attachment-preview-modal-pdf-preview__loading-spinner", 3, "diameter", "strokeWidth"]], template: function AttachmentPreviewModalPdfPreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "pdf-viewer", 0, 1);
        ɵngcc0.ɵɵlistener("pageChange", function AttachmentPreviewModalPdfPreviewComponent_Template_pdf_viewer_pageChange_0_listener($event) { return ctx.currentPage = $event; })("pages-initialized", function AttachmentPreviewModalPdfPreviewComponent_Template_pdf_viewer_pages_initialized_0_listener() { return ctx._onPageInitialized(); })("click", function AttachmentPreviewModalPdfPreviewComponent_Template_pdf_viewer_click_0_listener($event) { return ctx._onPdfViewerClick($event); })("error", function AttachmentPreviewModalPdfPreviewComponent_Template_pdf_viewer_error_0_listener() { return ctx._onError(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function AttachmentPreviewModalPdfPreviewComponent_Template_button_click_3_listener() { return ctx.zoomOut(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function AttachmentPreviewModalPdfPreviewComponent_Template_button_click_4_listener() { return ctx.zoomIn(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "mat-spinner", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("src", ctx.source)("page", ctx.currentPage)("render-text", true)("original-size", false)("zoom", ctx.scale)("zoom-scale", "page-width");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("sfui-attachment-preview-modal-pdf-preview__zoom-container--hidden", !ctx.isLoaded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !(ctx.scale > 1));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.scale >= ctx.maxScale);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("sfui-attachment-preview-modal-pdf-preview__loading-spinner--hidden", ctx.isLoaded);
        ɵngcc0.ɵɵproperty("diameter", 24)("strokeWidth", 3);
    } }, directives: function () { return [ɵngcc11.PdfViewerComponent, SfuiPdfScale, ZoomOutIcon, ZoomInIcon, ɵngcc2.MatSpinner]; }, styles: [".sfui-attachment-preview-modal-pdf-preview{display:block;height:100%;position:relative}  .sfui-attachment-preview-modal-pdf-preview canvas{transform:none!important}.sfui-attachment-preview-modal-pdf-preview__zoom-button[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background:none;background-color:transparent;outline:none;padding:0;margin:0;text-decoration:none;color:inherit}.sfui-attachment-preview-modal-pdf-preview__zoom-button[_ngcontent-%COMP%]:focus, .sfui-attachment-preview-modal-pdf-preview__zoom-button[_ngcontent-%COMP%]:hover{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none}.sfui-attachment-preview-modal-pdf-preview__viewer[_ngcontent-%COMP%]{display:block;height:100%}.sfui-attachment-preview-modal-pdf-preview__loading-spinner[_ngcontent-%COMP%]{margin:auto;position:absolute;left:0;right:0;top:50%;transform:translateY(-50%)}.sfui-attachment-preview-modal-pdf-preview__loading-spinner[_ngcontent-%COMP%]     circle{stroke:hsla(0,0%,100%,.74)}.sfui-attachment-preview-modal-pdf-preview__loading-spinner--hidden[_ngcontent-%COMP%]{display:none}.sfui-attachment-preview-modal-pdf-preview__zoom-container[_ngcontent-%COMP%]{position:absolute;right:16px;bottom:16px;box-shadow:0 4px 4px rgba(0,0,0,.25);border-radius:4px;background:rgba(0,0,0,.87);border:1px solid hsla(0,0%,100%,.38);overflow:hidden}.sfui-attachment-preview-modal-pdf-preview__zoom-container--hidden[_ngcontent-%COMP%]{display:none}.sfui-attachment-preview-modal-pdf-preview__zoom-button[_ngcontent-%COMP%]{width:32px;height:32px;padding:8px 16px;box-sizing:content-box;position:relative}.sfui-attachment-preview-modal-pdf-preview__zoom-button[_ngcontent-%COMP%]     svg{transform:none!important}.sfui-attachment-preview-modal-pdf-preview__zoom-button[_ngcontent-%COMP%]:disabled     svg{opacity:.38}.sfui-attachment-preview-modal-pdf-preview__zoom-button[_ngcontent-%COMP%]:active     svg{opacity:.5}.sfui-attachment-preview-modal-pdf-preview__zoom-button--with-border[_ngcontent-%COMP%]:after{position:absolute;left:0;top:0;bottom:0;content:\"\";border-left:1px solid hsla(0,0%,100%,.38)}"] });
AttachmentPreviewModalPdfPreviewComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    item: [{ type: Input }],
    preview: [{ type: Input }],
    viewerError: [{ type: Output }],
    shouldDisableSwipeChange: [{ type: Output }],
    pdfScale: [{ type: ViewChild, args: ['pdfScale', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentPreviewModalPdfPreviewComponent, [{
        type: Component,
        args: [{
                selector: 'sfui-attachment-preview-modal-pdf-preview',
                template: "<pdf-viewer\n  sfuiPdfScale\n  #pdfScale=\"sfuiPdfScale\"\n  [src]=\"source\"\n  [(page)]=\"currentPage\"\n  [render-text]=\"true\"\n  [original-size]=\"false\"\n  [zoom]=\"scale\"\n  [zoom-scale]=\"'page-width'\"\n  (pages-initialized)=\"_onPageInitialized()\"\n  (click)=\"_onPdfViewerClick($event)\"\n  (error)=\"_onError()\"\n  class=\"sfui-attachment-preview-modal-pdf-preview__viewer\"\n></pdf-viewer>\n<div\n  class=\"sfui-attachment-preview-modal-pdf-preview__zoom-container\"\n  [class.sfui-attachment-preview-modal-pdf-preview__zoom-container--hidden]=\"\n    !isLoaded\n  \"\n>\n  <button\n    sfui-svg-icon--zoom-out\n    class=\"sfui-attachment-preview-modal-pdf-preview__zoom-button\"\n    [disabled]=\"!(scale > 1)\"\n    (click)=\"zoomOut()\"\n  ></button>\n  <button\n    sfui-svg-icon--zoom-in\n    class=\"\n      sfui-attachment-preview-modal-pdf-preview__zoom-button\n      sfui-attachment-preview-modal-pdf-preview__zoom-button--with-border\n    \"\n    [disabled]=\"scale >= maxScale\"\n    (click)=\"zoomIn()\"\n  ></button>\n</div>\n<mat-spinner\n  class=\"sfui-attachment-preview-modal-pdf-preview__loading-spinner\"\n  [class.sfui-attachment-preview-modal-pdf-preview__loading-spinner--hidden]=\"\n    isLoaded\n  \"\n  [diameter]=\"24\"\n  [strokeWidth]=\"3\"\n></mat-spinner>\n",
                styles: ["::ng-deep .sfui-attachment-preview-modal-pdf-preview{display:block;height:100%;position:relative}::ng-deep .sfui-attachment-preview-modal-pdf-preview canvas{transform:none!important}.sfui-attachment-preview-modal-pdf-preview__zoom-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background:none;background-color:transparent;outline:none;padding:0;margin:0;text-decoration:none;color:inherit}.sfui-attachment-preview-modal-pdf-preview__zoom-button:focus,.sfui-attachment-preview-modal-pdf-preview__zoom-button:hover{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none}.sfui-attachment-preview-modal-pdf-preview__viewer{display:block;height:100%}.sfui-attachment-preview-modal-pdf-preview__loading-spinner{margin:auto;position:absolute;left:0;right:0;top:50%;transform:translateY(-50%)}.sfui-attachment-preview-modal-pdf-preview__loading-spinner ::ng-deep circle{stroke:hsla(0,0%,100%,.74)}.sfui-attachment-preview-modal-pdf-preview__loading-spinner--hidden{display:none}.sfui-attachment-preview-modal-pdf-preview__zoom-container{position:absolute;right:16px;bottom:16px;box-shadow:0 4px 4px rgba(0,0,0,.25);border-radius:4px;background:rgba(0,0,0,.87);border:1px solid hsla(0,0%,100%,.38);overflow:hidden}.sfui-attachment-preview-modal-pdf-preview__zoom-container--hidden{display:none}.sfui-attachment-preview-modal-pdf-preview__zoom-button{width:32px;height:32px;padding:8px 16px;box-sizing:content-box;position:relative}.sfui-attachment-preview-modal-pdf-preview__zoom-button ::ng-deep svg{transform:none!important}.sfui-attachment-preview-modal-pdf-preview__zoom-button:disabled ::ng-deep svg{opacity:.38}.sfui-attachment-preview-modal-pdf-preview__zoom-button:active ::ng-deep svg{opacity:.5}.sfui-attachment-preview-modal-pdf-preview__zoom-button--with-border:after{position:absolute;left:0;top:0;bottom:0;content:\"\";border-left:1px solid hsla(0,0%,100%,.38)}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], viewerError: [{
            type: Output
        }], shouldDisableSwipeChange: [{
            type: Output
        }], item: [{
            type: Input
        }], preview: [{
            type: Input
        }], pdfScale: [{
            type: ViewChild,
            args: ['pdfScale', { static: true }]
        }] }); })();

class AttachmentPreviewModalPreviewErrorComponent {
    constructor() {
        this.hostClass = 'sfui-attachment-preview-modal-preview-error';
        this.retry = new EventEmitter();
    }
}
AttachmentPreviewModalPreviewErrorComponent.ɵfac = function AttachmentPreviewModalPreviewErrorComponent_Factory(t) { return new (t || AttachmentPreviewModalPreviewErrorComponent)(); };
AttachmentPreviewModalPreviewErrorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttachmentPreviewModalPreviewErrorComponent, selectors: [["sfui-attachment-preview-modal-preview-error"]], hostVars: 2, hostBindings: function AttachmentPreviewModalPreviewErrorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, outputs: { retry: "retry" }, decls: 1, vars: 0, consts: [["sfui-svg-icon--refresh", "", 1, "sfui-attachment-preview-modal-preview-error__button", 3, "click"]], template: function AttachmentPreviewModalPreviewErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function AttachmentPreviewModalPreviewErrorComponent_Template_button_click_0_listener() { return ctx.retry.emit(); });
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [RefreshIcon], styles: [".sfui-attachment-preview-modal-preview-error{display:block;position:relative}.sfui-attachment-preview-modal-preview-error__button[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background:none;background-color:transparent;outline:none;padding:0;margin:0;text-decoration:none;color:inherit}.sfui-attachment-preview-modal-preview-error__button[_ngcontent-%COMP%]:focus, .sfui-attachment-preview-modal-preview-error__button[_ngcontent-%COMP%]:hover{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none}.sfui-attachment-preview-modal-preview-error__button[_ngcontent-%COMP%]{width:32px;height:32px;position:absolute;top:50%;left:0;right:0;margin:auto;transform:translateY(-50%)}.sfui-attachment-preview-modal-preview-error__button[_ngcontent-%COMP%]:active{opacity:.5}"] });
AttachmentPreviewModalPreviewErrorComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    retry: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentPreviewModalPreviewErrorComponent, [{
        type: Component,
        args: [{
                selector: 'sfui-attachment-preview-modal-preview-error',
                template: "<button\n  class=\"sfui-attachment-preview-modal-preview-error__button\"\n  sfui-svg-icon--refresh\n  (click)=\"retry.emit()\"\n></button>\n",
                styles: ["::ng-deep .sfui-attachment-preview-modal-preview-error{display:block;position:relative}.sfui-attachment-preview-modal-preview-error__button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background:none;background-color:transparent;outline:none;padding:0;margin:0;text-decoration:none;color:inherit}.sfui-attachment-preview-modal-preview-error__button:focus,.sfui-attachment-preview-modal-preview-error__button:hover{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none}.sfui-attachment-preview-modal-preview-error__button{width:32px;height:32px;position:absolute;top:50%;left:0;right:0;margin:auto;transform:translateY(-50%)}.sfui-attachment-preview-modal-preview-error__button:active{opacity:.5}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], retry: [{
            type: Output
        }] }); })();

class AttachmentPreviewModalImagePreviewComponent {
    constructor() {
        this.hostClass = 'sfui-attachment-preview-modal-image-preview';
    }
}
AttachmentPreviewModalImagePreviewComponent.ɵfac = function AttachmentPreviewModalImagePreviewComponent_Factory(t) { return new (t || AttachmentPreviewModalImagePreviewComponent)(); };
AttachmentPreviewModalImagePreviewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttachmentPreviewModalImagePreviewComponent, selectors: [["sfui-attachment-preview-modal-image-preview"]], hostVars: 2, hostBindings: function AttachmentPreviewModalImagePreviewComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { item: "item", preview: "preview" }, decls: 1, vars: 1, consts: [[1, "sfui-attachment-preview-modal-image-preview__image", 3, "src"]], template: function AttachmentPreviewModalImagePreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "img", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("src", ctx.preview.src, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: [".sfui-attachment-preview-modal-image-preview{display:flex;justify-content:center;height:100%;position:relative;overflow:hidden}.sfui-attachment-preview-modal-image-preview__image[_ngcontent-%COMP%]{height:auto;width:100%;-o-object-fit:contain;object-fit:contain}"] });
AttachmentPreviewModalImagePreviewComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    item: [{ type: Input }],
    preview: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentPreviewModalImagePreviewComponent, [{
        type: Component,
        args: [{
                selector: 'sfui-attachment-preview-modal-image-preview',
                template: "<img\n  class=\"sfui-attachment-preview-modal-image-preview__image\"\n  [src]=\"preview.src\"\n/>\n",
                styles: ["::ng-deep .sfui-attachment-preview-modal-image-preview{display:flex;justify-content:center;height:100%;position:relative;overflow:hidden}.sfui-attachment-preview-modal-image-preview__image{height:auto;width:100%;-o-object-fit:contain;object-fit:contain}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], item: [{
            type: Input
        }], preview: [{
            type: Input
        }] }); })();

class AttachmentPreviewModalCustomPreviewComponent {
    constructor() {
        this.hostClass = 'sfui-attachment-preview-modal-custom-preview';
    }
}
AttachmentPreviewModalCustomPreviewComponent.ɵfac = function AttachmentPreviewModalCustomPreviewComponent_Factory(t) { return new (t || AttachmentPreviewModalCustomPreviewComponent)(); };
AttachmentPreviewModalCustomPreviewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttachmentPreviewModalCustomPreviewComponent, selectors: [["sfui-attachment-preview-modal-custom-preview"]], hostVars: 2, hostBindings: function AttachmentPreviewModalCustomPreviewComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { item: "item", preview: "preview" }, decls: 1, vars: 1, consts: [[3, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function AttachmentPreviewModalCustomPreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AttachmentPreviewModalCustomPreviewComponent_ng_template_0_Template, 1, 4, "ng-template", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.preview.templateRef !== undefined);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: [".sfui-attachment-preview-modal-custom-preview{display:flex;align-items:center;justify-content:center}"] });
AttachmentPreviewModalCustomPreviewComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    item: [{ type: Input }],
    preview: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentPreviewModalCustomPreviewComponent, [{
        type: Component,
        args: [{
                selector: 'sfui-attachment-preview-modal-custom-preview',
                template: "<ng-template [ngIf]=\"preview.templateRef !== undefined\">\n  <ng-container\n    *ngTemplateOutlet=\"\n      preview.templateRef;\n      context: {\n        $implicit: item\n      }\n    \"\n  ></ng-container>\n</ng-template>\n",
                styles: ["::ng-deep .sfui-attachment-preview-modal-custom-preview{display:flex;align-items:center;justify-content:center}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], item: [{
            type: Input
        }], preview: [{
            type: Input
        }] }); })();

class SfuiPdfScale {
    constructor(elRef) {
        this.elRef = elRef;
    }
    scrollForUpdatedScale(toPoint, fromScale, toScale) {
        const container = this.elRef.nativeElement.querySelector('.ng2-pdf-viewer-container');
        setTimeout(() => {
            if (toPoint !== null && toScale !== 1) {
                // Double click
                const rect = container.getBoundingClientRect();
                const xOffset = toPoint.x - rect.width / 2;
                const yOffset = toPoint.y - rect.height / 2 + rect.top;
                container.scrollLeft =
                    ((container.scrollLeft + xOffset) / fromScale) * toScale +
                        rect.width / 2;
                container.scrollTop =
                    ((container.scrollTop + yOffset) / fromScale) * toScale;
                toPoint = null;
            }
            else {
                container.scrollLeft = (container.scrollLeft / fromScale) * toScale;
                container.scrollTop = (container.scrollTop / fromScale) * toScale;
            }
        }, 50);
    }
}
SfuiPdfScale.ɵfac = function SfuiPdfScale_Factory(t) { return new (t || SfuiPdfScale)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SfuiPdfScale.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SfuiPdfScale, selectors: [["", "sfuiPdfScale", ""]], exportAs: ["sfuiPdfScale"] });
SfuiPdfScale.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiPdfScale, [{
        type: Directive,
        args: [{
                selector: '[sfuiPdfScale]',
                exportAs: 'sfuiPdfScale'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

class SfuiAttachmentPreviewComponentsModule {
}
SfuiAttachmentPreviewComponentsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiAttachmentPreviewComponentsModule });
SfuiAttachmentPreviewComponentsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiAttachmentPreviewComponentsModule_Factory(t) { return new (t || SfuiAttachmentPreviewComponentsModule)(); }, imports: [[
            CommonModule,
            PdfViewerModule,
            SfuiSvgIconModule,
            MatProgressSpinnerModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiAttachmentPreviewComponentsModule, { declarations: function () { return [AttachmentPreviewModalDefaultPreviewComponent, AttachmentPreviewModalPdfPreviewComponent, AttachmentPreviewModalPreviewErrorComponent, AttachmentPreviewModalImagePreviewComponent, AttachmentPreviewModalCustomPreviewComponent, SfuiPdfScale]; }, imports: function () { return [CommonModule,
        PdfViewerModule, SfuiSvgIconModule, MatProgressSpinnerModule]; }, exports: function () { return [AttachmentPreviewModalDefaultPreviewComponent, AttachmentPreviewModalPdfPreviewComponent, AttachmentPreviewModalPreviewErrorComponent, AttachmentPreviewModalImagePreviewComponent, AttachmentPreviewModalCustomPreviewComponent, SfuiPdfScale]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiAttachmentPreviewComponentsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AttachmentPreviewModalDefaultPreviewComponent,
                    AttachmentPreviewModalPdfPreviewComponent,
                    AttachmentPreviewModalPreviewErrorComponent,
                    AttachmentPreviewModalImagePreviewComponent,
                    AttachmentPreviewModalCustomPreviewComponent,
                    SfuiPdfScale,
                ],
                imports: [
                    CommonModule,
                    PdfViewerModule,
                    SfuiSvgIconModule,
                    MatProgressSpinnerModule,
                ],
                exports: [
                    AttachmentPreviewModalDefaultPreviewComponent,
                    AttachmentPreviewModalPdfPreviewComponent,
                    AttachmentPreviewModalPreviewErrorComponent,
                    AttachmentPreviewModalImagePreviewComponent,
                    AttachmentPreviewModalCustomPreviewComponent,
                    SfuiPdfScale,
                ]
            }]
    }], null, null); })();

class AttachmentDefaultPreview {
    constructor() {
        this.previewType = 'default';
    }
}
class AttachmentPDFPreview {
    constructor(args) {
        this.previewType = 'pdf';
        this.src = args.src;
    }
}
class AttachmentImagePreview {
    constructor(args) {
        this.previewType = 'image';
        this.src = args.src;
    }
}
class AttachmentPreviewLoading {
    constructor() {
        this.previewType = 'loading';
    }
}
class AttachmentPreviewError {
    constructor() {
        this.previewType = 'error';
    }
}
class AttachmentCustomPreview {
    constructor(args) {
        this.previewType = 'custom';
        this.templateRef = args.templateRef;
    }
}
class AttachmentPDFPreviewNetworkSource {
    constructor(args) {
        this.url = args.url;
        this.httpHeaders = args.httpHeaders;
        this.withCredentials = args.withCredentials;
        this.rangeChunkSize = args.rangeChunkSize;
    }
}
class AttachmentPDFPreviewDataSource {
    constructor(args) {
        this.data = args.data;
    }
}

class LineGraphData {
    constructor() {
        this.hostClass = ['sfui-line-graph-data'];
        this.data = [];
        this.color = '#d29c04';
        this.polylinePoints = '';
        this.pathD = '';
        this.hintPoints = [];
    }
    get withHint() {
        if (this.data.length > 0) {
            return typeof this.data[0] === 'number';
        }
        return false;
    }
}
LineGraphData.ɵfac = function LineGraphData_Factory(t) { return new (t || LineGraphData)(); };
LineGraphData.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LineGraphData, selectors: [["sfui-line-graph-data"]], hostVars: 2, hostBindings: function LineGraphData_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { data: "data", color: "color" }, decls: 0, vars: 0, template: function LineGraphData_Template(rf, ctx) { }, encapsulation: 2 });
LineGraphData.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    data: [{ type: Input }],
    color: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LineGraphData, [{
        type: Component,
        args: [{
                selector: 'sfui-line-graph-data',
                template: ''
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], data: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();

class LineGraph {
    constructor(elRef, ngZone, cdRef) {
        this.elRef = elRef;
        this.ngZone = ngZone;
        this.cdRef = cdRef;
        this.hostClass = ['sfui-line-graph'];
        this.data$ = new BehaviorSubject([]);
        this.yAxisMax$ = new BehaviorSubject(100);
        this.xAxisLabels = [];
        this.yAxisLabels = [];
        this.paddingTop$ = new BehaviorSubject(28);
        this.paddingBottom$ = new BehaviorSubject(28);
        this.paddingLeft$ = new BehaviorSubject(28);
        this.paddingRight$ = new BehaviorSubject(28);
        this.emptyText = '';
        this.width$ = new BehaviorSubject(0);
        this.height$ = new BehaviorSubject(0);
        this.xAxisSpacing = 0;
        this.yAxisSpacing = 0;
        this.polylinePoints = '';
        this.pathD = '';
        this.hintPoints = [];
        this.tooltipPosition = new FormControl('above');
        this.isEmpty$ = of(false);
        this.baselinePath$ = of('');
        this.graphLayout$ = of();
        this.lineGraphData$ = of();
        this.updateLayout = debounce(() => {
            this.width = this.elRef.nativeElement.clientWidth;
            this.height = this.elRef.nativeElement.clientHeight;
            this.cdRef.markForCheck();
        }, 100);
    }
    set data(d) {
        this.data$.next(d);
    }
    get data() {
        return this.data$.value;
    }
    set yAxisMax(max) {
        this.yAxisMax$.next(max);
    }
    get yAxisMax() {
        return this.yAxisMax$.value;
    }
    set paddingTop(padding) {
        this.paddingTop$.next(padding);
    }
    get paddingTop() {
        return this.paddingTop$.value;
    }
    set paddingBottom(padding) {
        this.paddingBottom$.next(padding);
    }
    get paddingBottom() {
        return this.paddingBottom$.value;
    }
    set paddingLeft(padding) {
        this.paddingLeft$.next(padding);
    }
    get paddingLeft() {
        return this.paddingLeft$.value;
    }
    set paddingRight(padding) {
        this.paddingRight$.next(padding);
    }
    get paddingRight() {
        return this.paddingRight$.value;
    }
    set width(w) {
        this.width$.next(w);
    }
    get width() {
        return this.width$.value;
    }
    set height(w) {
        this.height$.next(w);
    }
    get height() {
        return this.height$.value;
    }
    get lineGraphDataListArray() {
        return this.lineGraphDataList.toArray();
    }
    get isLineGraphData() {
        return this.lineGraphDataList.length !== 0;
    }
    ngOnInit() {
        this.resizeSubscribe = resizeObserver(this.elRef.nativeElement, this.ngZone).subscribe(() => {
            this.updateLayout();
        });
        this.graphLayout$ = combineLatest([
            this.width$,
            this.height$,
            this.paddingTop$,
            this.paddingBottom$,
            this.paddingLeft$,
            this.paddingRight$,
        ]).pipe(map(([width, height, paddingTop, paddingBottom, paddingLeft, paddingRight,]) => {
            if (width <= 0 || height <= 0) {
                return null;
            }
            return {
                width,
                height,
                paddingTop,
                paddingBottom,
                paddingLeft,
                paddingRight,
            };
        }), filter((layout) => layout !== null));
    }
    ngAfterViewInit() {
        if (this.isLineGraphData) {
            this.lineGraphData$ = this.lineGraphDataList.changes.pipe(startWith(this.lineGraphDataList));
            combineLatest([
                this.graphLayout$,
                this.yAxisMax$,
                this.lineGraphData$,
            ]).subscribe(([graphLayout, yAxisMax]) => {
                this.updateGraph(graphLayout, yAxisMax, []);
            });
            this.isEmpty$ = this.lineGraphData$.pipe(map((lineGraphData) => {
                if (lineGraphData.length === 0)
                    return true;
                const nonEmptyData = lineGraphData.toArray().every((item) => {
                    const nonEmptyData = item.data.filter((d) => d !== 0);
                    return nonEmptyData.length === 0;
                });
                return nonEmptyData;
            }));
        }
        else {
            combineLatest([this.graphLayout$, this.data$, this.yAxisMax$]).subscribe(([graphLayout, data, yAxisMax]) => {
                this.updateGraph(graphLayout, yAxisMax, data);
            });
            this.isEmpty$ = this.data$.pipe(map((data) => {
                const nonEmptyData = data.filter((item) => item !== 0);
                return nonEmptyData.length === 0;
            }));
        }
        this.baselinePath$ = this.isEmpty$.pipe(switchMap((isEmpty) => {
            if (!isEmpty)
                return of('');
            return combineLatest([
                this.width$,
                this.height$,
                this.paddingLeft$,
                this.paddingBottom$,
                this.paddingRight$,
            ]).pipe(map(([width, height, paddingLeft, paddingBottom, paddingRight]) => {
                return [
                    `M${paddingLeft}, ${height - paddingBottom}`,
                    `L${width - paddingRight}, ${height - paddingBottom}`,
                ].join(' ');
            }));
        }));
    }
    ngOnDestroy() {
        var _a;
        (_a = this.resizeSubscribe) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.width$.complete();
        this.height$.complete();
        this.paddingTop$.complete();
        this.paddingBottom$.complete();
        this.paddingLeft$.complete();
        this.paddingRight$.complete();
        this.data$.complete();
        this.yAxisMax$.complete();
    }
    updateGraph(graphLayout, yAxisMax, data) {
        const lineGraphDataList = this.lineGraphDataList.toArray();
        const { width, height, paddingTop, paddingBottom, paddingLeft, paddingRight, } = graphLayout;
        const graphWidth = width - paddingLeft - paddingRight;
        const graphHeight = height - paddingTop - paddingBottom;
        if (this.isLineGraphData) {
            const dataLength = lineGraphDataList[0].data.length;
            const xSpacing = dataLength < 2 ? 0 : graphWidth / (dataLength - 1);
            lineGraphDataList.forEach((lineGraphData) => {
                lineGraphData.hintPoints = [];
                const points = lineGraphData.data.map((data, i) => {
                    const d = typeof data === 'number' ? data : data.value;
                    const point = {
                        x: i * xSpacing + this.paddingLeft,
                        y: (yAxisMax - d) * (graphHeight / yAxisMax) + this.paddingTop,
                        data,
                    };
                    if (typeof data !== 'number') {
                        lineGraphData.hintPoints.push(Object.assign(Object.assign({}, data), point));
                    }
                    return point;
                });
                lineGraphData.polylinePoints = points
                    .map((p) => `${p.x},${p.y}`)
                    .join(' ');
                lineGraphData.pathD =
                    `M${paddingLeft}, ${height - paddingBottom}` +
                        points.map((p) => `L${p.x},${p.y}`).join(' ') +
                        `L${width - paddingRight}, ${height - paddingBottom} Z`;
            });
        }
        else {
            this.hintPoints = [];
            const xSpacing = data.length < 2 ? 0 : graphWidth / (data.length - 1);
            const points = data.map((data, i) => {
                const d = typeof data === 'number' ? data : data.value;
                const point = {
                    x: i * xSpacing + this.paddingLeft,
                    y: (yAxisMax - d) * (graphHeight / yAxisMax) + this.paddingTop,
                };
                if (typeof data !== 'number') {
                    this.hintPoints.push(Object.assign(Object.assign({}, data), point));
                }
                return point;
            });
            this.polylinePoints = points.map((p) => `${p.x},${p.y}`).join(' ');
            this.pathD =
                `M${paddingLeft}, ${height - paddingBottom}` +
                    points.map((p) => `L${p.x},${p.y}`).join(' ') +
                    `L${width - paddingRight}, ${height - paddingBottom} Z`;
        }
        this.xAxisSpacing =
            this.xAxisLabels.length < 2
                ? 0
                : graphWidth / (this.xAxisLabels.length - 1);
        this.yAxisSpacing =
            this.yAxisLabels.length < 1 ? 0 : graphHeight / this.yAxisLabels.length;
        this.cdRef.markForCheck();
    }
}
LineGraph.ɵfac = function LineGraph_Factory(t) { return new (t || LineGraph)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
LineGraph.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LineGraph, selectors: [["sfui-line-graph"]], contentQueries: function LineGraph_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, LineGraphData, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.lineGraphDataList = _t);
    } }, hostVars: 2, hostBindings: function LineGraph_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { xAxisLabels: "xAxisLabels", yAxisLabels: "yAxisLabels", emptyText: "emptyText", data: "data", yAxisMax: "yAxisMax", paddingTop: "paddingTop", paddingBottom: "paddingBottom", paddingLeft: "paddingLeft", paddingRight: "paddingRight" }, decls: 2, vars: 3, consts: [["class", "sfui-line-graph__graph", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", 1, "sfui-line-graph__graph"], [1, "sfui-line-graph__x-labels"], ["class", "sfui-line-graph__x-labels-label sfui-line-graph__label", 3, "left", "width", "margin-left", 4, "ngFor", "ngForOf"], ["x", "0", "y", "0"], [1, "sfui-line-graph__y-labels"], ["class", "sfui-line-graph__y-labels-label sfui-line-graph__label", 3, "top", "width", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["class", "sfui-line-graph__baseline", 4, "ngIf"], [1, "sfui-line-graph__x-labels-label", "sfui-line-graph__label"], [1, "sfui-line-graph__y-labels-label", "sfui-line-graph__label"], ["class", "sfui-line-graph__polyline", "fill", "none", 3, "--sfui-line-graph-color", 4, "ngFor", "ngForOf"], ["class", "sfui-line-graph__path", 3, "--sfui-line-graph-color", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], ["fill", "none", 1, "sfui-line-graph__polyline"], [1, "sfui-line-graph__path"], ["class", "sfui-line-graph__point", "matTooltipClass", "sfui-line-graph__tooltip", 3, "top", "left", "--sfui-line-graph-color", "matTooltip", "matTooltipPosition", "click", 4, "ngFor", "ngForOf"], ["matTooltipClass", "sfui-line-graph__tooltip", 1, "sfui-line-graph__point", 3, "matTooltip", "matTooltipPosition", "click"], ["tooltip", "matTooltip"], ["class", "sfui-line-graph__point", "matTooltipClass", "sfui-line-graph__tooltip", 3, "top", "left", "matTooltip", "matTooltipPosition", "click", 4, "ngFor", "ngForOf"], [1, "sfui-line-graph__baseline"], [1, "sfui-line-graph__empty-message"]], template: function LineGraph_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LineGraph__svg_svg_0_Template, 15, 18, "svg", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.graphLayout$));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc12.MatTooltip], pipes: [ɵngcc1.AsyncPipe], styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-line-graph{display:block;position:relative;min-height:160px;--sfui-line-graph-color:#d29c04}  .sfui-line-graph,   .sfui-line-graph *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-line-graph.material-icons,   .sfui-line-graph .material-icons{font-family:Material Icons}  .sfui-line-graph.material-icons-outlined,   .sfui-line-graph .material-icons-outlined{font-family:Material Icons Outlined}  .sfui-line-graph__graph{display:block}  .sfui-line-graph__x-labels{position:relative;display:block;height:100%;box-sizing:border-box}  .sfui-line-graph__x-labels-label{position:absolute;top:50%;margin-top:-8px}  .sfui-line-graph__y-labels{position:relative}  .sfui-line-graph__y-labels-label{position:absolute}  .sfui-line-graph__label{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:rgba(0,0,0,.6);text-align:center;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}  .sfui-line-graph__polyline{stroke:var(--sfui-line-graph-color);stroke-width:2}  .sfui-line-graph__path{fill:var(--sfui-line-graph-color);fill-opacity:.2}  .sfui-line-graph__baseline{stroke:rgba(0,0,0,.24);stroke-width:1px}  .sfui-line-graph__empty-message{height:100%;width:100%;display:flex;align-items:center;justify-content:center;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:rgba(0,0,0,.24)}  .sfui-line-graph__point{height:12px;width:12px;position:absolute;background-color:var(--sfui-line-graph-color);border-radius:50%;cursor:pointer;opacity:0}  .sfui-line-graph__point:hover{opacity:1}  .sfui-line-graph__tooltip{white-space:pre-line;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:#fff;text-align:center;padding:4px 12px!important}"] });
LineGraph.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone },
    { type: ChangeDetectorRef }
];
LineGraph.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    data: [{ type: Input }],
    yAxisMax: [{ type: Input }],
    xAxisLabels: [{ type: Input }],
    yAxisLabels: [{ type: Input }],
    paddingTop: [{ type: Input }],
    paddingBottom: [{ type: Input }],
    paddingLeft: [{ type: Input }],
    paddingRight: [{ type: Input }],
    emptyText: [{ type: Input }],
    lineGraphDataList: [{ type: ContentChildren, args: [LineGraphData,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LineGraph, [{
        type: Component,
        args: [{
                selector: 'sfui-line-graph',
                template: "<svg\n  *ngIf=\"graphLayout$ | async as layout\"\n  class=\"sfui-line-graph__graph\"\n  [attr.height]=\"layout.height\"\n  [attr.width]=\"layout.width\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n>\n  <g>\n    <foreignObject\n      [attr.x]=\"0\"\n      [attr.y]=\"layout.height - layout.paddingBottom\"\n      [attr.width]=\"layout.width\"\n      [attr.height]=\"layout.paddingBottom\"\n    >\n      <div class=\"sfui-line-graph__x-labels\">\n        <div\n          *ngFor=\"let xlabel of xAxisLabels; let i = index\"\n          class=\"sfui-line-graph__x-labels-label sfui-line-graph__label\"\n          [style.left.px]=\"xAxisSpacing * i + layout.paddingLeft\"\n          [style.width.px]=\"xAxisSpacing\"\n          [style.margin-left.px]=\"-xAxisSpacing / 2\"\n        >\n          {{ xlabel }}\n        </div>\n      </div>\n    </foreignObject>\n  </g>\n  <g>\n    <foreignObject\n      x=\"0\"\n      y=\"0\"\n      [attr.width]=\"layout.paddingLeft\"\n      [attr.height]=\"layout.height\"\n    >\n      <div class=\"sfui-line-graph__y-labels\">\n        <div\n          *ngFor=\"let ylabel of yAxisLabels.slice().reverse(); let i = index\"\n          class=\"sfui-line-graph__y-labels-label sfui-line-graph__label\"\n          [style.top.px]=\"yAxisSpacing * i + layout.paddingTop - 8\"\n          [style.width.px]=\"layout.paddingLeft\"\n        >\n          {{ ylabel }}\n        </div>\n      </div>\n    </foreignObject>\n  </g>\n  <ng-container *ngIf=\"isLineGraphData\">\n    <polyline\n      *ngFor=\"let item of lineGraphDataList\"\n      class=\"sfui-line-graph__polyline\"\n      fill=\"none\"\n      [attr.points]=\"item.polylinePoints\"\n      [style.--sfui-line-graph-color]=\"item.color\"\n    ></polyline>\n    <path\n      *ngFor=\"let item of lineGraphDataList\"\n      class=\"sfui-line-graph__path\"\n      [attr.d]=\"item.pathD\"\n      [style.--sfui-line-graph-color]=\"item.color\"\n    ></path>\n    <foreignObject\n      [attr.x]=\"0\"\n      [attr.y]=\"0\"\n      [attr.width]=\"layout.width\"\n      [attr.height]=\"layout.height\"\n    >\n      <div *ngFor=\"let item of lineGraphDataList\">\n        <ng-container *ngIf=\"item.hintPoints.length > 0\">\n          <div\n            *ngFor=\"let hintPoint of item.hintPoints; let i = index\"\n            (click)=\"hintPoint.onClick && hintPoint.onClick($event, i)\"\n            class=\"sfui-line-graph__point\"\n            [style.top.px]=\"hintPoint.y - 6\"\n            [style.left.px]=\"hintPoint.x - 6\"\n            [style.--sfui-line-graph-color]=\"item.color\"\n            #tooltip=\"matTooltip\"\n            [matTooltip]=\"hintPoint.hint\"\n            [matTooltipPosition]=\"tooltipPosition.value\"\n            matTooltipClass=\"sfui-line-graph__tooltip\"\n          ></div>\n        </ng-container>\n      </div>\n    </foreignObject>\n  </ng-container>\n  <ng-container *ngIf=\"!isLineGraphData\">\n    <polyline\n      class=\"sfui-line-graph__polyline\"\n      fill=\"none\"\n      [attr.points]=\"polylinePoints\"\n    ></polyline>\n    <path class=\"sfui-line-graph__path\" [attr.d]=\"pathD\"></path>\n    <foreignObject\n      *ngIf=\"hintPoints.length > 0\"\n      [attr.x]=\"0\"\n      [attr.y]=\"0\"\n      [attr.width]=\"layout.width\"\n      [attr.height]=\"layout.height\"\n    >\n      <div\n        *ngFor=\"let hintPoint of hintPoints; let i = index\"\n        (click)=\"hintPoint.onClick && hintPoint.onClick($event, i)\"\n        class=\"sfui-line-graph__point\"\n        [style.top.px]=\"hintPoint.y - 6\"\n        [style.left.px]=\"hintPoint.x - 6\"\n        #tooltip=\"matTooltip\"\n        [matTooltip]=\"hintPoint.hint\"\n        [matTooltipPosition]=\"tooltipPosition.value\"\n        matTooltipClass=\"sfui-line-graph__tooltip\"\n      ></div>\n    </foreignObject>\n  </ng-container>\n\n  <path\n    *ngIf=\"baselinePath$ | async as baselinePath\"\n    [attr.d]=\"baselinePath\"\n    class=\"sfui-line-graph__baseline\"\n  ></path>\n  <g *ngIf=\"isEmpty$ | async\">\n    <foreignObject\n      [attr.x]=\"layout.paddingLeft\"\n      [attr.y]=\"0\"\n      [attr.width]=\"layout.width - layout.paddingLeft - layout.paddingRight\"\n      [attr.height]=\"layout.height - layout.paddingBottom\"\n    >\n      <div class=\"sfui-line-graph__empty-message\">\n        {{ emptyText }}\n      </div>\n    </foreignObject>\n  </g>\n</svg>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-line-graph{display:block;position:relative;min-height:160px;--sfui-line-graph-color:#d29c04}::ng-deep .sfui-line-graph,::ng-deep .sfui-line-graph *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-line-graph.material-icons,::ng-deep .sfui-line-graph .material-icons{font-family:Material Icons}::ng-deep .sfui-line-graph.material-icons-outlined,::ng-deep .sfui-line-graph .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-line-graph__graph{display:block}::ng-deep .sfui-line-graph__x-labels{position:relative;display:block;height:100%;box-sizing:border-box}::ng-deep .sfui-line-graph__x-labels-label{position:absolute;top:50%;margin-top:-8px}::ng-deep .sfui-line-graph__y-labels{position:relative}::ng-deep .sfui-line-graph__y-labels-label{position:absolute}::ng-deep .sfui-line-graph__label{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:rgba(0,0,0,.6);text-align:center;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}::ng-deep .sfui-line-graph__polyline{stroke:var(--sfui-line-graph-color);stroke-width:2}::ng-deep .sfui-line-graph__path{fill:var(--sfui-line-graph-color);fill-opacity:.2}::ng-deep .sfui-line-graph__baseline{stroke:rgba(0,0,0,.24);stroke-width:1px}::ng-deep .sfui-line-graph__empty-message{height:100%;width:100%;display:flex;align-items:center;justify-content:center;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:rgba(0,0,0,.24)}::ng-deep .sfui-line-graph__point{height:12px;width:12px;position:absolute;background-color:var(--sfui-line-graph-color);border-radius:50%;cursor:pointer;opacity:0}::ng-deep .sfui-line-graph__point:hover{opacity:1}::ng-deep .sfui-line-graph__tooltip{white-space:pre-line;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:#fff;text-align:center;padding:4px 12px!important}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }]; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], xAxisLabels: [{
            type: Input
        }], yAxisLabels: [{
            type: Input
        }], emptyText: [{
            type: Input
        }], data: [{
            type: Input
        }], yAxisMax: [{
            type: Input
        }], paddingTop: [{
            type: Input
        }], paddingBottom: [{
            type: Input
        }], paddingLeft: [{
            type: Input
        }], paddingRight: [{
            type: Input
        }], lineGraphDataList: [{
            type: ContentChildren,
            args: [LineGraphData]
        }] }); })();

class SfuiLineGraphModule {
}
SfuiLineGraphModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiLineGraphModule });
SfuiLineGraphModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiLineGraphModule_Factory(t) { return new (t || SfuiLineGraphModule)(); }, imports: [[CommonModule, MatTooltipModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiLineGraphModule, { declarations: function () { return [LineGraph, LineGraphData]; }, imports: function () { return [CommonModule, MatTooltipModule]; }, exports: function () { return [LineGraph, LineGraphData]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiLineGraphModule, [{
        type: NgModule,
        args: [{
                declarations: [LineGraph, LineGraphData],
                imports: [CommonModule, MatTooltipModule],
                exports: [LineGraph, LineGraphData]
            }]
    }], null, null); })();

class DoughnutChart {
    constructor() {
        this.hostClass = ['sfui-doughnut-chart'];
        this.data = [];
        this.displaySummary = true;
        this.strokeWidth = 10;
        this.gap = 5;
        this.summaryDataClick = new EventEmitter();
        this.hoverItemIndex$ = new BehaviorSubject(null);
    }
    onSummaryClick(data) {
        this.summaryDataClick.emit(data);
    }
    summaryMouseenter(index) {
        this.hoverItemIndex$.next(index);
    }
    summaryMouseleave() {
        this.hoverItemIndex$.next(null);
    }
    onGraphHoverIndexChange(index) {
        this.hoverItemIndex$.next(index);
    }
    onGraphClickIndexChange(index) {
        this.onSummaryClick(this.data[index]);
    }
    hasHint(d) {
        return Boolean(d.hint);
    }
}
DoughnutChart.ɵfac = function DoughnutChart_Factory(t) { return new (t || DoughnutChart)(); };
DoughnutChart.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DoughnutChart, selectors: [["sfui-doughnut-chart"]], hostVars: 2, hostBindings: function DoughnutChart_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { data: "data", displaySummary: "displaySummary", strokeWidth: "strokeWidth", gap: "gap" }, outputs: { summaryDataClick: "summaryDataClick" }, ngContentSelectors: _c3, decls: 4, vars: 7, consts: [[1, "sfui-doughnut-chart__graph", 3, "data", "strokeWidth", "gap", "hoverItemIndex", "hoverIndexChange", "clickIndexChange"], ["class", "sfui-doughnut-chart__summary", 4, "ngIf"], [1, "sfui-doughnut-chart__summary"], ["class", "sfui-doughnut-chart__summary-item", "sfuiCursorTooltip", "", 3, "sfui-doughnut-chart__summary-item--empty", "sfui-doughnut-chart__summary-item--hover", "sfui-doughnut-chart__summary-item--hover-active", "--sfui-dought-chart-summary-item-color", "isTooltipDisplaying", "tooltipHintText", "click", "mouseenter", "mouseleave", 4, "ngFor", "ngForOf"], ["sfuiCursorTooltip", "", 1, "sfui-doughnut-chart__summary-item", 3, "isTooltipDisplaying", "tooltipHintText", "click", "mouseenter", "mouseleave"], [1, "sfui-doughnut-chart__summary-color"], [1, "sfui-doughnut-chart__summary-label"], [1, "sfui-doughnut-chart__summary-value"], ["class", "sfui-doughnut-chart__summary-percentage", 4, "ngIf"], [1, "sfui-doughnut-chart__summary-percentage"]], template: function DoughnutChart_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "sfui-doughnut-chart-graph", 0);
        ɵngcc0.ɵɵlistener("hoverIndexChange", function DoughnutChart_Template_sfui_doughnut_chart_graph_hoverIndexChange_0_listener($event) { return ctx.onGraphHoverIndexChange($event); })("clickIndexChange", function DoughnutChart_Template_sfui_doughnut_chart_graph_clickIndexChange_0_listener($event) { return ctx.onGraphClickIndexChange($event); });
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DoughnutChart_div_3_Template, 2, 1, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("data", ctx.data)("strokeWidth", ctx.strokeWidth)("gap", ctx.gap)("hoverItemIndex", ɵngcc0.ɵɵpipeBind1(1, 5, ctx.hoverItemIndex$));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displaySummary);
    } }, directives: function () { return [DoughnutChartGraph, ɵngcc1.NgIf, ɵngcc1.NgForOf, CursorTooltipDirective]; }, pipes: function () { return [ɵngcc1.AsyncPipe]; }, styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-doughnut-chart{--sfui-doughnut-chart-graph-size:140px;--sfui-doughnut-chart-empty-color:#ededed;display:flex;flex-direction:row;justify-content:center;align-items:center}  .sfui-doughnut-chart,   .sfui-doughnut-chart *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-doughnut-chart.material-icons,   .sfui-doughnut-chart .material-icons{font-family:Material Icons}  .sfui-doughnut-chart.material-icons-outlined,   .sfui-doughnut-chart .material-icons-outlined{font-family:Material Icons Outlined}  .sfui-doughnut-chart__summary{margin-left:18px}  .sfui-doughnut-chart__summary-item{display:flex;flex-direction:row;align-items:center;cursor:pointer}  .sfui-doughnut-chart__summary-item--empty .sfui-doughnut-chart__summary-color{background-color:var(--sfui-doughnut-chart-empty-color,#ededed)}  .sfui-doughnut-chart__summary-item--empty .sfui-doughnut-chart__summary-value{color:rgba(0,0,0,.24)}  .sfui-doughnut-chart__summary-item--hover{opacity:.4}  .sfui-doughnut-chart__summary-item--hover-active{opacity:1}  .sfui-doughnut-chart__summary-item+  .sfui-doughnut-chart__summary-item{margin-top:10px}  .sfui-doughnut-chart__summary-color{width:8px;height:8px;background-color:var(--sfui-dought-chart-summary-item-color)}  .sfui-doughnut-chart__summary-label{font-weight:400;line-height:20px;letter-spacing:.5px;color:rgba(0,0,0,.87);margin-left:8px;width:86px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}  .sfui-doughnut-chart__summary-label,   .sfui-doughnut-chart__summary-value{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-size:14px}  .sfui-doughnut-chart__summary-value{font-weight:550;line-height:24px;letter-spacing:.1px;color:var(--sfui-dought-chart-summary-item-color);text-align:left;margin-left:2px}  .sfui-doughnut-chart__summary-percentage{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:rgba(0,0,0,.6);margin-left:4px}.sfui-doughnut-chart__graph[_ngcontent-%COMP%]{width:var(--sfui-doughnut-chart-graph-size)}"] });
DoughnutChart.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    data: [{ type: Input }],
    displaySummary: [{ type: Input }],
    strokeWidth: [{ type: Input }],
    gap: [{ type: Input }],
    summaryDataClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DoughnutChart, [{
        type: Component,
        args: [{
                selector: 'sfui-doughnut-chart',
                template: "<sfui-doughnut-chart-graph\n  class=\"sfui-doughnut-chart__graph\"\n  [data]=\"data\"\n  [strokeWidth]=\"strokeWidth\"\n  [gap]=\"gap\"\n  [hoverItemIndex]=\"hoverItemIndex$ | async\"\n  (hoverIndexChange)=\"onGraphHoverIndexChange($event)\"\n  (clickIndexChange)=\"onGraphClickIndexChange($event)\"\n>\n  <ng-content></ng-content>\n</sfui-doughnut-chart-graph>\n<div *ngIf=\"displaySummary\" class=\"sfui-doughnut-chart__summary\">\n  <div\n    *ngFor=\"let d of data; let i = index\"\n    class=\"sfui-doughnut-chart__summary-item\"\n    [class.sfui-doughnut-chart__summary-item--empty]=\"d.value <= 0\"\n    [class.sfui-doughnut-chart__summary-item--hover]=\"\n      (hoverItemIndex$ | async) != null\n    \"\n    [class.sfui-doughnut-chart__summary-item--hover-active]=\"\n      i === (hoverItemIndex$ | async)\n    \"\n    [style.--sfui-dought-chart-summary-item-color]=\"d.color\"\n    (click)=\"onSummaryClick(d)\"\n    (mouseenter)=\"summaryMouseenter(i)\"\n    (mouseleave)=\"summaryMouseleave()\"\n    sfuiCursorTooltip\n    [isTooltipDisplaying]=\"i === (hoverItemIndex$ | async) && hasHint(d)\"\n    [tooltipHintText]=\"d.hint || ''\"\n  >\n    <div class=\"sfui-doughnut-chart__summary-color\"></div>\n    <div class=\"sfui-doughnut-chart__summary-label\">{{ d.label }}</div>\n    <div class=\"sfui-doughnut-chart__summary-value\">{{ d.value }}</div>\n    <div\n      *ngIf=\"d.percentage != null\"\n      class=\"sfui-doughnut-chart__summary-percentage\"\n    >\n      ({{ d.percentage }}%)\n    </div>\n  </div>\n</div>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-doughnut-chart{--sfui-doughnut-chart-graph-size:140px;--sfui-doughnut-chart-empty-color:#ededed;display:flex;flex-direction:row;justify-content:center;align-items:center}::ng-deep .sfui-doughnut-chart,::ng-deep .sfui-doughnut-chart *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-doughnut-chart.material-icons,::ng-deep .sfui-doughnut-chart .material-icons{font-family:Material Icons}::ng-deep .sfui-doughnut-chart.material-icons-outlined,::ng-deep .sfui-doughnut-chart .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-doughnut-chart__summary{margin-left:18px}::ng-deep .sfui-doughnut-chart__summary-item{display:flex;flex-direction:row;align-items:center;cursor:pointer}::ng-deep .sfui-doughnut-chart__summary-item--empty .sfui-doughnut-chart__summary-color{background-color:var(--sfui-doughnut-chart-empty-color,#ededed)}::ng-deep .sfui-doughnut-chart__summary-item--empty .sfui-doughnut-chart__summary-value{color:rgba(0,0,0,.24)}::ng-deep .sfui-doughnut-chart__summary-item--hover{opacity:.4}::ng-deep .sfui-doughnut-chart__summary-item--hover-active{opacity:1}::ng-deep .sfui-doughnut-chart__summary-item+::ng-deep .sfui-doughnut-chart__summary-item{margin-top:10px}::ng-deep .sfui-doughnut-chart__summary-color{width:8px;height:8px;background-color:var(--sfui-dought-chart-summary-item-color)}::ng-deep .sfui-doughnut-chart__summary-label{font-weight:400;line-height:20px;letter-spacing:.5px;color:rgba(0,0,0,.87);margin-left:8px;width:86px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}::ng-deep .sfui-doughnut-chart__summary-label,::ng-deep .sfui-doughnut-chart__summary-value{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-size:14px}::ng-deep .sfui-doughnut-chart__summary-value{font-weight:550;line-height:24px;letter-spacing:.1px;color:var(--sfui-dought-chart-summary-item-color);text-align:left;margin-left:2px}::ng-deep .sfui-doughnut-chart__summary-percentage{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:rgba(0,0,0,.6);margin-left:4px}.sfui-doughnut-chart__graph{width:var(--sfui-doughnut-chart-graph-size)}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], data: [{
            type: Input
        }], displaySummary: [{
            type: Input
        }], strokeWidth: [{
            type: Input
        }], gap: [{
            type: Input
        }], summaryDataClick: [{
            type: Output
        }] }); })();

const DIAMETER = 140;
class DoughnutChartGraph {
    constructor() {
        this.hostClass = ['sfui-doughnut-chart-graph'];
        this.data$ = new BehaviorSubject([]);
        this.strokeWidth$ = new BehaviorSubject(10);
        this.gap$ = new BehaviorSubject(5);
        this.hoverItemIndex = null;
        this.hoverIndexChange = new EventEmitter();
        this.clickIndexChange = new EventEmitter();
        this.internalData$ = of([]);
        this.size$ = of(DIAMETER + this.strokeWidth);
        this.viewBox$ = of('');
        this.radius = DIAMETER / 2;
        this.perimeter = Math.PI * DIAMETER;
        this.isEmpty = false;
    }
    set data(data) {
        this.data$.next(data);
    }
    get data() {
        return this.data$.value;
    }
    set strokeWidth(s) {
        this.strokeWidth$.next(s);
    }
    get strokeWidth() {
        return this.strokeWidth$.value;
    }
    set gap(v) {
        this.gap$.next(v);
    }
    get gap() {
        return this.gap$.value;
    }
    ngOnInit() {
        this.size$ = this.strokeWidth$.pipe(map((strokeWidth) => {
            return DIAMETER + strokeWidth;
        }));
        this.viewBox$ = this.size$.pipe(map((size) => {
            return `0 0 ${size} ${size}`;
        }));
        this.internalData$ = combineLatest([
            this.data$,
            this.gap$,
            this.size$,
        ]).pipe(map(([data, gap, size]) => {
            return this.deriveInternalData(data, gap, size);
        }));
    }
    ngOnDestroy() {
        this.data$.complete();
    }
    deriveInternalData(data, gap, graphSize) {
        const sum = data
            .map((d) => d.value)
            .reduce((acc, val) => acc + Math.max(val, 0));
        const numberOfNonEmptyItem = data.filter((item) => item.value > 0).length;
        this.isEmpty = numberOfNonEmptyItem === 0;
        if (this.isEmpty) {
            return [
                {
                    color: `var(--sfui-doughnut-chart-empty-color, #ededed)`,
                    dasharray: null,
                    transform: null,
                },
            ];
        }
        const realGap = data.length > 1 ? gap : 0;
        const gapPercentage = realGap / this.perimeter;
        const drawableLength = this.perimeter - realGap * numberOfNonEmptyItem;
        let angleOffset = -90;
        return data.map((d) => {
            const value = Math.max(d.value, 0);
            const percentage = value / sum;
            const strokeLength = percentage * drawableLength;
            const strokeAnglePercentage = strokeLength / this.perimeter;
            const strokeStartAngle = angleOffset + (gapPercentage / 2) * 360;
            const strokeEndAngle = strokeStartAngle +
                (gapPercentage / 2) * 360 +
                strokeAnglePercentage * 360;
            if (value !== 0) {
                angleOffset = strokeEndAngle;
            }
            return {
                color: d.color,
                dasharray: `${strokeLength} ${this.perimeter - strokeLength}`,
                transform: this.getTransform(strokeStartAngle, graphSize),
            };
        });
    }
    onMouseenter(event, index) {
        const element = event.target;
        element.style.cursor = 'pointer';
        this.hoverIndexChange.emit(index);
    }
    onMouseleave(event) {
        const element = event.target;
        element.style.cursor = 'default';
        this.hoverIndexChange.emit(null);
    }
    onClick(index) {
        this.clickIndexChange.emit(index);
    }
    getTransform(degree, graphSize) {
        return `rotate(${degree}, ${graphSize / 2}, ${graphSize / 2})`;
    }
}
DoughnutChartGraph.ɵfac = function DoughnutChartGraph_Factory(t) { return new (t || DoughnutChartGraph)(); };
DoughnutChartGraph.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DoughnutChartGraph, selectors: [["sfui-doughnut-chart-graph"]], hostVars: 2, hostBindings: function DoughnutChartGraph_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { hoverItemIndex: "hoverItemIndex", data: "data", strokeWidth: "strokeWidth", gap: "gap" }, outputs: { hoverIndexChange: "hoverIndexChange", clickIndexChange: "clickIndexChange" }, ngContentSelectors: _c3, decls: 7, vars: 6, consts: [["xmlns", "http://www.w3.org/2000/svg", 1, "sfui-doughnut-chart-graph__doughnut"], ["cx", "50%", "cy", "50%", "fill", "none", 3, "mouseenter", "mouseleave", "click", 4, "ngFor", "ngForOf"], [1, "sfui-doughnut-chart-graph__content"], [1, "sfui-doughnut-chart-graph__content-wrapper"], ["cx", "50%", "cy", "50%", "fill", "none", 3, "mouseenter", "mouseleave", "click"]], template: function DoughnutChartGraph_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, DoughnutChartGraph__svg_circle_2_Template, 1, 6, "circle", 1);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("viewBox", ɵngcc0.ɵɵpipeBind1(1, 2, ctx.viewBox$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(3, 4, ctx.internalData$));
    } }, directives: [ɵngcc1.NgForOf], pipes: [ɵngcc1.AsyncPipe], styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-doughnut-chart-graph{display:block;width:140px;position:relative;isolation:isolate}  .sfui-doughnut-chart-graph,   .sfui-doughnut-chart-graph *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-doughnut-chart-graph.material-icons,   .sfui-doughnut-chart-graph .material-icons{font-family:Material Icons}  .sfui-doughnut-chart-graph.material-icons-outlined,   .sfui-doughnut-chart-graph .material-icons-outlined{font-family:Material Icons Outlined}  .sfui-doughnut-chart-graph__content{position:absolute;display:flex;align-items:center;justify-content:center;top:0;bottom:0;left:0;right:0;z-index:-1}"] });
DoughnutChartGraph.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    data: [{ type: Input }],
    strokeWidth: [{ type: Input }],
    gap: [{ type: Input }],
    hoverItemIndex: [{ type: Input }],
    hoverIndexChange: [{ type: Output }],
    clickIndexChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DoughnutChartGraph, [{
        type: Component,
        args: [{
                selector: 'sfui-doughnut-chart-graph',
                template: "<svg\n  class=\"sfui-doughnut-chart-graph__doughnut\"\n  [attr.viewBox]=\"viewBox$ | async\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n>\n  <circle\n    *ngFor=\"let data of internalData$ | async; let i = index\"\n    cx=\"50%\"\n    cy=\"50%\"\n    [attr.r]=\"radius\"\n    fill=\"none\"\n    [attr.opacity]=\"\n      this.isEmpty || hoverItemIndex === null || hoverItemIndex === i ? 1 : 0.4\n    \"\n    [attr.stroke]=\"data.color\"\n    [attr.stroke-width]=\"strokeWidth\"\n    [attr.stroke-dasharray]=\"data.dasharray\"\n    [attr.transform]=\"data.transform\"\n    (mouseenter)=\"onMouseenter($event, i)\"\n    (mouseleave)=\"onMouseleave($event)\"\n    (click)=\"onClick(i)\"\n  ></circle>\n</svg>\n<div class=\"sfui-doughnut-chart-graph__content\">\n  <div class=\"sfui-doughnut-chart-graph__content-wrapper\">\n    <ng-content></ng-content>\n  </div>\n</div>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-doughnut-chart-graph{display:block;width:140px;position:relative;isolation:isolate}::ng-deep .sfui-doughnut-chart-graph,::ng-deep .sfui-doughnut-chart-graph *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-doughnut-chart-graph.material-icons,::ng-deep .sfui-doughnut-chart-graph .material-icons{font-family:Material Icons}::ng-deep .sfui-doughnut-chart-graph.material-icons-outlined,::ng-deep .sfui-doughnut-chart-graph .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-doughnut-chart-graph__content{position:absolute;display:flex;align-items:center;justify-content:center;top:0;bottom:0;left:0;right:0;z-index:-1}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], hoverItemIndex: [{
            type: Input
        }], hoverIndexChange: [{
            type: Output
        }], clickIndexChange: [{
            type: Output
        }], data: [{
            type: Input
        }], strokeWidth: [{
            type: Input
        }], gap: [{
            type: Input
        }] }); })();

class CursorTooltip {
    constructor() {
        this.hostClass = ['sfui-cursor-tooltip'];
        this.tooltipHintText = '';
    }
}
CursorTooltip.ɵfac = function CursorTooltip_Factory(t) { return new (t || CursorTooltip)(); };
CursorTooltip.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CursorTooltip, selectors: [["sfui-cursor-tooltip"]], hostVars: 2, hostBindings: function CursorTooltip_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { tooltipHintText: "tooltipHintText" }, decls: 1, vars: 1, template: function CursorTooltip_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate(ctx.tooltipHintText);
    } }, styles: ["*[_ngcontent-%COMP%],   .sfui-cursor-tooltip{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-cursor-tooltip{position:absolute;box-sizing:border-box;background:rgba(0,0,0,.6);border-radius:4px;pointer-events:none;font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;white-space:pre-line;color:#fff;text-align:center;padding:4px 12px}  .sfui-cursor-tooltip,   .sfui-cursor-tooltip *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-cursor-tooltip.material-icons,   .sfui-cursor-tooltip .material-icons{font-family:Material Icons}  .sfui-cursor-tooltip.material-icons-outlined,   .sfui-cursor-tooltip .material-icons-outlined{font-family:Material Icons Outlined}"] });
CursorTooltip.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    tooltipHintText: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CursorTooltip, [{
        type: Component,
        args: [{
                selector: 'sfui-cursor-tooltip',
                template: '{{tooltipHintText}}',
                styles: ["*,::ng-deep .sfui-cursor-tooltip{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-cursor-tooltip{position:absolute;box-sizing:border-box;background:rgba(0,0,0,.6);border-radius:4px;pointer-events:none;font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;white-space:pre-line;color:#fff;text-align:center;padding:4px 12px}::ng-deep .sfui-cursor-tooltip,::ng-deep .sfui-cursor-tooltip *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-cursor-tooltip.material-icons,::ng-deep .sfui-cursor-tooltip .material-icons{font-family:Material Icons}::ng-deep .sfui-cursor-tooltip.material-icons-outlined,::ng-deep .sfui-cursor-tooltip .material-icons-outlined{font-family:Material Icons Outlined}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], tooltipHintText: [{
            type: Input
        }] }); })();

class CursorTooltipDirective {
    constructor(overlay) {
        this.overlay = overlay;
        this.tooltipHintText = '';
        this._isTooltipDisplaying = false;
        this.eventHandler = (e) => {
            this.updatePosition(e);
        };
    }
    set isTooltipDisplaying(v) {
        this._isTooltipDisplaying = v;
        if (v) {
            this.cursorTooltip = this.createOverlay(CursorTooltip);
            this.cursorTooltip.instance.tooltipHintText = this.tooltipHintText;
        }
        else {
            this.destroyOverlay();
        }
    }
    get isTooltipDisplaying() {
        return this._isTooltipDisplaying;
    }
    ngOnInit() {
        window.addEventListener('mousemove', this.eventHandler);
    }
    ngOnDestroy() {
        window.removeEventListener('mousemove', this.eventHandler);
        this.destroyOverlay();
    }
    setChannelPosition(event) {
        var _a, _b;
        const x = (_a = event === null || event === void 0 ? void 0 : event.clientX) !== null && _a !== void 0 ? _a : 0;
        const y = (_b = event === null || event === void 0 ? void 0 : event.clientY) !== null && _b !== void 0 ? _b : 0;
        return this.overlay
            .position()
            .global()
            .left(`${x + 12}px`)
            .top(`${y + 12}px`);
    }
    createOverlay(comp) {
        const config = new OverlayConfig({
            positionStrategy: this.setChannelPosition(),
        });
        this.overlayRef = this.overlay.create(config);
        const componentPortal = new ComponentPortal(comp);
        return this.overlayRef.attach(componentPortal);
    }
    updatePosition(event) {
        if (this.overlayRef) {
            this.overlayRef.updatePositionStrategy(this.setChannelPosition(event));
            this.overlayRef.updatePosition();
        }
    }
    destroyOverlay() {
        var _a;
        (_a = this.overlayRef) === null || _a === void 0 ? void 0 : _a.detach();
    }
}
CursorTooltipDirective.ɵfac = function CursorTooltipDirective_Factory(t) { return new (t || CursorTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.Overlay)); };
CursorTooltipDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CursorTooltipDirective, selectors: [["", "sfuiCursorTooltip", ""]], inputs: { tooltipHintText: "tooltipHintText", isTooltipDisplaying: "isTooltipDisplaying" } });
CursorTooltipDirective.ctorParameters = () => [
    { type: Overlay }
];
CursorTooltipDirective.propDecorators = {
    tooltipHintText: [{ type: Input }],
    isTooltipDisplaying: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CursorTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[sfuiCursorTooltip]'
            }]
    }], function () { return [{ type: ɵngcc4.Overlay }]; }, { tooltipHintText: [{
            type: Input
        }], isTooltipDisplaying: [{
            type: Input
        }] }); })();

class SfuiCursorTooltipModule {
}
SfuiCursorTooltipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiCursorTooltipModule });
SfuiCursorTooltipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiCursorTooltipModule_Factory(t) { return new (t || SfuiCursorTooltipModule)(); }, imports: [[CommonModule, OverlayModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiCursorTooltipModule, { declarations: function () { return [CursorTooltip, CursorTooltipDirective]; }, imports: function () { return [CommonModule, OverlayModule]; }, exports: function () { return [CursorTooltip, CursorTooltipDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiCursorTooltipModule, [{
        type: NgModule,
        args: [{
                declarations: [CursorTooltip, CursorTooltipDirective],
                imports: [CommonModule, OverlayModule],
                exports: [CursorTooltip, CursorTooltipDirective]
            }]
    }], null, null); })();

class SfuiDoughnutChartModule {
}
SfuiDoughnutChartModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiDoughnutChartModule });
SfuiDoughnutChartModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiDoughnutChartModule_Factory(t) { return new (t || SfuiDoughnutChartModule)(); }, imports: [[CommonModule, SfuiCursorTooltipModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiDoughnutChartModule, { declarations: function () { return [DoughnutChart, DoughnutChartGraph]; }, imports: function () { return [CommonModule, SfuiCursorTooltipModule]; }, exports: function () { return [DoughnutChart, DoughnutChartGraph]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiDoughnutChartModule, [{
        type: NgModule,
        args: [{
                declarations: [DoughnutChart, DoughnutChartGraph],
                imports: [CommonModule, SfuiCursorTooltipModule],
                exports: [DoughnutChart, DoughnutChartGraph]
            }]
    }], null, null); })();

class BarChart {
    constructor() {
        this.hostClass = ['sfui-bar-chart'];
        this._value = 0;
        this._barWidth = 0;
        this.tooltipHintText = '';
        this.tooltipPosition = new FormControl('below');
        this.isTooltipDisplaying = false;
    }
    set value(v) {
        this._value = v;
    }
    get value() {
        return this._value;
    }
    set barWidth(w) {
        // Make sure input range is between 0 and 100
        this._barWidth = Math.min(Math.max(0, w), 100);
    }
    get barWidth() {
        return this._barWidth;
    }
    onMouseenter() {
        this.isTooltipDisplaying = true;
    }
    onMouseleave() {
        this.isTooltipDisplaying = false;
    }
}
BarChart.ɵfac = function BarChart_Factory(t) { return new (t || BarChart)(); };
BarChart.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BarChart, selectors: [["sfui-bar-chart"]], hostVars: 2, hostBindings: function BarChart_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClass);
    } }, inputs: { tooltipHintText: "tooltipHintText", value: "value", barWidth: "barWidth" }, ngContentSelectors: _c3, decls: 10, vars: 5, consts: [["sfuiCursorTooltip", "", 1, "sfui-bar-chart", 3, "isTooltipDisplaying", "tooltipHintText"], [1, "sfui-bar-chart__container"], [1, "sfui-bar-chart__title-container"], [1, "sfui-bar-chart__bar-chart-container"], [1, "sfui-bar-chart__bar-chart", 3, "mouseenter", "mouseleave"], [1, "sfui-bar-chart__bar-chart-bar"], [1, "sfui-bar-chart__value-container"], [1, "sfui-bar-chart__number"]], template: function BarChart_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵlistener("mouseenter", function BarChart_Template_div_mouseenter_5_listener() { return ctx.onMouseenter(); })("mouseleave", function BarChart_Template_div_mouseleave_5_listener() { return ctx.onMouseleave(); });
        ɵngcc0.ɵɵelement(6, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("isTooltipDisplaying", ctx.isTooltipDisplaying)("tooltipHintText", ctx.tooltipHintText);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵstyleProp("width", ctx.barWidth, "%");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.value, " ");
    } }, directives: [CursorTooltipDirective], styles: ["*[_ngcontent-%COMP%]{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-bar-chart{display:block;--bar-chart-color:var(--sfui-bar-chart-color,#968c75)}  .sfui-bar-chart,   .sfui-bar-chart *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}  .sfui-bar-chart.material-icons,   .sfui-bar-chart .material-icons{font-family:Material Icons}  .sfui-bar-chart.material-icons-outlined,   .sfui-bar-chart .material-icons-outlined{font-family:Material Icons Outlined}  .sfui-bar-chart__wrapper{display:flex;flex-direction:row;justify-content:center}  .sfui-bar-chart__container{flex:1 0 0px;display:flex;flex-direction:column;justify-content:center}  .sfui-bar-chart__value-container{margin-left:12px;min-width:60px}  .sfui-bar-chart__bar-chart-container{display:flex;flex-direction:row;align-items:center}  .sfui-bar-chart__bar-chart{display:block;width:100%;height:10px;background-color:#f5f5f4;cursor:pointer}  .sfui-bar-chart__bar-chart-bar{background-color:var(--bar-chart-color);height:10px;display:block;width:6px}  .sfui-bar-chart__number{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:600;font-size:14px;line-height:24px;letter-spacing:.1px;text-align:left;color:rgba(0,0,0,.6)}  .sfui-bar-chart__title-container{display:flex;flex-direction:row;align-items:center}  .sfui-bar-chart__tooltip{white-space:pre-line;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:#fff;text-align:center;padding:4px 12px!important}"] });
BarChart.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class',] }],
    value: [{ type: Input }],
    barWidth: [{ type: Input }],
    tooltipHintText: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BarChart, [{
        type: Component,
        args: [{
                selector: 'sfui-bar-chart',
                template: "<div\n  class=\"sfui-bar-chart\"\n  sfuiCursorTooltip\n  [isTooltipDisplaying]=\"isTooltipDisplaying\"\n  [tooltipHintText]=\"tooltipHintText\"\n>\n  <div class=\"sfui-bar-chart__container\">\n    <div class=\"sfui-bar-chart__title-container\">\n      <ng-content></ng-content>\n    </div>\n    <div class=\"sfui-bar-chart__bar-chart-container\">\n      <div\n        class=\"sfui-bar-chart__bar-chart\"\n        (mouseenter)=\"onMouseenter()\"\n        (mouseleave)=\"onMouseleave()\"\n      >\n        <span\n          class=\"sfui-bar-chart__bar-chart-bar\"\n          [style.width.%]=\"barWidth\"\n        ></span>\n      </div>\n      <div class=\"sfui-bar-chart__value-container\">\n        <div class=\"sfui-bar-chart__number\">\n          {{ value }}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: ["*{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-bar-chart{display:block;--bar-chart-color:var(--sfui-bar-chart-color,#968c75)}::ng-deep .sfui-bar-chart,::ng-deep .sfui-bar-chart *{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif))}::ng-deep .sfui-bar-chart.material-icons,::ng-deep .sfui-bar-chart .material-icons{font-family:Material Icons}::ng-deep .sfui-bar-chart.material-icons-outlined,::ng-deep .sfui-bar-chart .material-icons-outlined{font-family:Material Icons Outlined}::ng-deep .sfui-bar-chart__wrapper{display:flex;flex-direction:row;justify-content:center}::ng-deep .sfui-bar-chart__container{flex:1 0 0px;display:flex;flex-direction:column;justify-content:center}::ng-deep .sfui-bar-chart__value-container{margin-left:12px;min-width:60px}::ng-deep .sfui-bar-chart__bar-chart-container{display:flex;flex-direction:row;align-items:center}::ng-deep .sfui-bar-chart__bar-chart{display:block;width:100%;height:10px;background-color:#f5f5f4;cursor:pointer}::ng-deep .sfui-bar-chart__bar-chart-bar{background-color:var(--bar-chart-color);height:10px;display:block;width:6px}::ng-deep .sfui-bar-chart__number{font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:600;font-size:14px;line-height:24px;letter-spacing:.1px;text-align:left;color:rgba(0,0,0,.6)}::ng-deep .sfui-bar-chart__title-container{display:flex;flex-direction:row;align-items:center}::ng-deep .sfui-bar-chart__tooltip{white-space:pre-line;font-family:var(--sfui-font-family,var(--ion-font-family,\"Open Sans\",sans-serif));font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.2px;color:#fff;text-align:center;padding:4px 12px!important}"]
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class']
        }], tooltipHintText: [{
            type: Input
        }], value: [{
            type: Input
        }], barWidth: [{
            type: Input
        }] }); })();

class SfuiBarChartModule {
}
SfuiBarChartModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SfuiBarChartModule });
SfuiBarChartModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SfuiBarChartModule_Factory(t) { return new (t || SfuiBarChartModule)(); }, imports: [[CommonModule, SfuiCursorTooltipModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SfuiBarChartModule, { declarations: function () { return [BarChart]; }, imports: function () { return [CommonModule, SfuiCursorTooltipModule]; }, exports: function () { return [BarChart]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SfuiBarChartModule, [{
        type: NgModule,
        args: [{
                declarations: [BarChart],
                imports: [CommonModule, SfuiCursorTooltipModule],
                exports: [BarChart]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AddTextIcon, ArrowIcon, AttachmentCustomPreview, AttachmentDOCIcon, AttachmentDefaultIcon, AttachmentDefaultPreview, AttachmentImageIcon, AttachmentImagePreview, AttachmentPDFIcon, AttachmentPDFPreview, AttachmentPDFPreviewDataSource, AttachmentPDFPreviewNetworkSource, AttachmentPreviewError, AttachmentPreviewLoading, AttachmentPreviewModalCustomPreviewComponent, AttachmentPreviewModalDefaultPreviewComponent, AttachmentPreviewModalImagePreviewComponent, AttachmentPreviewModalPdfPreviewComponent, AttachmentPreviewModalPreviewErrorComponent, BarChart, BrushIcon, Button, Card, CardHeader, CheckIcon, CloseIcon, CursorTooltip, CursorTooltipDirective, Dialog, DialogButton, DialogContent, DialogFooter, DialogHeader, DoughnutChart, DoughnutChartGraph, DownloadIcon, EditIcon, LineGraph, LineGraphData, RefreshIcon, RemoveIcon, RotateIcon, SFUI_PLATFORM, SfuiAttachmentPreviewComponentsModule, SfuiBarChartModule, SfuiButtonIcon, SfuiButtonModule, SfuiCardModule, SfuiCdkDialog, SfuiCdkOverlay, SfuiCdkOverlayContainerDirective, SfuiCdkOverlayModule, SfuiCommonDirectivesModule, SfuiCursorTooltipModule, SfuiDialogModule, SfuiDoughnutChartModule, SfuiLineGraphModule, SfuiPdfScale, SfuiResizeObserver, SfuiSnackbarModule, SfuiSuffix, SfuiSvgIconModule, SfuiThemeConsumer, SfuiThemeModule, SfuiThemeProvider, SfuiThemeService, SfuiTimelineModule, SfuiUserItemModule, Snackbar, SnackbarService, TickIcon, Timeline, TimelineGroup, UndoIcon, UserItem, UserItemAvatar, UserItemContent, UserItemDescription, UserItemName, ZoomInIcon, ZoomOutIcon, getThemeStyles, SfuiCdkOverlayContainer as ɵa };

//# sourceMappingURL=swire-frontline-ui-common.js.map